var $jscomp = {
    scope: {},
    global: this
}, Symbol;
$jscomp.initSymbol = function() {
    $jscomp.global.Symbol || (Symbol = $jscomp.Symbol);
    $jscomp.initSymbol = function() {}
}
;
$jscomp.symbolCounter_ = 0;
$jscomp.Symbol = function(u) {
    return "jscomp_symbol_" + u + $jscomp.symbolCounter_++
}
;
$jscomp.initSymbolIterator = function() {
    $jscomp.initSymbol();
    Symbol.iterator || (Symbol.iterator = Symbol("iterator"));
    $jscomp.initSymbolIterator = function() {}
}
;
$jscomp.makeIterator = function(u) {
    $jscomp.initSymbolIterator();
    if (u[Symbol.iterator])
        return u[Symbol.iterator]();
    if (!(u instanceof Array || "string" == typeof u || u instanceof String))
        throw new TypeError(u + " is not iterable");
    var q = 0;
    return {
        next: function() {
            return q == u.length ? {
                done: !0
            } : {
                done: !1,
                value: u[q++]
            }
        }
    }
}
;
$jscomp.arrayFromIterator = function(u) {
    for (var q, J = []; !(q = u.next()).done; )
        J.push(q.value);
    return J
}
;
$jscomp.arrayFromIterable = function(u) {
    return u instanceof Array ? u : $jscomp.arrayFromIterator($jscomp.makeIterator(u))
}
;
$jscomp.arrayFromArguments = function(u) {
    for (var q = [], J = 0; J < u.length; J++)
        q.push(u[J]);
    return q
}
;
$jscomp.inherits = function(u, q) {
    function J() {}
    J.prototype = q.prototype;
    u.prototype = new J;
    u.prototype.constructor = u;
    for (var Q in q)
        if ($jscomp.global.Object.defineProperties) {
            var I = $jscomp.global.Object.getOwnPropertyDescriptor(q, Q);
            void 0 !== I && $jscomp.global.Object.defineProperty(u, Q, I)
        } else
            u[Q] = q[Q]
}
;
function getSwymConfig() {
    return {
        host: "//swymstore-v3premium-01.swymrelay.com",
        assets: "//premcdn.swymrelay.com/code/"
    }
}
var __SWYM__VERSION__ = "3.117.0";
window._swat ? SwymUtils.log("Swym already loaded") : function() {
    function u(a) {
        this.storage = a.storage;
        this.sw = a;
        var b = SwymUtils.getEncodedAsObject(location.href);
        b.utm_source && -1 < b.utm_source.indexOf("swym") && (a = this.storage.get(this.sw.key.UTM),
        b = SwymUtils.getHashCode(b.utm_source),
        a != b && (this.remove(),
        this.storage.set(this.sw.key.UTM, b)));
        this.sessionId = this.getSessionId()
    }
    function q() {
        this.primaryDomain = J();
        this.canStoreLocally = Q();
        document.cookie = "__verify=1;Secure;SameSite=None";
        var a = 1 <= document.cookie.length && -1 !== document.cookie.indexOf("__verify=1");
        document.cookie = "__verify=1;Secure;SameSite=None;expires=" + (new Date(1976,8,16)).toUTCString();
        this.cookieEnabled = a
    }
    function J() {
        var a = window.location.hostname;
        if (a.search(".myshopify.com"))
            return a;
        var b = a.split(".").length
          , c = "";
        if (!/^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/.test(a) && 2 <= b) {
            for (var a = 0, b = document.domain, c = b.split("."), d = "_gd" + (new Date).getTime(); a < c.length - 1 && -1 == document.cookie.indexOf(d + "=" + d); )
                b = c.slice(-1 - ++a).join("."),
                document.cookie = d + "=" + d + ";Secure;SameSite=None;domain=" + b + ";";
            document.cookie = d + "=;Secure;SameSite=None;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=" + b + ";";
            c = b
        }
        return c
    }
    function Q() {
        if ("undefined" != typeof window.Storage)
            try {
                return window.localStorage.setItem("lstest", "lstest"),
                window.localStorage.removeItem("lstest"),
                !0
            } catch (a) {
                return !1
            }
        else
            return !1
    }
    function I(a, b, c) {
        this.cacheName = a;
        this.cacheTimestampName = this.cacheName + "_timestamp";
        this.cacheTTL = b || getSwymConfig().ttl || 300;
        this.storage = c
    }
    function y(a) {
        this.name = a.name;
        this.config = SwymUtils.extendDefaults(a, this.defaultOpts);
        for (var b in this.config)
            this[b] = this.config[b];
        this.inProgress = {};
        this.callbacks = {};
        this.evtLayer = document.createElement("Swym-model-" + this.name);
        var c = this;
        this.mcache = null;
        this.cached && (this.lcache = new I(this.name,this.expireInmem,this.swat.storage));
        var d = function() {
            c.makeCacheStale()
        };
        this.cacheStaleEvts.forEach(function(a) {
            this.swat.evtLayer.addEventListener(a, d)
        }, this)
    }
    function h() {
        this.Mustache = window.Mustache;
        this.swymHost = Ea();
        this.utils = SwymUtils;
        this.key = {
            PID: "pid",
            REMOTEAUTH: "remoteAuth",
            REGID: "swymRegid",
            MISAUTHCHK: "isCheckedForMisauth",
            INSTRMAP: "instrumentMap",
            EMAIL: "email",
            SESSIONID: "session-id",
            POSTLOGINRD: "pstlgnrd",
            UTM: "shutm",
            VERSIONCHECKED: "v-ckd",
            TURNOFF: "t-off",
            RSETCACHE: "rconfig_cache",
            RAPPSCACHE: "rapps_cache",
            EXMPTD: "b_exmptd",
            BADRID: "badrid",
            WEML: "weml",
            O_S: "o_s",
            CLCTMAP: "clctmap",
            DNFCHK: "dnfchk",
            SVD: "nf_svd",
            UPREF: "u_pref",
            TPERMTS: "tpermts",
            IGNOREAUTHCACHE: "ignach",
            TIERMISMATCH: "t_m",
            USERSETTINGS: "userSettings",
            SMSCONFIG: "sms-config",
            ABTESTING: "ab-test-config",
            MKTDENIED: "mkt-denied",
            SHARE_WISHLIST_MODAL: "share-wishlist-modal-data",
            WMLSUB: "watchlist-mailing-list-subscribed",
            RECENTLY_VIEWED_DATA: "rvd",
            RECENTLY_VIEWED_UPDATED_AT: "rvua",
            RECENTLY_VIEWED_NOTIFICATION: "rvn",
            ATW_NUDGE: "wn"
        };
        this.evtLayer = document.createElement("Swym");
        this.currentPageData = {};
        this.Storage = q;
        this.storage = new q;
        this.session = new u(this);
        this.session.setOnStart(fb(this));
        this.storage.cookieEnabled || (SwymUtils.error("Cookies Disabled", Error("CookiesDisabled")),
        this.turnOff());
        if (SwymUtils.isBot())
            console.warn("Bot detected - turning off"),
            this.turnOff();
        else {
            var a = swymModules.push
              , b = 0;
            swymModules.forEach(function(a) {
                this.loadModule(a)
            }, this);
            var c = this;
            swymModules.push = function(b) {
                c.loadModule(b);
                a.apply(c, [b])
            }
            ;
            1 == this.storage.get(this.key.IGNOREAUTHCACHE) && (this.authn.makeCacheStale(),
            this.productEts.makeCacheStale(),
            this.storage.remove(this.key.IGNOREAUTHCACHE));
            this.disableNotifications = !0;
            this.currency = null;
            this.evtLayer.addEventListener(this.JSEvents.regidRefreshed, function() {
                b++;
                5 < b || c.allGetInternal()
            });
            this.evtLayer.addEventListener(this.JSEvents.trackedPageView, function(a) {
                var b = a.detail.d.epi;
                if (b) {
                    c.api.fetch(function(b) {
                        for (var e = 0; e < b.length; e++)
                            if (b[e].epi == a.detail.d.epi)
                                return;
                        c.triggerSwymEvent(c.JSEvents.newProductTracked, a.detail.d)
                    });
                    var g = a.detail.d.uri
                      , k = (g && SwymUtils.getEncodedAsObject(g) || {})["sw-rfr"];
                    k && (b = a.detail.d.epi,
                    SwymUtils.debounce(function(a) {
                        c.instrument(c.Instrumentations.WidgetItemOpen, {
                            epi: b,
                            rfr: k
                        })
                    }, 10)())
                }
            });
            this.platform && (this.platform.isAdminMode && this.platform.isAdminMode() && (this.clearSettingsCache(),
            this.evtLayer.addEventListener(this.JSEvents.readSettings, function() {
                c.clearSettingsCache()
            })),
            this.initProductDetailsAPI())
        }
    }
    function la(a, b, c, d) {
        a.isRegistering = !1;
        var e;
        c && (b ? c != b && (e = h.JSEvents.regidRefreshed) : e = h.JSEvents.registered,
        a.set(a.key.REGID, c),
        e && (a.triggerSwymEvent(e, c),
        d && d(c)))
    }
    function Fa(a, b) {
        var c = SwymUtils.safeJSONParse(a.settings).General.RemoteConfig;
        if (c) {
            var d = window.getSwymConfig();
            c.host != d.host && (SwymUtils.warn("Tier mismatch found, contact Swym support team to address this."),
            window.getSwymConfig = function() {
                return SwymUtils.extendDefaults(c, d)
            }
            ,
            b.swymHost = Ea(),
            b.storage.get(b.key.TIERMISMATCH) || b.reportTierMismatch(function() {
                b.storage.setSessionData(b.key.TIERMISMATCH, !0)
            }, function(a) {
                SwymUtils.log("Failed to report mismatch", a)
            }))
        }
    }
    function fb(a) {
        return function() {}
    }
    function gb(a) {
        for (var b, c, d = !0, e = Object.keys(a), g = 0, k = e.length; g < k; g += 1)
            if (c = e[g],
            b = a[c],
            "cprops" === c) {
                if (800 < JSON.stringify(b).length) {
                    d = !1;
                    break
                }
            } else if ("string" === typeof b && 800 < b.length) {
                d = !1;
                break
            }
        if (!d)
            throw Error("Param value exceeded length limit. Operation not allowed.");
    }
    function Ea() {
        var a = getSwymConfig()
          , b = window.location.protocol;
        getSwymConfig().force_protocol && (b = "http:");
        return b + a.host
    }
    function Ga(a) {
        var b = 200 > a.status || 399 < a.status;
        b && SwymUtils.log("HTTP err: " + a.status + ". Msg: " + a.statusText);
        return !b
    }
    function aa(a) {
        return (a = RegExp("[?&]" + a + "=([^&]*)").exec(window.location.search)) ? decodeURIComponent(a[1].replace(/\+/g, " ")) : null
    }
    function X(a) {
        var b = window.document
          , c = {}
          , d = SwymUtils.getPageURL();
        c.uri = window.swymLandingURL || b.URL;
        c.dt = b.title;
        c.du = d;
        var d = document.querySelectorAll("li[class^=category]")
          , e = "";
        if (null != d && 0 < d.length)
            for (var g = 0; g < d.length; g++)
                e += d[g].innerText,
                e += " || ";
        c.ct = e;
        (d = aa("utm_source")) ? (e = aa("utm_medium"),
        d = "swym" == d ? "swym:" + ("tooltip" == e ? "notification" : e) : d + ":" + (e ? e : "")) : d = (d = aa("sw_rc")) ? d : "default";
        c.rc = d;
        B.retailerSettings && B.retailerSettings.General.ProductLevel && (c.type = B.retailerSettings.General.ProductLevel);
        b.referrer && (c.ru = b.referrer.substr(0, 4E3));
        a = G(a, c);
        a.hasOwnProperty("op") && (null == a.op || a.op <= a.pr) && delete a.op;
        a.ct && 200 < a.ct.length && (a.ct = a.ct.substr(0, 200).trim());
        M(a.et) && (b = a.ct,
        b = (c = a.dt) && 0 < c.length ? 1 : b && 0 < b.length ? 2 : 0,
        a.et = b);
        return a
    }
    function G(a, b) {
        a || (a = {});
        for (var c in b)
            M(a[c]) && (a[c] = b[c]);
        return a
    }
    function M(a) {
        return "undefined" == typeof a
    }
    function R(a) {
        if ("" == a)
            return a;
        var b = a;
        try {
            b = JSON.parse(a)
        } catch (c) {}
        return b
    }
    function C(a) {
        hb.push(this);
        for (var b in a)
            this[b] = a[b];
        this.target = document.querySelector(this.targetSelector);
        var c = this;
        setTimeout(function() {
            c.init()
        }, 1E3);
        this.timeoutThreshold && setTimeout(function() {
            c.init()
        }, this.timeoutThreshold)
    }
    function Ha() {
        f.retailerSettings.General.DetectIdentity && !f.isAlreadyAuth() && (new C({
            id: atob("U09VTkRFU1Q="),
            type: "jsonp",
            detectType: "email",
            targetSelector: atob("I3NvdW5kZXN0LWpzb25wLWNvbnRhaW5lcg=="),
            listenThreshold: 1,
            isValid: function() {
                return window[this.id] && window.MutationObserver && this.target
            },
            detect: function(a) {
                var b = a[atob("ZW1haWw=")];
                a = a.source;
                b && this.collect(b, a)
            }
        }),
        new C({
            id: atob("UHJpdnk="),
            type: "jsonp",
            detectType: "email",
            targetSelector: "head",
            listenThreshold: 1,
            isValid: function() {
                return window[this.id] && window.MutationObserver && this.target
            },
            detect: function(a) {
                var b = a[atob("Y3VzdG9tZXJfYXR0cmlidXRlcyU1QmVtYWlsJTVE")];
                a = a.context;
                b && this.collect(b, a)
            }
        }),
        new C({
            id: atob("UHJpdnk="),
            type: "xhrpost",
            detectType: "email",
            listenThreshold: 1,
            isValid: function() {
                return !!window[this.id]
            },
            contentType: "json",
            detect: function(a, b) {
                var c = a[atob("Y3VzdG9tZXJfYXR0cmlidXRlcw==")]
                  , c = c && c[atob("ZW1haWw=")]
                  , d = a[atob("Y29udGV4dA==")];
                c && this.collect(c, d)
            }
        }),
        new C({
            id: atob("TWFpbENoaW1w"),
            type: "form",
            detectType: "email",
            targetSelector: atob("I21jLWVtYmVkZGVkLXN1YnNjcmliZS1mb3Jt"),
            listenThreshold: 1,
            isValid: function() {
                return !!this.target
            },
            detect: SwymUtils.debounce(function(a, b) {
                var c = b.target.querySelectorAll("[type=email]")[0];
                c && this.collect(c.value, "subscribe")
            }, 1E3)
        }),
        new C({
            id: atob("U2hvcGlmeUNvbnRhY3Q="),
            type: "form",
            detectType: "email",
            targetSelector: atob("I2NvbnRhY3RfZm9ybQ=="),
            listenThreshold: 1,
            isValid: function() {
                return this.target
            },
            detect: function(a, b) {
                var c = b.target.querySelectorAll("[type=email]")[0];
                c && this.collectImmediate(c.value, "subscribe")
            }
        }),
        new C({
            id: atob("U3dlbGw="),
            type: "xhrpost",
            detectType: "email",
            listenThreshold: 1,
            isValid: function() {
                return !!window[this.id]
            },
            contentType: "json",
            detect: function(a, b) {
                var c = a[atob("ZW1haWw=")]
                  , d = a[atob("dHlwZQ==")];
                c && this.collect(c, d)
            }
        }),
        new C({
            id: atob("Wm90YWJveA=="),
            type: "xhrpost",
            detectType: "email",
            listenThreshold: 1,
            isValid: function() {
                return !!window[this.id]
            },
            contentType: "urlencoded",
            detect: function(a, b) {
                var c = a[atob("ZW1haWw=")]
                  , d = a[atob("dHlwZQ==")];
                c && this.collect(c, d)
            }
        }),
        new C({
            id: atob("dGlkaW8="),
            type: "ws",
            detectType: "email",
            listenThreshold: 1,
            isValid: function() {
                return !!window[this.id + atob("Q2hhdEFwaQ==")] && window.WebSocket
            },
            detect: function(a) {
                if (null != a && a.hasOwnProperty(atob("dXBkYXRlRGF0YQ=="))) {
                    a = a[atob("dXBkYXRlRGF0YQ==")][this.detectType];
                    var b = window[atob("dGlkaW9DaGF0Q29tcG9uZW50")][atob("c3RhdGU=")][atob("dmlldw==")];
                    this.collect(a, b)
                }
            }
        }),
        new C({
            id: atob("YmVla2V0aW5n"),
            type: "xhrget",
            detectType: "email",
            listenThreshold: 1,
            isValid: function() {
                return !!window[this.id + atob("U0RLTG9hZGVk")]
            },
            detect: function(a, b) {
                var c = -1 < b._swAction.toLowerCase().indexOf(atob("aWRlbnRpZnlfZW1haWwuanNvbg==")) && a[atob("ZW1haWw=")]
                  , d = a[atob("c3Vic2NyaWJl")];
                c && this.collect(c, atob(d ? "c3Vic2NyaWJl" : "cG9wdXA="))
            }
        }),
        new C({
            id: atob("cGl4ZWxwb3A="),
            type: "fetchpost",
            detectType: "email",
            listenThreshold: 1,
            isValid: function() {
                return !!document.querySelector('script[src*="' + this.id + '"]')
            },
            contentType: "json",
            detect: function(a, b) {
                var c = a[atob("bmV3c2xldHRlcg==")];
                c && this.collect(c, atob("cG9wdXA="))
            }
        }),
        new C({
            id: atob("d2hlZWxpbw=="),
            type: "ws",
            detectType: "email",
            listenThreshold: 1,
            isValid: function() {
                return !(!window[this.id] && !document.querySelector('script[src*="' + this.id + '"]') || !window.WebSocket)
            },
            detect: function(a) {
                null != a && a.d.b.d && (a = a.d.b.d[atob("ZW1haWw=")]) && this.collect(a, atob("cG9wdXA="))
            }
        }),
        new C({
            id: atob("c3BpbmFzYWxl"),
            type: "xhrpost",
            detectType: "email",
            listenThreshold: 1,
            isValid: function() {
                return document.querySelector('script[src*="' + this.id + '"]')
            },
            contentType: "urlencoded",
            detect: function(a, b) {
                var c = a[atob("ZW1haWw=")];
                c && this.collect(c, atob("cG9wdXA="))
            }
        }),
        new C({
            id: atob("a21haWw="),
            type: "xhrpost",
            detectType: "email",
            listenThreshold: 1,
            isValid: function() {
                return window[atob("S2xhdml5b1N1YnNjcmliZQ==")] || document.querySelector('script[src*="' + atob("a2xhdml5bw==") + '"]')
            },
            contentType: "urlencoded",
            detect: function(a, b) {
                var c = a[atob("ZW1haWw=")]
                  , d = a[atob("JHNvdXJjZQ==")];
                c && this.collect(c, d || atob("cG9wdXA="))
            }
        }),
        new C({
            id: atob("a2xhdml5bw=="),
            type: "xhrpost",
            detectType: "email",
            listenThreshold: 10,
            isValid: function() {
                return window[atob("S2xhdml5b1N1YnNjcmliZQ==")] || document.querySelector('script[src*="' + atob("a2xhdml5bw==") + '"]')
            },
            contentType: "json",
            detect: function(a, b) {
                var c = atob("JGVtYWls")
                  , c = a.properties[c]
                  , d = a[atob("JHNvdXJjZQ==")];
                c && this.collect(c, d || atob("cG9wdXA="))
            }
        }),
        new C({
            id: atob("a21haWw="),
            type: "fetchpost",
            detectType: "email",
            listenThreshold: 10,
            isValid: function() {
                return window[atob("S2xhdml5b1N1YnNjcmliZQ==")] || document.querySelector('script[src*="' + atob("a2xhdml5bw==") + '"]')
            },
            contentType: "urlencoded",
            detect: function(a, b) {
                var c = a[atob("ZW1haWw=")]
                  , d = a[atob("JHNvdXJjZQ==")];
                c && this.collect(c, d || atob("cG9wdXA="))
            }
        }),
        new C({
            id: atob("c21zYnVtcA=="),
            type: "fetchpost",
            detectType: "email",
            listenThreshold: 10,
            isValid: function() {
                return window[this.id] || document.querySelector('script[src*="' + atob("c21zYnVtcA==") + '"]')
            },
            contentType: "json",
            timeoutThreshold: 4E4,
            detect: function(a, b) {
                var c = a[atob("JGVtYWls")] || a[atob("ZW1haWw=")]
                  , d = a[atob("JHNvdXJjZQ==")];
                c && this.collect(c, d || atob("cG9wdXA="))
            }
        }),
        new C({
            id: atob("b21ldHJpYQ=="),
            type: "fetchpost",
            detectType: "email",
            listenThreshold: 10,
            isValid: function() {
                return document.querySelector('script[src*="' + atob("b21ldHJpYQ==") + '"]')
            },
            contentType: "urlencoded",
            detect: function(a, b) {
                var c = atob("dWU=")
                  , c = a[c]
                  , d = a[atob("JHNvdXJjZQ==")];
                c && this.collect(c, d || atob("cG9wdXA="))
            }
        }))
    }
    function Ia(a, b) {
        if (!(f.getApp(a) || {}).enabled)
            throw Error(a + " app is not enabled");
        var c = !0;
        b.forEach(function(a) {
            typeof a.param !== a.type && (c = !1)
        });
        if (!c)
            throw Error("Invalid arguments supplied");
    }
    function Ja(a) {
        for (var b in a) {
            var c = a[b], d;
            for (d in c) {
                var e = c[d], g;
                for (g in e) {
                    var k = e[g], l;
                    for (l in k) {
                        for (var m = k[l], p = [], f = m.length, h = 0; h < f; h++) {
                            var x = m[h];
                            "number" == typeof x ? p.push({
                                ts: x
                            }) : p.push(x)
                        }
                        k[l] = p
                    }
                }
            }
        }
        return a
    }
    function ba(a) {
        var b;
        if (null == a || "object" != typeof a)
            return a;
        if (a instanceof Date)
            return b = new Date,
            b.setTime(a.getTime()),
            b;
        if (a instanceof Array) {
            b = [];
            for (var c = 0, d = a.length; c < d; c++)
                b[c] = ba(a[c]);
            return b
        }
        if (a instanceof Object) {
            b = {};
            for (c in a)
                a.hasOwnProperty(c) && (b[c] = ba(a[c]));
            return b
        }
        throw Error("Unable to copy obj! Its type isn't supported.");
    }
    function Y(a, b) {
        b = void 0 === b ? null : b;
        return "API" + (b ? b : "") + a
    }
    function ib() {
        f.api = {
            SaveForLater: {},
            wishlist: {}
        };
        Object.keys(Ka).forEach(function(a) {
            var b = Y(a);
            f.Instrumentations[b] = Ka[a];
            jb(a)
        });
        f.shopper && Object.keys(La).forEach(function(a) {
            var b = Y(a);
            f.Instrumentations[b] = La[a];
            kb(a)
        });
        ca(lb, f.instrumentV3.bind(f));
        f.evtLayer.addEventListener(f.JSEvents.sflApiLoaded, function(a) {
            f.SaveForLater && ca(mb, f.instrumentV3.bind(f), "SaveForLater")
        });
        f.evtLayer.addEventListener(f.JSEvents.htcApiLoaded, function(a) {
            ca(nb, f.instrumentV3.bind(f))
        });
        f.wishlist && ca(ob, f.instrumentV3.bind(f), "wishlist")
    }
    function kb(a) {
        var b = f.shopper[a];
        if (b) {
            var c = Y(a);
            f.shopper[a] = function() {
                f.instrument(f.Instrumentations[c], {
                    channel: "swym-web-ui"
                });
                return b.apply(f, arguments)
            }
        } else
            SwymUtils.log(a + " function not exist, not instrumented")
    }
    function jb(a) {
        var b = f[a];
        b ? (f[a] = function() {
            var c = Y(a);
            ma.hasOwnProperty(a) ? (ma[a] || f.instrument(f.Instrumentations[c], {
                channel: "custom-js-api"
            }),
            ma[a] = !0) : f.instrument(f.Instrumentations[c], {
                channel: "custom-js-api"
            });
            return b.apply(f, arguments)
        }
        ,
        f.api[a] = function() {
            return b.apply(f, arguments)
        }
        ) : SwymUtils.log(a + " function not exist, not instrumented")
    }
    function pb() {
        if (K.xhrCallPathNames.length) {
            var a = new MutationObserver(f.injectSwymButtonOnProductGrid), b;
            K.productGridSelector && (b = document.querySelector(K.productGridSelector));
            var c = {
                childList: !0
            };
            b && a.observe(b, c)
        }
    }
    function qb() {
        var a = K.xhrCallPathNames;
        a.length && f.evtLayer.addEventListener(f.JSEvents.xhrTrap, function(b) {
            var c = b.detail.d;
            !c._swIsSWAction && a.filter(function(a) {
                return -1 < c._swAction.indexOf(a + "=")
            }).length && (c._swOnSendComplete = function() {
                setTimeout(function() {
                    f.injectSwymButtonOnProductGrid()
                }, 500)
            }
            )
        })
    }
    function rb() {
        try {
            var a = function(a) {
                var c = Object.assign({}, swymCart);
                window._swat._isSwymInstrumenting = !0;
                b("url-with-params-actions", a.currentTarget.getAttribute("href"), c)
            }
              , b = function(a, b, d, e) {
                function k(a) {
                    try {
                        -1 < a.indexOf("?") && (a = a.split("?")[1]);
                        var b = {};
                        a.split("&").forEach(function(a) {
                            a = a.split("=");
                            b[a[0]] = decodeURIComponent(a[1] || "")
                        });
                        return b
                    } catch (c) {}
                }
                var g = e && e.items && e.items.filter(function(a) {
                    return a.variant_id == h
                })
                  , l = d && d.items && d.items.filter(function(a) {
                    return a.variant_id == h
                });
                switch (a) {
                case "line-quantity-as-payload":
                    a = SwymUtils.safeJSONParse(b);
                    b = "string" == typeof a ? k(b) : a;
                    a = "object" == typeof e && "string" == typeof e.errors && 0 < e.errors.length;
                    if (null == b || "object" == typeof b && !("quantity"in b && ("line"in b || "id"in b)) || a)
                        break;
                    b.line && 0 == parseInt(b.quantity) ? f.triggerSwymEvent(f.JSEvents.storeRemovedFromCart, {
                        products: c([d.items[b.line - 1]]),
                        cartId: e.token
                    }) : b.line && 0 != parseInt(b.quantity) ? e.items[b.line - 1].quantity > d.items[b.line - 1].quantity && f.triggerSwymEvent(f.JSEvents.storeAddedToCart, {
                        products: c([e.items[b.line - 1]]),
                        cartId: e.token
                    }) : b.id && 0 == parseInt(b.quantity) ? (b.id.split(":"),
                    f.triggerSwymEvent(f.JSEvents.storeRemovedFromCart, {
                        products: c(l),
                        cartId: e.token
                    })) : b.id && 0 != parseInt(b.quantity) && (b.id.split(":"),
                    (0 != g.length && g[0].quantity) > (0 != l.length && l[0].quantity) && f.triggerSwymEvent(f.JSEvents.storeAddedToCart, {
                        products: c(g),
                        cartId: e.token
                    }));
                    break;
                case "url-with-params-actions":
                    b.match(/(?=.*\/cart\/change)(?=.*line=)(?=.*quantity=0)/) && (e = (e = /[?&]line=([^&]*)/.exec(b)) ? decodeURIComponent(e[1].replace(/\+/g, " ")) : null,
                    f.triggerSwymEvent(f.JSEvents.storeRemovedFromCart, {
                        products: c([d.items[e - 1]]),
                        cartId: swymCart.token,
                        reloadsPage: !0,
                        unpreparedProducts: [d.items[e - 1]]
                    }));
                    if (b.match(/(?=.*\/cart\/change)(?=.*id=)(?=.*quantity=0)/)) {
                        var h = (e = /[?&]id=([^&]*)/.exec(b)) ? decodeURIComponent(e[1].replace(/\+/g, " ")) : null;
                        f.triggerSwymEvent(f.JSEvents.storeRemovedFromCart, {
                            products: c([d.items.filter(function(a) {
                                return a.variant_id == h
                            })]),
                            cartId: swymCart.token,
                            reloadsPage: !0,
                            unpreparedProducts: d.items.filter(function(a) {
                                return a.variant_id == h || a.key == h
                            })
                        })
                    }
                    b.match(/(?=.*\/cart\/change)(?=.*line=)(?=.*quantity=0*[1-9][0-9]*)/) && (e = (e = /[?&]line=([^&]*)/.exec(b)) ? decodeURIComponent(e[1].replace(/\+/g, " ")) : null,
                    swymCart.items[e - 1].quantity > d.items[e - 1].quantity && f.triggerSwymEvent(f.JSEvents.storeAddedToCart, {
                        products: c([swymCart.items[e - 1]]),
                        cartId: swymCart.token
                    }));
                    b.match(/(?=.*\/cart\/change)(?=.*id=)(?=.*quantity=0*[1-9][0-9]*)/) && (h = (e = /[?&]id=([^&]*)/.exec(b)) ? decodeURIComponent(e[1].replace(/\+/g, " ")) : null,
                    null != h && f.storage.set("productCartAction", {
                        platform: "shopify",
                        epi: h,
                        type: "add"
                    }))
                }
            }
              , c = function(a) {
                var b = [];
                a.forEach(function(a) {
                    a = B.platform.transformCartItem(a);
                    b.push({
                        epi: a.epi,
                        empi: a.empi
                    })
                });
                return b
            };
            f.evtLayer.addEventListener(f.JSEvents.xhrTrap, function(a) {
                var d = a.detail.d;
                if (!d._swIsSWAction)
                    if (-1 < d._swAction.indexOf("/cart/add") && !d.isSwymUIAction) {
                        var e = Object.assign({}, swymCart);
                        d._swAddSendCallbacks(function() {
                            if (d.responseText && 200 == d.status) {
                                var a = JSON.parse(d.responseText);
                                f.triggerSwymEvent(f.JSEvents.storeAddedToCart, {
                                    products: [{
                                        epi: a.variant_id,
                                        empi: a.product_id
                                    }],
                                    cartId: swymCart.token
                                })
                            }
                        })
                    } else
                        -1 < d._swAction.indexOf("/cart/change") && !d.isSwymUIAction ? f._isSwymInstrumenting || (e = Object.assign({}, swymCart),
                        d._swAddSendCallbacks(function() {
                            null != d._swData && d.responseText ? b("line-quantity-as-payload", d._swData, e, JSON.parse(d.responseText)) : b("url-with-params-actions", d._swAction, e)
                        })) : -1 < d._swAction.indexOf("/cart/update") && !d.isSwymUIAction && (e = Object.assign({}, swymCart),
                        d._swAddSendCallbacks(function() {
                            if (200 <= d.status && 299 >= d.status) {
                                var a = JSON.parse(d.responseText);
                                if (a.items.length < e.items.length) {
                                    var b = e.items.filter(function(b) {
                                        return !a.items.includes(b)
                                    });
                                    f.triggerSwymEvent(f.JSEvents.storeRemovedFromCart, {
                                        products: c(b),
                                        cartId: a.token
                                    })
                                } else
                                    b = a.items.length == e.items.length ? e.items.filter(function(b) {
                                        return a.items.some(function(a) {
                                            return a.product_id == b.product_id && a.variant_id == b.variant_id && a.quantity > b.quantity
                                        })
                                    }) : a.items.filter(function(a) {
                                        return !e.items.includes(a)
                                    }),
                                    0 < b.length && f.triggerSwymEvent(f.JSEvents.storeAddedToCart, {
                                        products: c(b),
                                        cartId: a.token
                                    })
                            }
                        }))
            });
            f.evtLayer.addEventListener(f.JSEvents.fetchTrap, function(a) {
                var d = a.detail.d;
                if (!d._swIsSWAction)
                    if (-1 < d._swAction.indexOf("/cart/add") && !d.isSwymUIAction) {
                        var e = Object.assign({}, swymCart);
                        d._swAddSendCallbacks(function() {
                            d._swfetchReponse && d._swfetchReponse.clone().json().then(function(a) {
                                f.triggerSwymEvent(f.JSEvents.storeAddedToCart, {
                                    products: [{
                                        epi: a.variant_id,
                                        empi: a.product_id
                                    }],
                                    cartId: swymCart.token
                                })
                            })
                        })
                    } else
                        -1 < d._swAction.indexOf("/cart/change") && !d.isSwymUIAction ? f._isSwymInstrumenting || (e = Object.assign({}, swymCart),
                        d._swAddSendCallbacks(function() {
                            null != d._swData && d._swfetchReponse ? d._swfetchReponse.clone().json().then(function(a) {
                                b("line-quantity-as-payload", d._swData, e, a)
                            }) : b("url-with-params-actions", d._swAction, e)
                        })) : -1 < d._swAction.indexOf("/cart/update") && !d.isSwymUIAction && (e = Object.assign({}, swymCart),
                        d._swAddSendCallbacks(function() {
                            d._swfetchReponse && d._swfetchReponse.clone().json().then(function(a) {
                                if (a.items.length < e.items.length) {
                                    var b = e.items.filter(function(b) {
                                        return !a.items.includes(b)
                                    });
                                    f.triggerSwymEvent(f.JSEvents.storeRemovedFromCart, {
                                        products: c(b),
                                        cartId: a.token
                                    })
                                } else
                                    b = a.items.length == e.items.length ? e.items.filter(function(b) {
                                        return a.items.some(function(a) {
                                            return a.product_id == b.product_id && a.variant_id == b.variant_id && a.quantity > b.quantity
                                        })
                                    }) : a.items.filter(function(a) {
                                        return !e.items.includes(a)
                                    }),
                                    0 < b.length && f.triggerSwymEvent(f.JSEvents.storeAddedToCart, {
                                        products: c(b),
                                        cartId: a.token
                                    })
                            })
                        }))
            });
            document.addEventListener("submit", function(a) {
                a = a.target;
                if (-1 < (a.getAttribute("action") && a.getAttribute("action").indexOf("/cart/add")))
                    a = Object.values(a).reduce(function(a, b) {
                        a[b.name] = b.value;
                        return a
                    }, {}),
                    a = a.id,
                    null != a && f.storage.set("productCartAction", {
                        platform: "shopify",
                        epi: a,
                        type: "add"
                    });
                else if ("/cart" == a.getAttribute("action")) {
                    a = Object.values(a).reduce(function(a, b, c) {
                        "updates[]" == b.name ? Array.isArray(a[b.name]) ? a[b.name].push(b.value) : a[b.name] = [b.value] : a[b.name] = b.value;
                        return a
                    }, {});
                    var b = Object.assign({}, swymCart);
                    "updates[]"in a && a["updates[]"].length == b.items.length && a["updates[]"].forEach(function(a, c) {
                        var d = b.items[c];
                        a > d.quantity ? f.triggerSwymEvent(f.JSEvents.storeAddedToCart, {
                            products: [{
                                epi: d.variant_id,
                                empi: d.product_id
                            }],
                            cartId: swymCart.token
                        }) : 0 == a && f.triggerSwymEvent(f.JSEvents.storeRemovedFromCart, {
                            products: [{
                                epi: d.variant_id,
                                empi: d.product_id
                            }],
                            cartId: swymCart.token
                        })
                    })
                }
            });
            f.initCartItemRemoveButtons = function() {
                document.querySelectorAll("a[href]").forEach(function(b) {
                    -1 < b.getAttribute("href").indexOf("/cart/change") && (b.removeEventListener("click", a),
                    b.addEventListener("click", a))
                })
            }
            ;
            f.initCartItemRemoveButtons();
            var d = {
                902: {
                    selector: ".cart__page-col [data-products",
                    subtreeCheck: !0
                },
                857: {
                    selector: ".cart__page-col"
                },
                775: {
                    selector: "#CartProducts"
                }
            }
              , e = window.Shopify && window.Shopify.theme && window.Shopify.theme.theme_store_id
              , g = e && d[e] && d[e].selector || "";
            if (g) {
                var k = document.querySelector(g);
                if (k) {
                    var l = new MutationObserver(function() {
                        f.initCartItemRemoveButtons()
                    }
                    )
                      , g = {
                        childList: !0,
                        attributes: !0
                    };
                    d[e].subtreeCheck && (g.subtree = !0);
                    l.observe(k, g)
                }
            }
        } catch (m) {
            SwymUtils.warn(m)
        }
    }
    function sb() {
        f.evtLayer.addEventListener(f.JSEvents.xhrTrap, function(a) {
            a = a.detail.d;
            if (!a._swIsSWAction && a._swAction)
                if (-1 < a._swAction.indexOf("/cart/add"))
                    a._swOnSendComplete = function() {
                        if ("blob" !== this.responseType) {
                            var a;
                            if (a = "json" == this.responseType ? this.response : JSON.parse(this.responseText))
                                window.swymCart.items = window.swymCart.items.concat(a)
                        }
                        setTimeout(function() {
                            O(!0);
                            f.productEts.makeCacheStale()
                        }, 10)
                    }
                    ;
                else if (-1 < a._swAction.indexOf("/cart.js") || -1 < a._swAction.indexOf("/cart/change") || -1 < a._swAction.indexOf("/cart/update"))
                    a._swOnSendComplete = function() {
                        "blob" !== this.responseType && (window.swymCart = "json" == this.responseType ? this.response : JSON.parse(this.responseText),
                        Ma())
                    }
        })
    }
    function tb() {
        f.evtLayer.addEventListener(f.JSEvents.fetchTrap, function(a) {
            var b = a.detail.d;
            !b._swIsSWAction && b._swAction && (-1 < b._swAction.indexOf("/cart.js") || -1 < b._swAction.indexOf("/cart/change") || -1 < b._swAction.indexOf("/cart/update")) && b._swAddSendCallbacks(function() {
                b._swfetchReponse.clone().json().then(function(a) {
                    window.swymCart = a
                });
                setTimeout(function() {
                    O(!0);
                    f.productEts.makeCacheStale()
                }, 10)
            })
        })
    }
    function na(a) {
        if (a) {
            var b = a.iconText || "Wishlist";
            return SwymUtils.createElement("text" === (a.iconType || "icon") ? "<span id='swym-header-icontype-text' class='swym-header-icontype-text' aria-label='" + b + "' role='presentation'>" + b + "</span>" : "<i class='icon swym-launcher-header-icon' aria-hidden='true' role='presentation'></i>")
        }
    }
    function ub(a) {
        if (a) {
            var b = []
              , c = a.iconType || "icon"
              , d = SwymUtils.deepcopy(a);
            if ("icontext" === c || "texticon" == c) {
                d.iconType = "icon";
                var e = na(d);
                d.iconType = "text";
                d = na(d);
                "texticon" === c ? b = [d, e] : b = [e, d]
            } else
                b.push(na(a));
            a.headerCounter && b.push(SwymUtils.createElement("<span class='swym-wishlist-header-counter' aria-hidden='true' role='presentation'></span>"))
        }
        return b
    }
    function vb(a, b, c) {
        0 < a.length && SwymUtils.isElementAvailable(a) && (b ? SwymUtils.appendNode("before", c, document.querySelector(a)) : SwymUtils.appendNode("after", c, document.querySelector(a)))
    }
    function wb(a, b) {
        var c = SwymUtils.createElement("<a href='#swym-wishlist' class='swym-wishlist'></a>");
        c.id = b ? "swym-inject-header-mobile" : "swym-inject-header";
        ub(a).forEach(function(a) {
            c.appendChild(a)
        });
        return c
    }
    function Na(a, b) {
        if (a) {
            var c = wb(a.iconConfig, b)
              , d = c;
            if (a.cloneAttachSelectorElement && SwymUtils.isElementAvailable(a.attachButtonSelector))
                if (d = document.querySelector(a.attachButtonSelector).cloneNode(!1),
                d.tagName.toLowerCase() === c.tagName.toLowerCase())
                    d.classList.forEach(function(b) {
                        a.removeClasses.includes(b) || SwymUtils.addClass(c, b)
                    }),
                    d = c;
                else {
                    var e = document.querySelector(a.attachButtonSelector).cloneNode(!0)
                      , d = e.cloneNode(!1);
                    d.id = "swym-inject-header-parent";
                    (e = e.querySelector("a")) ? e.classList.forEach(function(b) {
                        a.removeClasses.includes(b) || SwymUtils.addClass(c, b)
                    }) : d = document.querySelector(a.attachButtonSelector).cloneNode(!1);
                    d.appendChild(c)
                }
            vb(a.attachButtonSelector, a.appendBefore, d);
            f.initCustomLaunchPoints()
        }
    }
    function Ma() {
        setTimeout(function() {
            f.productEts.checkAndClearCache(-10);
            f.productEts.isCacheStale() && O(!0)
        }, 10)
    }
    function Oa(a) {
        SwymUtils.onDOMReady(function() {
            oa(a)
        })
    }
    function oa(a) {
        Pa = !0;
        if (f.retailerSettings) {
            if ((K = f.retailerSettings.ProductGridButtonConfig) && (window.MutationObserver ? pb() : qb()),
            f.retailerSettings.UI.Enabled || f.retailerSettings.Wishlist.Enabled || f.retailerSettings.Watchlist.Enabled) {
                da = window.jQuery;
                var b = SwymUtils.getSWAction();
                "addtocart" == b.toLowerCase() && window.SwymProductInfo.currentVariant && f.api.replayAddToCart(a, window.SwymProductInfo.currentVariant, function() {
                    SwymUtils.log("Added to cart")
                });
                "checkout" == b.toLowerCase() && window.SwymProductInfo.currentVariant && (f.instrument(f.Instrumentations.UICheckout, {
                    epi: window.SwymProductInfo.currentVariant
                }),
                window.location = location.protocol + "//" + location.host + "/cart/" + window.SwymProductInfo.currentVariant + ":1?ref=swym-action");
                t = f.retailerSettings.Wishlist;
                if (window.SwymProductInfo && window.SwymProductInfo.product) {
                    var c = !0;
                    window.SwymProductInfo.product.tags.forEach(function(a) {
                        -1 < (t.DisallowedTags || []).indexOf(a) && (c = !1)
                    });
                    c || (t.Enabled = !1)
                }
                var d = t.Enabled
                  , b = SwymUtils.getLocalizedStrings();
                w = SwymUtils.extendDefaults(b.retailerSettingsStrings, xb[b.stringFileToLoad]);
                ea = w.WishlistAddCTA;
                pa = w.WishlistAddedCTA;
                V = !SwymUtils.isTouchDevice() && "icon" == t.ButtonType;
                t.CustomFavoriteButtonSelector && SwymUtils.forEachElement(t.CustomFavoriteButtonSelector, function(b) {
                    b.setAttribute("data-swaction", "addToWishlist");
                    b.setAttribute("data-product-id", a.empi)
                });
                SwymViewProducts[a.empi] = a;
                if (d) {
                    var b = document.querySelectorAll('[data-swaction="addToWishlist"]:not([data-with-epi])')
                      , e = document.querySelectorAll('[data-swaction="addToWishlist"][data-with-epi="true"]');
                    (0 < b.length || 0 < e.length) && f.ui.loadSecondaryStyles();
                    SwymUtils.forEachNodeElem(b, function(a) {
                        fa(a)
                    });
                    SwymUtils.forEachNodeElem(e, function(a) {
                        Qa(a)
                    })
                }
                v = f.retailerSettings.Watchlist;
                window.SwymProductInfo && window.SwymProductInfo.product && (c = !0,
                window.SwymProductInfo.product.tags.forEach(function(a) {
                    -1 < (v.DisallowedTags || []).indexOf(a) && (c = !1)
                }),
                c || (v.Enabled = !1));
                var g = v.Enabled
                  , k = w.WatchlistAddCTA
                  , b = v.OnlyStock;
                Ra = !SwymUtils.isTouchDevice() && "icon" == v.ButtonType;
                g && window.SwymWatchProducts && (e = document.querySelectorAll('[data-swaction="addToWatchlist"]'),
                0 < e.length && f.ui.loadSecondaryStyles(),
                SwymUtils.forEachNodeElem(e, function(a) {
                    qa(a)
                }),
                v.SMSEnabled && (f.storage.get("validatedUserContactNo") || f.swymApi({
                    endpoint: "/user-preference",
                    callbackFn: function(a) {
                        a && a.Mediums && f.storage.set("validatedUserContactNo", a.Mediums.sms ? a.Mediums.sms.values || [] : [])
                    },
                    v3: !0
                })));
                if (e = f.retailerSettings.General.QuickViewPlugin)
                    switch (e) {
                    case "sca":
                        var l = document.querySelectorAll(".sca-qv-optionrow input[type=submit], .sca-qv-cartbtn.sca-qv-cartbtn-config");
                        0 < l.length && window.MutationObserver && function() {
                            var a = SwymUtils.createElement("<button class='swym-sca swym-button swym-add-to-wishlist-view-product swym-add-to-wishlist-quick-view swym-" + (t.ButtonType || "") + " swym-" + (t.ButtonIcon || "") + "' data-swaction='addToWishlist' data-product-id='' aria-label='" + w.WishlistAddCTA + "'></button>");
                            l[0].insertAdjacentElement("afterend", a);
                            document.body.addEventListener("click", function(b) {
                                b = b.target || b.srcElement;
                                b.className.includes("sca-qv-button") && (b = b.getAttribute("handle") || b.getAttribute("data-handle"),
                                b = SwymViewProducts[b],
                                a.onclick = null,
                                SwymUtils.removeClass(a, "swym-loaded swym-added disabled"),
                                a.removeAttribute("data-product-id"),
                                b && (b._cv = !0,
                                b.vi = S(b),
                                P(b),
                                f.reportPageview(b),
                                a.setAttribute("data-product-id", b.empi),
                                z("addToWishList", f.EventTypes.addToWishList, a, b)))
                            })
                        }();
                        break;
                    case "fancybox.ajax":
                        e = function(a) {
                            SwymUtils.forEachElement(".swym-add-to-wishlist-view-product:not(.swym-loaded)", function(a) {
                                var b = a.getAttribute("data-product-id");
                                if (b = SwymViewProducts[b])
                                    P(b),
                                    f.reportPageview(b);
                                fa(a)
                            })
                        }
                        ;
                        $ && "3.1.20" == $.fancybox.version ? document.addEventListener("beforeShow.fb", e) : document.addEventListener("beforeshow", e);
                        break;
                    case "colorbox":
                        document.addEventListener("cbox_complete", function() {
                            SwymUtils.forEachElement(".swym-add-to-wishlist-view-product:not(.swym-loaded)", function(a) {
                                var b = SwymViewProducts[dProductId];
                                b && (P(b),
                                f.reportPageview(b));
                                fa(a)
                            })
                        })
                    }
                var m = {
                    megamenu: {
                        customJS: function() {
                            var a = document.querySelectorAll('a[href="#swym-wishlist"]');
                            SwymUtils.forEachNodeElem(a, function(a) {
                                a.parentNode.setAttribute("data-swym-display", "true")
                            })
                        },
                        customCSS: "li.buddha-disabled[data-swym-display] {display: inline-block !important;}"
                    }
                };
                (f.retailerSettings.General.ThirdPartyPlugins || []).forEach(function(a) {
                    if (a = m[a])
                        try {
                            a.customJS && a.customJS.call(a),
                            a.customCSS && SwymUtils.appendCustomCSS(a.customCSS)
                        } catch (b) {}
                });
                f.injectSwymButtonOnProductGrid();
                f.injectHeaderLaunchpointOnHeaderLazily();
                if (a.et == f.EventTypes.unknownView)
                    -1 < location.href.indexOf("/cart") && Ma();
                else if (a.et == f.EventTypes.productView) {
                    f.evtLayer.addEventListener(f.JSEvents.variantChanged, function(b) {
                        delete a.uri
                    });
                    ra = window.SwymProductInfo.product;
                    L = window.SwymProductInfo.currentVariant;
                    var p = !t.NoButtonInject, h = t.AttachButtonSelector, n = t.OoSAttachButtonSelector, x = t.CreateCustomButtonBefore, F = t.OoSCreateCustomButtonBefore, x = x ? -1 < x.indexOf(":visible") ? da(x)[0] : document.querySelector(x) : null, E = f.retailerSettings.General.ProductLevel, e = v.Position, U = !v.NoButtonInject, H = v.CreateCustomButtonBefore, H = H ? -1 < H.indexOf(":visible") ? da(H)[0] : document.querySelector(H) : null, T = t.AttachButtonSelector, h = yb(h, t.ButtonType), A;
                    if (h && -1 < h.indexOf(":visible"))
                        A = da(h || "form button[class*=cart]");
                    else {
                        A = [];
                        for (var u = [h, "form button[class*=cart]", "#add-to-cart-form #product-add-to-cart", "form#addToCartForm input[id=addToCart]", "#product-add input[type=submit]", "form button[id*=Cart]", "form input[type=submit][value*=Cart]", "form input[type=submit][value*=cart]", "form input[type=submit][value*=Add]", "form button[type=submit][name*=add]", "form button[name*=add]", "form input[type=submit][id*=cart]", "form[action='/cart/add'] > *"], h = 0; h < u.length; h++) {
                            var q = u[h]
                              , ga = q && document.querySelectorAll(q)
                              , Sa = [];
                            if (q && ga.length) {
                                for (A = 0; A < ga.length; A++)
                                    SwymUtils.isElementVisible(ga[A]) && Sa.push(ga[A]);
                                A = Sa
                            }
                            if (A.length) {
                                A = 1 < A.length ? [A[0]] : A;
                                break
                            }
                        }
                    }
                    0 == A.length && f.platform.isVariantInProductOutOfStock(window.SwymProductInfo.currentVariant, window.SwymProductInfo.product) && n && (A = document.querySelectorAll(n),
                    x = (x = F) ? document.querySelector(x) : null);
                    0 == A.length && (A = [document.body]);
                    if (1 == A.length) {
                        f.ui.loadSecondaryStyles();
                        if ((d || g) && !document.querySelector(".swym-wishlist-button-bar"))
                            if (x)
                                SwymUtils.insertBefore('<div class="swym-button-bar swym-wishlist-button-bar swym-inject"></div>', x);
                            else
                                for (h = 0,
                                n = A.length; h < n; h++)
                                    A[h].parentNode.appendChild(SwymUtils.createElement('<div class="swym-button-bar swym-wishlist-button-bar swym-inject"></div>'));
                        if (g || E == f.ProductLevels.ProductVariant) {
                            var W = window.SwymProductInfo.product
                              , ta = SwymWatchProducts[W.id] = SwymWatchProducts[W.handle] = ha(W)
                              , n = SwymUtils.getParameterByName("variant")
                              , F = document.querySelectorAll("select");
                            F.length && SwymUtils.forEachNodeElem(F, function(a) {
                                a.addEventListener("change", ua)
                            });
                            (F = document.querySelector("form[action='/cart/add']")) && F.addEventListener("change", ua);
                            n || (n = (F = document.querySelector("input[name^=id]:checked, select[name^=id], input[name=id], hidden[name^=id]", F)) && F.value || n);
                            n && ta[n] && L != n && triggerSwymVariantEvent(n)
                        }
                        a._cv = !0;
                        a.vi = S(a);
                        if (d) {
                            p && (d = SwymUtils.createElement("<button class='swym-button swym-add-to-wishlist swym-inject " + (t.EnableFaveCount ? "swym-has-fave-count" : "") + " swym-" + (t.ButtonType || "") + " swym-" + (t.ButtonIcon || "") + " " + (t.AddClasses || "") + "' onclick='event.preventDefault();' aria-label='" + ea + "'><span class='swym-wishlist-cta'>" + ea + "</span></button>"),
                            t.RemoveClasses && SwymUtils.removeClass(d, t.RemoveClasses),
                            document.querySelector(".swym-wishlist-button-bar").appendChild(SwymUtils.createElement("<div class='swym-btn-container swym-inject' data-position='default'>" + d.outerHTML + (t.EnableFaveCount ? "<span class='swym-fave-count'></span>" : "") + "</div>")),
                            z("addToWishList", f.EventTypes.addToWishList, document.querySelector(".swym-add-to-wishlist"), a),
                            f.evtLayer.addEventListener(f.JSEvents.removedFromWishlist, function() {
                                z("addToWishList", f.EventTypes.addToWishList, document.querySelector(".swym-add-to-wishlist"), a)
                            }),
                            f.evtLayer.addEventListener(f.JSEvents.removeWishlistCollection, function() {
                                z("addToWishList", f.EventTypes.addToWishList, document.querySelector(".swym-add-to-wishlist"), a)
                            }));
                            var Ta = document.querySelector(".swym-add-to-wishlist");
                            E == f.ProductLevels.ProductVariant && Ta && f.evtLayer.addEventListener(f.JSEvents.variantChanged, function(b) {
                                b = b.detail.d;
                                N = b.variant;
                                var c = a.epi;
                                a.epi = b.currentVariantId;
                                a.vi = b.variant && b.variant.title || "";
                                z("addToWishList", f.EventTypes.addToWishList, Ta, a);
                                a.epi = c
                            });
                            SwymUtils.onDOMReady(function() {
                                f.initSwymWidgets(L, a.du, a.empi)
                            })
                        }
                        if (g) {
                            f.evtLayer.addEventListener(f.JSEvents.variantChanged, function(a) {
                                a = a.detail.d;
                                N = a.variant;
                                va(a.variant, v)
                            });
                            g = T && null != document.querySelectorAll(T) || null != A && A[0] != document.body || null != H;
                            if (v.InlineForm && g)
                                document.querySelector(".swym-isa-inline-form") || (H ? SwymUtils.insertBefore('<div class="swym-isa-inline-form swym-inject"></div>', H) : (e = T ? document.querySelectorAll(T) : A,
                                SwymUtils.forEachNodeElem(e, function(a) {
                                    a.parentNode.appendChild(SwymUtils.createElement('<div class="swym-isa-inline-form swym-inject"></div>'))
                                }))),
                                SwymUtils.hideElem(document.querySelector(".swym-isa-inline-form"));
                            else if (U || !g) {
                                d = "<button class='swym-button swym-add-to-watchlist swym-inject product_" + a.empi + " swym-" + (v.ButtonType || "") + " swym-" + (v.ButtonIcon || "") + " " + (v.AddClasses || "");
                                2 == v.UIVersion && (d += " swym-sbisa-v2");
                                d = SwymUtils.createElement(d + ("' style='display: none;' data-swaction=\"addToWatchlist\" onclick='event.preventDefault();' aria-label='" + k + "'><span class='swym-watchlist-cta'>" + k + "</span></button>"));
                                v.RemoveClasses && SwymUtils.removeClass(d, v.RemoveClasses);
                                if (v.UseSeparateContainer) {
                                    if (!document.querySelector(".swym-isa-button-bar"))
                                        if (H)
                                            SwymUtils.insertBefore('<div class="swym-button-bar swym-isa-button-bar swym-inject"></div>', H);
                                        else
                                            for (k = T ? document.querySelectorAll(T) : [],
                                            h = 0,
                                            n = k.length || A.length; h < n; h++)
                                                (0 < k.length ? k[h] : A[h]).parentNode.appendChild(SwymUtils.createElement('<div class="swym-button-bar swym-isa-button-bar swym-inject"></div>'));
                                    document.querySelector(".swym-isa-button-bar").appendChild(SwymUtils.createElement("<div class='swym-btn-container swym-inject' data-position='" + e + "'>" + d.outerHTML + "</div>"))
                                } else
                                    k = document.querySelector(".swym-wishlist-button-bar,.swym-button-bar"),
                                    k.appendChild(SwymUtils.createElement("<div class='swym-btn-container swym-inject' data-position='" + e + "'data-fallbacktofloating='" + !g + "'>" + d.outerHTML + "</div>")),
                                    SwymUtils.addClass(k, "swym-isa-button-bar");
                                d = document.querySelector(".swym-isa-button-bar .swym-add-to-watchlist") || document.querySelector(".swym-wishlist-button-bar .swym-add-to-watchlist");
                                ia();
                                k = SwymUtils.getParameterByName("variant");
                                g = SwymUtils.deepcopy(a);
                                k && k != a.epi && (U = SwymProductVariants[k],
                                g.epi = k,
                                g.iu = U.iu,
                                g.pr = U.pr,
                                g.stk = U.stk,
                                g.variants = U.variants);
                                z("addToWatchList", f.EventTypes.watchlist, d, g);
                                zb(document.querySelector(".swym-add-to-watchlist"), e)
                            }
                            b ? (f.evtLayer.addEventListener(f.JSEvents.variantChanged, function(a) {
                                a = a.detail.d;
                                N = a.variant;
                                ja(a.product.id, a.variant, null, a.product)
                            }),
                            ja(W.id, ta[L], null, W)) : (SwymUtils.showElem(document.querySelector(".product_" + W.id + '[data-swaction="addToWatchlist"]')),
                            wa());
                            va(ta[L], v)
                        }
                    } else
                        try {
                            SwymUtils.error("No add to cart found - " + window.Shopify.theme.name, {}, window.Shopify.theme)
                        } catch (Mb) {}
                }
            }
        } else
            f.evtLayer.addEventListener(f.JSEvents.configLoaded, function(b) {
                oa(a)
            })
    }
    function xa(a) {
        SwymUtils.forEachElement(".product_" + a.empi + '[data-swaction="addToWishlist"]:not(.swym-added)[data-variant-id="' + a.epi + '"],' + (L == a.epi ? ".swym-add-to-wishlist" : ".swym-add-to-wishlist:not(.swym-inject)"), function(a) {
            Z(a)
        })
    }
    function Ab(a, b, c) {
        a = ".product_" + a.empi + '[data-swaction="addToWishlist"][data-variant-id="' + a.epi + '"], ' + (t.EnableCollections && SwymProductInfo && SwymProductInfo.product && SwymProductInfo.product.id == a.empi ? b ? ".swym-add-to-wishlist:not(.swym-inject)" : ".swym-add-to-wishlist" : L == a.epi ? ".swym-add-to-wishlist" : ".swym-add-to-wishlist:not(.swym-inject)");
        1 < document.querySelectorAll(a).length ? Ua(c) : SwymUtils.forEachElement(a, function(a) {
            Ua(a)
        })
    }
    function ia() {
        var a = document.querySelector(v.UseSeparateContainer ? ".swym-isa-button-bar" : ".swym-button-bar");
        a && !a.querySelector(".swym-add-to-wishlist") && SwymUtils.addClass(a, "swym-bbar-nomargin")
    }
    function wa() {
        var a = document.querySelector(v.UseSeparateContainer ? ".swym-isa-button-bar" : ".swym-button-bar");
        a && !a.querySelector(".swym-add-to-wishlist") && SwymUtils.removeClass(a, "swym-bbar-nomargin")
    }
    function fa(a) {
        var b = a.getAttribute("data-product-id")
          , c = a.getAttribute("data-swaction")
          , d = a.getAttribute("data-swnostyle")
          , b = SwymViewProducts[b];
        "addtowishlist" == c.toLowerCase() && b && (P(b),
        b._cv = !0,
        b.vi = S(b),
        d || SwymUtils.addClass(a, "swym-" + (t.ButtonType || "") + " swym-" + (t.ButtonIcon || "")),
        z("addToWishList", f.EventTypes.addToWishList, a, b))
    }
    function Qa(a) {
        var b = a.getAttribute("data-product-id")
          , c = a.getAttribute("data-variant-id")
          , d = a.getAttribute("data-swaction")
          , e = a.getAttribute("data-swnostyle")
          , g = a.getAttribute("data-product-url");
        if (!g)
            throw Error("No data-product-url set on element", a);
        var k = f.retailerSettings.General.ProductLevel
          , l = {
            epi: parseInt(c),
            empi: parseInt(b),
            type: k,
            du: g,
            _fv: !0
        };
        "addtowishlist" == d.toLowerCase() && l && (e || SwymUtils.addClass(a, "swym-" + (t.ButtonType || "") + " swym-" + (t.ButtonIcon || "")),
        k == f.ProductLevels.ProductVariant ? (z("addToWishList", f.EventTypes.addToWishList, a, l),
        window.SwymProductInfo && window.SwymProductInfo.product && l.empi == window.SwymProductInfo.product.id && f.evtLayer.addEventListener(f.JSEvents.variantChanged, function(b) {
            l.epi = b.detail.d.variant.id;
            a.setAttribute("data-variant-id", l.epi);
            z("addToWishList", f.EventTypes.addToWishList, a, l)
        })) : z("addToWishList", f.EventTypes.addToWishList, a, l),
        f.evtLayer.addEventListener(f.JSEvents.removedFromWishlist, function() {
            z("addToWishList", f.EventTypes.addToWishList, a, l)
        }),
        f.evtLayer.addEventListener(f.JSEvents.removeWishlistCollection, function() {
            z("addToWishList", f.EventTypes.addToWishList, a, l)
        }))
    }
    function qa(a, b, c) {
        var d = a.getAttribute("data-product-id")
          , e = a.getAttribute("data-swaction")
          , g = a.getAttribute("data-swnostyle")
          , k = window.SwymProductVariants[b] || window.SwymViewProducts[d]
          , l = window.SwymWatchProducts[d];
        "addtowatchlist" == e.toLowerCase() && k && l && (P(k),
        g || SwymUtils.addClass(a, "swym-" + (v.ButtonType || "") + " swym-" + (v.ButtonIcon || "")),
        c || Bb(d, b || k.epi, l, window.SwymProductInfo.product))
    }
    function Bb(a, b, c, d) {
        var e = c[b], g;
        if (f.platform.isInventorySetUpCorrectly(e)) {
            if (v.ShowOnCollectionsIfAllOOS)
                for (var k in c)
                    if (c.hasOwnProperty(k) && (g = c[k],
                    !f.platform.isVariantOOS(g))) {
                        SwymUtils.hideElem(document.querySelector(".product_" + a + '[data-swaction="addToWatchlist"]'));
                        ia();
                        return
                    }
            SwymUtils.forEachElement(".product_" + a + '[data-swaction="addToWatchlist"]', function(c) {
                var d = SwymProductVariants[b] || SwymViewProducts[a];
                d._cv = !0;
                d.vi = S(d);
                d.epi = b;
                z("addToWatchList", f.EventTypes.watchlist, c, d)
            });
            ja(a, e, !0, d)
        } else
            SwymUtils.hideElem(document.querySelector(".product_" + a + '[data-swaction="addToWatchlist"]')),
            ia(),
            SwymUtils.warn("Inventory management not setup");
        va(e, v)
    }
    function ja(a, b, c, d) {
        var e = ".product_" + a + '[data-swaction="addToWatchlist"]', g, k;
        v.ComingSoonFeatureEnabled && (d && b && void 0 != d.variants.find(function(a) {
            return b.id == a.id
        }) && (k = f.platform.isTagAvailable(v.ComingSoonTags || ["swym-comingsoon"], d)),
        g = !v.HideIfComingSoonInstock && k);
        if (!f.platform.isVariantOOS(b) && g || f.platform.isVariantOOS(b) && k && v.PreferComingSoonTopicOnOOS)
            d = e && document.querySelector(e),
            null != d && (d.querySelector(".swym-watchlist-cta").innerText = f.retailerSettings.Strings.ComingSoonAddCTA,
            d.setAttribute("aria-label", f.retailerSettings.Strings.ComingSoonAddCTA));
        if (f.platform.isInventorySetUpCorrectly(b))
            if (v.ShowIfOneOOS) {
                a = window.SwymWatchProducts[a] || {};
                for (var l in a)
                    if (a.hasOwnProperty(l) && f.platform.isVariantOOS(a[l])) {
                        if (d = document.querySelector(e))
                            SwymUtils.showElem(d),
                            wa();
                        break
                    }
            } else if (f.platform.isVariantOOS(b) || g) {
                if (d = document.querySelector(e))
                    SwymUtils.showElem(d),
                    d.setAttribute("data-variant-id", b.id),
                    wa();
                e = document.querySelectorAll(e);
                l = 0;
                for (g = e.length; l < g; l++)
                    d = e[l],
                    qa.apply(d, [d, b.id, !0]);
                c || (c = document.querySelector(".swym-isa-inline-form"),
                v.InlineForm && null != c && (a = SwymProductVariants[b.id] || SwymViewProducts[a],
                a = JSON.parse(JSON.stringify(a)),
                a.epi = b.id,
                f.api.addToWatchList({
                    isInternal: !0
                }, a, null, c),
                SwymUtils.showElem(c)))
            } else
                SwymUtils.forEachElement(".product_" + a + '[data-swaction="addToWatchlist"]', function(a) {
                    SwymUtils.hideElem(a)
                }),
                ia(),
                c || v.InlineForm && SwymUtils.hideElem(document.querySelector(".swym-isa-inline-form"));
        else
            SwymUtils.hideElem(document.querySelector(".product_" + a + '[data-swaction="addToWatchlist"]')),
            c || v.InlineForm && SwymUtils.hideElem(document.querySelector(".swym-isa-inline-form")),
            SwymUtils.warn("Inventory management not setup");
        f.SwymShopifyCurrentVariant = b
    }
    function ka(a) {
        var b = {}
          , c = a.variants[0];
        b.dt = a.title;
        b.empi = a.id;
        b.epi = a.variants[0].id;
        b.pr = a.price / 100;
        b.op = a.compare_at_price / 100;
        b.iu = a.featured_image;
        a.url ? b.du = window.location.origin + a.url : a.handle && (b.du = window.location.origin + "/products/" + a.handle);
        var d = {};
        d[c.title] = c.id;
        b.variants = [d];
        b.vi = "Default Title" !== c.title ? c.title : "";
        a.variants.forEach(Cb, a);
        return P(b)
    }
    function Cb(a) {
        var b = {};
        b.dt = a.title;
        b.empi = this.id;
        b.epi = a.id;
        b.pr = a.price / 100;
        b.op = a.compare_at_price / 100;
        b.iu = a.featured_image ? a.featured_image.src || a.featured_image : this.featured_image;
        this.url ? b.du = window.location.origin + this.url + "?variant=" + a.id : this.handle && (b.du = window.location.origin + "/products/" + this.handle + "?variant=" + a.id);
        var c = {};
        c[a.title] = a.id;
        b.variants = [c];
        b._cv = !0;
        b.vi = "Default Title" !== a.title ? a.title : "";
        SwymProductVariants[a.id] = b
    }
    function ha(a) {
        var b = {};
        a.variants.forEach(function(a) {
            SwymWatchProducts[a.id] = b[a.id] = {
                id: a.id,
                available: a.available,
                inventory_management: a.inventory_management,
                inventory_quantity: a.inventory_quantity,
                inventory_policy: a.inventory_policy,
                title: a.title
            }
        });
        return b
    }
    function ya(a, b) {
        var c = a ? a.querySelector('[data-swaction="addToWishlist"]:not(.swym-loaded)') : null;
        if (K && f.retailerSettings.Wishlist.ProductGridButton && c) {
            var d = function(b) {
                b = b.detail.d;
                b.du ? (b = e(b, m),
                b.productHandleRegex.test(b.duWithoutVariant) && (SwymUtils.removeClass(c, "swym-loaded"),
                ya(a, !0))) : (SwymUtils.removeClass(c, "swym-loaded"),
                ya(a, !0))
            }
              , e = function(a, b) {
                var c = a.du.split("?")[0]
                  , d = new RegExp(b + "$");
                return {
                    duWithoutVariant: decodeURI(c) === c ? encodeURI(c) : c,
                    productHandleRegex: d
                }
            }
              , g = function() {
                SwymUtils.addClass(c, "swym-added disabled swym-loaded");
                c.setAttribute("aria-label", w.WishlistAddedCTA);
                c.onclick = f.retailerSettings.Wishlist.EnableCollections ? k : function(a) {
                    f.retailerSettings.Wishlist.AllowToggle ? f.api.getProductDetails(p, function(a) {
                        a = ka(a);
                        f.api.removeFromWishList(a, function(a) {
                            a && (SwymUtils.removeClass(c, "swym-added disabled"),
                            c.setAttribute("aria-label", w.WishlistAddCTA),
                            c.onclick = k)
                        })
                    }) : a.preventDefault()
                }
            }
              , k = function() {
                var a = function(a) {
                    a && g()
                };
                f.api.getProductDetails(p, function(b) {
                    b = ka(b);
                    f.ui.performAddToWishlist(b, a, function() {})
                })
            }
              , l = a.querySelector(K.productUrlSelector).href
              , m = l.slice(l.indexOf("/products/"), l.length).split("?")[0]
              , p = {
                du: m
            };
            f.api.fetch(function(a) {
                c.setAttribute("style", "display: inline-block");
                a.filter(function(a) {
                    var b = e(a, m);
                    return b.productHandleRegex.test(b.duWithoutVariant) && 4 === a.et
                }).length ? g() : (c.onclick = k,
                SwymUtils.addClass(c, "swym-loaded"),
                SwymUtils.removeClass(c, "swym-added disabled"))
            });
            b || (f.evtLayer.addEventListener(f.JSEvents.removedFromWishlist, function(a) {
                d(a)
            }),
            f.evtLayer.addEventListener(f.JSEvents.removeWishlistCollection, function(a) {
                d(a)
            }))
        }
    }
    function Db(a) {
        var b = a ? a.querySelector('[data-swaction="addToWatchlist"]:not(.swym-loaded)') : null;
        if (K && f.retailerSettings.Watchlist.ProductGridButton && b) {
            a = a.querySelector(K.productUrlSelector).href;
            var c = {
                du: a.slice(a.indexOf("/products/"), a.length).split("?")[0]
            };
            SwymUtils.addClass(b, "swym-loaded");
            b.onclick = function(a) {
                f.api.getProductDetails(c, function(b) {
                    b = ka(b);
                    f.api.addToWatchList(Object.assign(a, {
                        isInternal: !0
                    }), b, function(a) {
                        SwymUtils.log("Added item to watchlist.")
                    })
                })
            }
        }
    }
    function va(a, b) {
        var c = b.Topics.indexOf(Va);
        1 > a.inventory_quantity ? -1 == c && b.Topics.unshift(Va) : -1 != c && b.Topics.splice(c, 1)
    }
    function P(a) {
        ["pr", "op"].forEach(function(b) {
            if (!SwymUtils.isUndefined(a[b])) {
                var c = SwymUtils.removeComma(a[b]);
                a[b] != c && (a[b] = Shopify.formatMoney ? SwymUtils.removeComma(Wa(c, "{{amount}}")) : c)
            }
        });
        return a
    }
    function Eb(a) {
        var b = [{}]
          , c = {};
        "object" !== typeof a || Array.isArray(a) || null === a || (b[0][a.variant_id] = a.variant_title,
        c = {
            epi: a.variant_id,
            empi: a.product_id,
            du: window.location.origin + "/" + a.url,
            dt: a.title,
            iu: SwymUtils.wrapUrlWithHTTPS(a.image),
            pr: (a.original_price || a.price) / 100,
            variants: b
        },
        window.SwymProductVariants = window.SwymProductVariants || {},
        window.SwymProductVariants[c.epi] = c);
        return c
    }
    function Wa(a, b) {
        function c(a, b, c, d) {
            if (b = "undefined" == typeof b ? 2 : b,
            c = "undefined" == typeof c ? "," : c,
            d = "undefined" == typeof d ? "." : d,
            isNaN(a) || null == a)
                return 0;
            a = (a / 100).toFixed(b);
            a = a.split(".");
            return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + c) + (a[1] ? d + a[1] : "")
        }
        "string" == typeof a && (a = a.replace(".", ""));
        var d = ""
          , e = /\{\{\s*(\w+)\s*\}\}/
          , g = b || this.money_format;
        switch (g.match(e)[1]) {
        case "amount":
            d = c(a, 2);
            break;
        case "amount_no_decimals":
            d = c(a, 0);
            break;
        case "amount_with_comma_separator":
            d = c(a, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            d = c(a, 0, ".", ",");
            break;
        case "amount_with_apostrophe_separator":
            d = c(a, 2, "'", ".");
            break;
        case "amount_no_decimals_with_space_separator":
            d = c(a, 0, " ");
            break;
        case "amount_with_space_separator":
            d = c(a, 2, " ", ",");
            break;
        case "amount_with_period_and_space_separator":
            d = c(a, 2, " ", ".")
        }
        return g.replace(e, d)
    }
    function Fb(a, b) {
        if (b) {
            var c = JSON.parse(JSON.stringify(b));
            c._cv = !0;
            c.vi = S(c);
            a.onclick = function(d) {
                d.preventDefault();
                Xa(a, b, !1);
                f.api.removeFromWishList(c, function(b) {
                    setTimeout(function() {
                        z("addToWishList", f.EventTypes.addToWishList, a, c)
                    }, 300)
                })
            }
        }
    }
    function S(a) {
        return a.vi ? "Default Title" !== a.vi ? a.vi : "" : a.variants && a.variants[0] ? (a = Object.keys(a.variants[0]),
        a[0] && "Default Title" !== a[0] ? a[0] : "") : ""
    }
    function Ya(a, b) {
        var c = a.epi, d, e = window.SwymProductInfo.product;
        if (e)
            for (var e = e.variants, g = 0; g < e.length; g++)
                if (e[g].id == c) {
                    d = e[g].price / 100;
                    break
                }
        d || (d = b.getAttribute("data-product-id"),
        e = window.SwymProductVariants[c] || window.SwymViewProducts[d] || a,
        d = e.pr);
        return d || a.pr || 0
    }
    function z(a, b, c, d, e) {
        function g() {
            var a = c ? c.querySelectorAll(".swym-tooltip") : [];
            SwymUtils.forEachNodeElem(a, function(a) {
                a.parentNode.removeChild(a)
            })
        }
        var k = JSON.parse(JSON.stringify(d));
        SwymUtils.getPageURLAsLocation();
        var l = SwymUtils.getSWAction(), m = f.retailerSettings.General.ProductLevel, p, h = "";
        "addToWishList" == a ? (h = w.WishlistAddCTA,
        V && (g(),
        c.querySelector(".swym-tooltip") || (c.appendChild(SwymUtils.createElement("<span class='swym-tooltip'><span class='swym-tooltip-text'>" + w.WishlistTooltipBefore + "</span></span>")),
        c.addEventListener("mouseover", function() {
            SwymUtils.addClass(this, "show-tooltip")
        }),
        c.addEventListener("mouseout", function() {
            SwymUtils.removeClass(this, "show-tooltip")
        })))) : (h = w.WatchlistAddCTA,
        Ra && (g(),
        c.querySelector(".swym-tooltip") || (c.appendChild(SwymUtils.createElement("<span class='swym-tooltip'><span class='swym-tooltip-text'>" + w.WatchlistTooltip + "</span></span>")),
        c.addEventListener("mouseover", function() {
            SwymUtils.addClass(this, "show-tooltip")
        }),
        c.addEventListener("mouseout", function() {
            SwymUtils.removeClass(this, "show-tooltip")
        }))));
        f.api.fetch(function(g) {
            g = g.filter(m == f.ProductLevels.ProductVariant ? function(a) {
                return k.empi == a.empi && a.epi == k.epi
            }
            : function(a) {
                return k.empi == a.empi
            }
            );
            var x = "addToWishList" == a;
            (x ? t.EnableCollections || 0 == g.length : 1) ? (x && (Ab(k, 0 < g.length, c),
            t.EnableCollections && 0 < g.length && Z(c, !0, k)),
            l == a.toLowerCase() ? (k.et = b,
            "addToWatchList" == a ? (g = SwymUtils.getParameterByName("email")) ? (f.retailerSettings.UI.DisableOOSFormEmailPrefill || f.storage.set(f.key.WEML, g),
            f.api[a]({
                isInternal: !0
            }, k, function(a) {
                a && (SwymUtils.log("Item was successfully auto added to Watchlist"),
                e && e(k))
            }),
            document.getElementById("swym-remind-email-auth-button").click()) : SwymUtils.warn("Unable to get email for swaction") : (k.type = m,
            f.ui.performAddToWishlist(k, function(b) {
                SwymUtils.log("Item was auto added: " + a);
                xa(k);
                e && e(k)
            }, function() {
                setTimeout(function() {
                    z(a, b, c, k, e)
                }, 300)
            }),
            Z(c, !0, k),
            xa(k))) : c.onclick = function(c) {
                c.preventDefault();
                c.stopImmediatePropagation();
                var g = !!c.target.getAttribute("data-with-epi");
                if (N && !g) {
                    k.variants = [];
                    var g = {}, l;
                    N.name ? l = N.name : N.title && (l = N.title);
                    g[l] = N.id;
                    k.epi = N.id;
                    k.variants.push(g)
                }
                k.et = b;
                var h = this;
                "addToWatchList" == a ? (k.pr = Ya(k, h),
                window.SwymProductVariants && SwymProductVariants[k.epi] && (k.iu = SwymProductVariants[k.epi].iu),
                f.api[a](Object.assign(c, {
                    isInternal: !0
                }), k, function(a) {
                    a && (SwymUtils.log("Successfully Opened the Pop up"),
                    e && e(k))
                })) : (t.EnableCollections || Xa(h, k, !0),
                k.type = m,
                k.type == f.ProductLevels.ProductVariant && d.et == f.EventTypes.productView && (p = S(k),
                k.pr = Ya(k, h),
                k.vi = p,
                "addToWishList" == a && 4 == b && 1 == window.SwymPageData.et && (k.source = f.wishlistSources.pdp),
                SwymProductVariants[k.epi] && (k.iu = SwymProductVariants[k.epi].iu)),
                f.ui.performAddToWishlist(k, function(a, b) {
                    if (t.EnableCollections && b)
                        SwymUtils.removeClass(h, "swym-added"),
                        SwymUtils.log("Item was successfully removed from Wishlist");
                    else {
                        Z(h, !0, k);
                        xa(k);
                        var c = h.querySelector(".swym-wishlist-cta");
                        c && h.setAttribute("aria-label", c.innerHTML);
                        SwymUtils.log("Item was successfully added to Wishlist")
                    }
                    e && e(k)
                }, function() {
                    setTimeout(function() {
                        z(a, b, h, k, e)
                    }, 300)
                }))
            }
            ) : (Z(c, !0, k),
            h = w.WishlistAddedCTA);
            SwymUtils.addClass(c, "swym-loaded");
            c.setAttribute("aria-label", h)
        })
    }
    function Z(a, b, c) {
        b = t.AllowToggle;
        var d = w.WishlistTooltipAfter;
        t.EnableCollections ? (SwymUtils.addClass(a, "swym-added swym-loaded"),
        a = document.querySelectorAll(".swym-fave-count"),
        SwymUtils.forEachNodeElem(a, function(a) {
            SwymUtils.addClass(a, "swym-added")
        })) : (b ? (Fb(a, c),
        c = document.querySelectorAll(".swym-wishlist-cta"),
        SwymUtils.forEachNodeElem(c, function(a) {
            a.innerHTML = SwymUtils.renderTemplateString(pa, {})
        }),
        V && (c = a ? a.querySelectorAll(".swym-tooltip") : [],
        SwymUtils.forEachNodeElem(c, function(a) {
            a = a.querySelectorAll(".swym-tooltip-text");
            SwymUtils.forEachNodeElem(a, function(a) {
                a.innerHTML = SwymUtils.renderTemplateString(w.WishlistTooltipAfter, {})
            })
        }))) : (a.onclick = function(a) {
            a.preventDefault();
            V && SwymUtils.toggleClass(a.currentTarget, "show-tooltip")
        }
        ,
        c = a ? a.querySelectorAll(".swym-wishlist-cta") : [],
        SwymUtils.forEachNodeElem(c, function(a) {
            a.innerHTML = SwymUtils.renderTemplateString(pa, {})
        }),
        V && (c = a ? a.querySelectorAll(".swym-tooltip") : [],
        SwymUtils.forEachNodeElem(c, function(a) {
            function b(a) {
                a.preventDefault();
                a.stopPropagation();
                f.ui.open(f.Instrumentations.UIOpenFromTooltip)
            }
            var c = a.querySelectorAll(".swym-tooltip-text");
            SwymUtils.forEachNodeElem(c, function(a) {
                a.innerHTML = SwymUtils.renderTemplateString(d, {})
            });
            c = a.querySelectorAll("a,.swym-open-ui");
            if (c.length) {
                a = 0;
                for (var l = c.length; a < l; a++)
                    c[a].className += " swym-tooltip-clickable",
                    c[a].onclick = b
            } else
                SwymUtils.addClass(a, "swym-tooltip-clickable"),
                a.onclick = b
        }))),
        SwymUtils.addClass(a, "disabled swym-added swym-loaded"),
        a = document.querySelectorAll(".swym-fave-count"),
        SwymUtils.forEachNodeElem(a, function(a) {
            SwymUtils.addClass(a, "disabled swym-added")
        }))
    }
    function Xa(a, b, c) {
        a.onclick = function(a) {
            a.preventDefault()
        }
        ;
        SwymUtils.addClass(a, "disabled swym-added" + (c ? " swym-adding" : " swym-removing"));
        a = a ? a.querySelectorAll(".swym-fave-count") : [];
        SwymUtils.forEachNodeElem(a, function(a) {
            SwymUtils.addClass(a, "disabled swym-added swym-adding")
        })
    }
    function Ua(a) {
        SwymUtils.removeClass(a, "disabled swym-added swym-adding swym-removing");
        var b = a ? a.querySelectorAll(".swym-fave-count") : [];
        SwymUtils.forEachNodeElem(b, function(a) {
            SwymUtils.removeClass(a, "disabled swym-added swym-adding")
        });
        b = a ? a.querySelectorAll(".swym-wishlist-cta") : [];
        SwymUtils.forEachNodeElem(b, function(a) {
            a.innerHTML = SwymUtils.renderTemplateString(ea, {})
        });
        if (V) {
            var c = w.WishlistTooltipBefore;
            a = a ? a.querySelectorAll(".swym-tooltip") : [];
            SwymUtils.forEachNodeElem(a, function(a) {
                function b(a) {
                    a.preventDefault();
                    a.stopPropagation();
                    f.ui.open(f.Instrumentations.UIOpenFromTooltip)
                }
                var g = a.querySelectorAll(".swym-tooltip-text");
                SwymUtils.forEachNodeElem(g, function(a) {
                    a.innerHTML = SwymUtils.renderTemplateString(c, {})
                });
                g = a.querySelectorAll("a,.swym-open-ui");
                if (g.length)
                    for (var k = 0, l = g.length; k < l; k++)
                        g[k].className += " swym-tooltip-clickable",
                        g[k].onclick = b;
                else
                    SwymUtils.addClass(a, "swym-tooltip-clickable"),
                    a.onclick = b;
                a = a.querySelectorAll("a,.swym-open-ui");
                SwymUtils.forEachNodeElem(a, function(a) {
                    a.parentNode.removeChild(a)
                })
            })
        }
    }
    function O(a) {
        if (f.getApps()) {
            var b = window.swymCart.token;
            f.getRetailerConfig("ShopId");
            var c = {};
            Gb.forEach(function(a) {
                c[a] = f.storage.getRaw(a)
            });
            c["swym-session-id"] || (c["swym-session-id"] = f.session.getSessionId());
            c.cart && (c.cart = c.cart.split(",")[0]);
            !c.cart && 0 < window.swymCart.item_count && (c.cart = b);
            c.cart && c.cart != f.get("ol_ct") ? f.retailerSettings.General.AddCartAttributes && (f.get("ol_ct"),
            f.storage.setSessionData("ol_ct", b),
            c.userAgent = window.navigator.userAgent,
            c.origin = window.origin,
            SwymUtils.ajaxOpt({
                url: "/cart/update.js",
                method: "POST",
                data: SwymUtils.getObjectAsEncodedNested({
                    attributes: {
                        swymAttrs: JSON.stringify(c)
                    }
                })
            })) : a || za()
        } else
            f.evtLayer.addEventListener(f.JSEvents.configLoaded, function() {
                O(a)
            })
    }
    function Za(a, b) {
        $a++;
        5 < $a || (a && f.productEts.makeCacheStale(),
        f.holdCallbacks(),
        f.validateUserLogin("shopify", parseInt(window.swymCustomerId), function() {
            O(!0);
            f.continueCallbacks();
            b && b("customer refreshed")
        }, window.swymCustomerExtraCheck ? {
            force: !0
        } : null))
    }
    function za(a, b) {
        f.waitForCustomerRefresh || (f.retailerSettings && f.retailerSettings.General.LogoutClean && !window.swymCustomerId && f.isAlreadyAuth() ? (f.cleanDevice(),
        f.storage.remove("ol_ct"),
        f.storage.removeLocal("wshlstcnt"),
        f.refresh(function() {
            f.continueCallbacks();
            b && b("cleaned")
        }),
        f.holdCallbacks()) : window.swymCustomerId && !f.isAlreadyAuth() ? Za(a, b) : window.swymCustomerId ? f.api.authCheck(function(c) {
            c.regn && c.regn.userinfo && c.regn.userinfo.extid && (c.regn.userinfo.extid != window.swymCustomerId ? (f.cleanDevice(),
            f.storage.remove("ol_ct"),
            f.refresh(function() {
                Za(a, b)
            }),
            f.holdCallbacks()) : (f.continueCallbacks(),
            b && b("refreshed")))
        }) : (f.continueCallbacks(),
        b && b("no login")))
    }
    function Hb() {
        var a = SwymUtils.getParameterByName("variant");
        triggerSwymVariantEvent(a)
    }
    function ua() {
        Aa = Aa || SwymUtils.debounce(Hb, 20);
        return Aa()
    }
    function yb(a, b) {
        var c = {
            "venture-775-icon": {
                attachSelector: ".product-single__meta-list li",
                customCSS: ".swym-button-bar{margin: 0px;}"
            },
            "debut-1049-icon": {
                attachSelector: ".product-single__price span",
                customCSS: ".swym-button-bar{margin: 0px;}"
            },
            "debut-796-icon": {
                attachSelector: ".product-single__price span",
                customCSS: ".swym-button-bar{margin: 0px;}"
            },
            "debut-796-text": {
                attachSelector: "form.product-form",
                customCSS: ".swym-button-bar{margin: 10px 0px;}"
            },
            "debut-796-icontext": {
                attachSelector: "form.product-form",
                customCSS: ".swym-button-bar{margin: 10px 0px;}"
            },
            "debut-796-btnlink": {
                attachSelector: "form.product-form",
                customCSS: ".swym-button-bar{margin: 10px 0px;}"
            },
            "debut-796-iconbtnlink": {
                attachSelector: "form.product-form",
                customCSS: ".swym-button-bar{margin: 10px 0px;}"
            },
            "debut-796": {
                customJS: function() {
                    var a = B.ui.open;
                    B.ui.open = function() {
                        try {
                            window.theme.MobileNav.closeMobileNav()
                        } catch (b) {}
                        a.apply(B.ui, arguments)
                    }
                }
            },
            "boundless-766-icon": {
                attachSelector: ".product__price span",
                customCSS: ".swym-button-bar{margin: 0px;}"
            },
            "fashionopolism-141-icon": {
                attachSelector: ".product-prices span",
                customCSS: ".swym-button-bar{margin: 0px;}"
            },
            "minimal-380": {
                customCSS: ".swym-button-bar{margin: 0px 10px;}"
            },
            "classic-721-icon": {
                customCSS: ".swym-button-bar{margin: 0px 10px;}"
            },
            "sunrise2-57-icon": {
                customCSS: ".swym-button-bar{margin: 0px 10px;vertical-align: top;}"
            },
            "brooklyn-730-icon": {
                customCSS: ".swym-button-bar{margin: 0px 10px;}"
            },
            "brooklyn-730-icontext": {
                customCSS: ".swym-button-bar{margin: 0px; }"
            },
            "brooklyn-730-btnlink": {
                customCSS: ".swym-button-bar{margin: 20px 10px;}"
            },
            "brooklyn-730-iconbtnlink": {
                customCSS: ".swym-button-bar{margin: 20px 10px;}"
            },
            "testament-623-icon": {
                attachSelector: "#product-price span",
                customCSS: ".swym-button-bar{margin: 0px;}"
            },
            "testament-623": {
                customCSS: "#swym-plugin .swym-button,#swym-hosted-plugin .swym-button {width: auto;}"
            },
            "sugar-160891530-icontext": {
                attachSelector: "form .add-to-cart input",
                customCSS: ".swym-button-bar{margin: 0px 10px; vertical-align: middle;} .product-wrap form .add-to-cart input{margin-right: 10px; vertical-align: middle;}"
            },
            "supply-679": {
                customCSS: "#swym-plugin #swym-notepad, #swym-hosted-plugin #swym-notepad{z-index: 1000000003;}"
            },
            "icon-686": {
                customCSS: ".swym-button {max-width: 200px;}"
            },
            "showtime-687": {
                attachSelector: "form#addToCartForm input[id=addToCart]",
                customCSS: ".swym-button-bar{margin: 10px 0px;}@media (max-width: 480px) {.swym-button-bar{display: block;text-align: center;margin: 4px 0px;}}"
            },
            "showtime-687-icon": {
                customCSS: ".swym-button-bar{margin: -4px 10px 0px;vertical-align: top;}"
            },
            "expression-230": {
                attachSelector: "#product-form .buttoncont",
                customCSS: ".swym-button-bar{margin: 0px;} .swym-button{cursor: pointer;}"
            },
            ella: {
                attachSelector: "#product-add-to-cart",
                customCSS: ".swym-button-bar {margin: 10px;display: inline-block;height: 50px;} .swym-btn-container[data-position=default] .swym-add-to-wishlist.swym-btnlink {width: auto;font-size: initial;padding: 0px 0px 0px 4px;font-weight: initial;height: 20px;line-height: 100%;text-indent: 0px;} .swym-btn-container[data-position=default] .swym-add-to-wishlist:hover {border-color: none !important;background-color: white !important;}"
            },
            "kagami-live-747": {
                customCSS: ".flexbox .product__buy{-webkit-flex-wrap: wrap;-moz-flex-wrap: wrap;-ms-flex-wrap: wrap;flex-wrap: wrap; justify-content: flex-start; -webkit-justify-content: flex-start; -moz-justify-content: flex-start; -ms-justify-content: flex-start;} .flexbox .product__quantity {order: 0;} .flexbox .button--cart, .flexbox .button--cart--default, .flexbox .button--cart--not--available {order: 5; -webkit-flex-basis: 100%; -moz-flex-basis: 100%; -ms-flex-basis: 100%; flex-basis: 100%; padding: 15px 40px 16px 40px;} .swym-button-bar {margin-top: 0px;} .swym-btn-container[data-position=default] .swym-add-to-wishlist {margin-top: 15px;margin-left: -22px;margin-bottom: 15px;}"
            },
            "kagami-747": {
                customCSS: ".flexbox .product__buy{-webkit-flex-wrap: wrap;-moz-flex-wrap: wrap;-ms-flex-wrap: wrap;flex-wrap: wrap; justify-content: flex-start; -webkit-justify-content: flex-start; -moz-justify-content: flex-start; -ms-justify-content: flex-start;} .flexbox .product__quantity {order: 0;} .flexbox .button--cart, .flexbox .button--cart--default, .flexbox .button--cart--not--available {order: 5; -webkit-flex-basis: 100%; -moz-flex-basis: 100%; -ms-flex-basis: 100%; flex-basis: 100%; padding: 15px 40px 16px 40px;} .swym-button-bar {margin-top: 0px;} .swym-btn-container[data-position=default] .swym-add-to-wishlist {margin-top: 15px;margin-left: -22px;margin-bottom: 15px;}"
            },
            "blockshop-606": {
                attachSelector: ".prices",
                customCSS: ".swym-button-bar {display: block;margin-left: 0px;}"
            },
            855: {
                attachSelector: ".ProductForm .ProductForm__AddToCart",
                customCSS: ".swym-button-bar {display: block; margin: 10px 0px;}.swym-button-bar .swym-btn-container * {font: inherit;line-height: inherit;}"
            },
            "855-icontext": {
                customCSS: ".swym-button-bar .swym-btn-container[data-position=default]{display: block;} .swym-button-bar .swym-btn-container .swym-add-to-wishlist.swym-icontext:after{width: 20%;max-width: 50px;} .swym-button-bar .swym-btn-container .swym-add-to-wishlist.swym-icontext {width: 100%;} .swym-button-bar .swym-btn-container .swym-add-to-wishlist.swym-has-fave-count.swym-icontext {width: calc(100% - 40px);} .swym-button-bar .swym-add-to-wishlist.swym-icontext+.swym-fave-count {padding: 8px; width: 40px; text-align: center}",
                wishlistAddClasses: "Button"
            },
            "855-iconbtnlink": {
                wishlistAddClasses: "Button"
            },
            "855-btnlink": {
                wishlistAddClasses: "Button"
            },
            "855-icon": {
                customCSS: ".swym-button-bar{display:flex; justify-content:center; margin:10px 0px;}"
            },
            566: {
                attachSelector: "button.product-submit"
            },
            "566-icontext": {
                customCSS: ".swym-button-bar { margin: 0; }"
            },
            "566-icon": {
                customCSS: ".swym-button-bar { margin: 0; }"
            },
            796: {
                attachSelector: "button.btn.product-form__cart-submit",
                customCSS: ".swym-button-bar { margin: 0; } .swym-add-to-wishlist{ letter-spacing: 0.08em; } .swym-add-to-watchlist{ letter-spacing: 0.08em; }"
            },
            838: {
                attachSelector: ".product-form--atc",
                customCSS: ".swym-button-bar { margin: 10px 0; }"
            },
            857: {
                attachSelector: ".btn.btn--full.add-to-cart"
            },
            871: {
                attachSelector: ".product-form__payment-container"
            },
            "871-icontext": {
                customCSS: ".swym-button-bar { margin: 10px 0; }"
            },
            "871-btnlink": {
                customCSS: ".swym-button-bar { margin: 10px 0; }"
            },
            "871-icon": {
                customCSS: ".swym-button-bar { margin: 10px 0; }"
            },
            868: {
                attachSelector: ".product__submit__buttons",
                customCSS: ".swym-button-bar { margin: 10px 0; }"
            },
            730: {
                customCSS: " .swym-add-to-wishlist{ letter-spacing: 0.1rem; } .swym-add-to-watchlist{ letter-spacing: 0.1rem; }"
            },
            775: {
                customCSS: ".swym-add-to-wishlist{ letter-spacing: 0.15em; } .swym-add-to-watchlist{ letter-spacing: 0.15em; }"
            },
            380: {
                customCSS: ".swym-add-to-wishlist{ letter-spacing: 0.1em; } .swym-add-to-watchlist{ letter-spacing: 0.1em; }"
            }
        };
        try {
            var d = function() {
                SwymUtils.addClass(r, "swym-" + g);
                SwymUtils.addClass(r, "swym-" + k)
            }
              , e = Shopify.theme.theme_store_id
              , g = Shopify.theme.name.toLowerCase().replace(/ /g, "") + "-" + e
              , k = g + "-" + (b || "icon")
              , l = e + "-" + (b || "icon")
              , m = c[g] || c[e]
              , e = !1;
            m || 0 !== g.indexOf("ella") || (m = c[m]);
            if (m && (!a && m.attachSelector && (a = m.attachSelector,
            e = !0),
            m.customCSS && SwymUtils.appendCustomCSS(m.customCSS),
            m.customJS))
                try {
                    m.customJS.call()
                } catch (h) {}
            var p = c[k] || c[l];
            if (p) {
                if (!a || e)
                    a = p.attachSelector;
                p.customCSS && SwymUtils.appendCustomCSS(p.customCSS);
                p.wishlistAddClasses && (t.AddClasses = (t.AddClasses || "") + " " + p.wishlistAddClasses)
            }
            var r = document.getElementById("swym-plugin");
            r ? d() : f.evtLayer.addEventListener(f.JSEvents.renderUI, function() {
                r = document.getElementById("swym-plugin");
                d()
            });
            SwymUtils.addClass(document.body, "swym-" + g);
            SwymUtils.addClass(document.body, "swym-" + k)
        } catch (h) {
            SwymUtils.error("Error in theme selector - " + JSON.stringify(window.Shopify && window.Shopify.theme), h)
        }
        return a
    }
    function zb(a, b) {
        "left" == b || "right" == b ? document.body.appendChild(a.parentNode) : "default" == b && "true" == a.parentNode.getAttribute("data-fallbacktofloating") && (SwymUtils.log("Fallback to floating button"),
        a.parentNode.setAttribute("data-position", "right"),
        document.body.appendChild(a.parentNode))
    }
    function Ib() {
        var a = f.getRetailerConfig("InterfacePath");
        a && -1 < a.indexOf("swymundefined") && (a = null);
        var b = f.getApps()[0]
          , b = b && b.app;
        return a || "/apps/swym" + b + "/interfaces/interfaceStore.php?appname=" + b
    }
    function ab() {
        var a = null;
        if (window.Shopify && window.Shopify.theme && window.Shopify.theme.theme_store_id) {
            a = window.Shopify.theme.theme_store_id;
            try {
                switch (a) {
                case 887:
                    fetch("/?sections=cart-icon-bubble").then(function(a) {
                        return a.json()
                    }).then(function(a) {
                        if (a && a["cart-icon-bubble"]) {
                            var b = document.getElementById("cart-icon-bubble");
                            b && (a = SwymUtils.createElement(a["cart-icon-bubble"]).innerHTML) && (b.innerHTML = a)
                        }
                    }).catch(function(a) {
                        SwymUtils.error("Error in updating cart bubble count in header", a)
                    });
                    break;
                case 730:
                    var b = document.querySelector(".cart-link__bubble");
                    b && SwymUtils.addClass(b, "cart-link__bubble--visible");
                    break;
                case 679:
                    fetch("/cart.js").then(function(a) {
                        return a.json()
                    }).then(function(a) {
                        a && a.item_count && SwymUtils.forEachElement(".cart-count", function(b) {
                            b.innerHTML = a.item_count;
                            SwymUtils.removeClass(b, "hidden-count")
                        })
                    }).catch(function(a) {
                        SwymUtils.error("Error in updating cart bubble count in header", a)
                    });
                    break;
                case 857:
                    if (b = document.querySelector(".cart-link__bubble"))
                        SwymUtils.addClass(b, "cart-link__bubble--visible"),
                        document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
                    break;
                case 568:
                    document.dispatchEvent(new CustomEvent("theme:cartchanged",{
                        bubbles: !0,
                        cancelable: !1
                    }));
                    break;
                case 735:
                    fetch("/?sections=cart-button").then(function(a) {
                        return a.json()
                    }).then(function(a) {
                        if (a && a["cart-button"]) {
                            var b = document.getElementById("cart-button");
                            b && (a = SwymUtils.createElement(a["cart-button"]).innerHTML) && (b.innerHTML = a)
                        }
                    }).catch(function(a) {
                        SwymUtils.error("Error in updating cart bubble count in header", a)
                    });
                    break;
                case 838:
                    fetch("/cart.js").then(function(a) {
                        return a.json()
                    }).then(function(a) {
                        a && a.item_count && window.dispatchEvent(new CustomEvent("cartcount:update",{
                            detail: a
                        }))
                    }).catch(function(a) {
                        SwymUtils.error("Error in updating cart bubble count in header", a)
                    });
                    break;
                case 1368:
                    fetch("/?sections=cart-icon-bubble").then(function(a) {
                        return a.json()
                    }).then(function(a) {
                        if (a && a["cart-icon-bubble"]) {
                            var b = document.getElementById("cart-icon-bubble");
                            b && (a = SwymUtils.createElement(a["cart-icon-bubble"]).innerHTML) && (b.innerHTML = a)
                        }
                    }).catch(function(a) {
                        SwymUtils.error("Error in updating cart bubble count in header", a)
                    });
                    break;
                case 459:
                    var c = this
                      , d = document.getElementById("cart-config");
                    if (!d)
                        break;
                    d = JSON.parse(d.innerHTML || "{}");
                    fetch("/cart.js").then(function(a) {
                        return a.json()
                    }).then(function(a) {
                        c.Shopify && c.Shopify.theme && c.Shopify.theme && c.Shopify.theme.ajaxCart && c.Shopify.theme.ajaxCart.updateView(d, a)
                    }).catch(function(a) {
                        SwymUtils.error("Error in updating cart bubble count in header", a)
                    });
                    break;
                case 902:
                    document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
                    break;
                case 380:
                    fetch("/cart.js").then(function(a) {
                        return a.json()
                    }).then(function(a) {
                        a && a.item_count && SwymUtils.forEachElement(".cart-count", function(b) {
                            b.innerHTML = a.item_count
                        })
                    }).catch(function(a) {
                        SwymUtils.error("Error in updating cart bubble count in header", a)
                    });
                    break;
                case 775:
                    (b = document.querySelector(".site-header__cart-indicator")) && SwymUtils.removeClass(b, "hide");
                case 796:
                    fetch("/cart.js").then(function(a) {
                        return a.json()
                    }).then(function(a) {
                        if (a && a.item_count) {
                            var b = document.querySelector("[data-cart-count-bubble]");
                            b && SwymUtils.removeClass(b, "hide");
                            if (b = document.querySelector("[data-cart-count]"))
                                b.textContent = a.item_count
                        }
                    }).catch(function(a) {
                        SwymUtils.error("Error in updating cart bubble count in header", a)
                    });
                default:
                    SwymUtils.error("No code for updating cart bubble count in header", a)
                }
            } catch (e) {
                SwymUtils.error("Error in updating cart bubble count in header", e)
            }
        }
    }
    window.swymModules = window.swymModules || [];
    (function(a, b) {
        "object" === typeof exports && exports && "string" !== typeof exports.nodeName ? b(exports) : (a.Mustache = {},
        b(a.Mustache));
        b(a.Mustache = {})
    }
    )(this, function(a) {
        function b(a) {
            return "function" === typeof a
        }
        function c(a) {
            return a.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&")
        }
        function d(a, b) {
            return null != a && "object" === typeof a && b in a
        }
        function e(b, d) {
            function e(a) {
                "string" === typeof a && (a = a.split(H, 2));
                if (!n(a) || 2 !== a.length)
                    throw Error("Invalid tags: " + a);
                E = new RegExp(c(a[0]) + "\\s*");
                q = new RegExp("\\s*" + c(a[1]));
                C = new RegExp("\\s*" + c("}" + a[1]))
            }
            if (!b)
                return [];
            var m = [], f = [], h = [], p = !1, r = !1, E, q, C;
            e(d || a.tags);
            for (var w = new l(b), y, D, z, B; !w.eos(); ) {
                y = w.pos;
                if (z = w.scanUntil(E)) {
                    B = 0;
                    for (var G = z.length; B < G; ++B)
                        if (D = z.charAt(B),
                        x.call(F, D) ? r = !0 : h.push(f.length),
                        f.push(["text", D, y, y + 1]),
                        y += 1,
                        "\n" === D) {
                            if (p && !r)
                                for (; h.length; )
                                    delete f[h.pop()];
                            else
                                h = [];
                            r = p = !1
                        }
                }
                if (!w.scan(E))
                    break;
                p = !0;
                D = w.scan(v) || "name";
                w.scan(t);
                "=" === D ? (z = w.scanUntil(u),
                w.scan(u),
                w.scanUntil(q)) : "{" === D ? (z = w.scanUntil(C),
                w.scan(A),
                w.scanUntil(q),
                D = "&") : z = w.scanUntil(q);
                if (!w.scan(q))
                    throw Error("Unclosed tag at " + w.pos);
                B = [D, z, y, w.pos];
                f.push(B);
                if ("#" === D || "^" === D)
                    m.push(B);
                else if ("/" === D) {
                    D = m.pop();
                    if (!D)
                        throw Error('Unopened section "' + z + '" at ' + y);
                    if (D[1] !== z)
                        throw Error('Unclosed section "' + D[1] + '" at ' + y);
                } else
                    "name" === D || "{" === D || "&" === D ? r = !0 : "=" === D && e(z)
            }
            if (D = m.pop())
                throw Error('Unclosed section "' + D[1] + '" at ' + w.pos);
            return k(g(f))
        }
        function g(a) {
            for (var b = [], c, d, k = 0, e = a.length; k < e; ++k)
                if (c = a[k])
                    "text" === c[0] && d && "text" === d[0] ? (d[1] += c[1],
                    d[3] = c[3]) : (b.push(c),
                    d = c);
            return b
        }
        function k(a) {
            for (var b = [], c = b, d = [], k, e = 0, g = a.length; e < g; ++e)
                switch (k = a[e],
                k[0]) {
                case "#":
                case "^":
                    c.push(k);
                    d.push(k);
                    c = k[4] = [];
                    break;
                case "/":
                    c = d.pop();
                    c[5] = k[2];
                    c = 0 < d.length ? d[d.length - 1][4] : b;
                    break;
                default:
                    c.push(k)
                }
            return b
        }
        function l(a) {
            this.tail = this.string = a;
            this.pos = 0
        }
        function m(a, b) {
            this.view = a;
            this.cache = {
                ".": this.view
            };
            this.parent = b
        }
        function f() {
            this.cache = {}
        }
        var h = Object.prototype.toString
          , n = Array.isArray || function(a) {
            return "[object Array]" === h.call(a)
        }
          , x = RegExp.prototype.test
          , F = /\S/
          , E = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;",
            "/": "&#x2F;",
            "`": "&#x60;",
            "=": "&#x3D;"
        }
          , t = /\s*/
          , H = /\s+/
          , u = /\s*=/
          , A = /\s*\}/
          , v = /#|\^|\/|>|\{|&|=|!/;
        l.prototype.eos = function() {
            return "" === this.tail
        }
        ;
        l.prototype.scan = function(a) {
            a = this.tail.match(a);
            if (!a || 0 !== a.index)
                return "";
            a = a[0];
            this.tail = this.tail.substring(a.length);
            this.pos += a.length;
            return a
        }
        ;
        l.prototype.scanUntil = function(a) {
            a = this.tail.search(a);
            var b;
            switch (a) {
            case -1:
                b = this.tail;
                this.tail = "";
                break;
            case 0:
                b = "";
                break;
            default:
                b = this.tail.substring(0, a),
                this.tail = this.tail.substring(a)
            }
            this.pos += b.length;
            return b
        }
        ;
        m.prototype.push = function(a) {
            return new m(a,this)
        }
        ;
        m.prototype.lookup = function(a) {
            var c = this.cache, k;
            if (c.hasOwnProperty(a))
                k = c[a];
            else {
                for (var e = this, g, m, l, f = !1; e; ) {
                    if (0 < a.indexOf("."))
                        for (g = e.view,
                        m = a.split("."),
                        l = 0; null != g && l < m.length; )
                            l === m.length - 1 && (f = d(g, m[l]) || null != g && "object" !== typeof g && g.hasOwnProperty && g.hasOwnProperty(m[l])),
                            g = g[m[l++]];
                    else
                        g = e.view[a],
                        f = d(e.view, a);
                    if (f) {
                        k = g;
                        break
                    }
                    e = e.parent
                }
                c[a] = k
            }
            b(k) && (k = k.call(this.view));
            return k
        }
        ;
        f.prototype.clearCache = function() {
            this.cache = {}
        }
        ;
        f.prototype.parse = function(b, c) {
            var d = this.cache
              , k = b + ":" + (c || a.tags).join(":")
              , g = d[k];
            null == g && (g = d[k] = e(b, c));
            return g
        }
        ;
        f.prototype.render = function(a, b, c, d) {
            var k = this.parse(a, d);
            b = b instanceof m ? b : new m(b);
            return this.renderTokens(k, b, c, a, d)
        }
        ;
        f.prototype.renderTokens = function(a, b, c, d, k) {
            for (var e = "", g, m, l, f = 0, h = a.length; f < h; ++f)
                l = void 0,
                g = a[f],
                m = g[0],
                "#" === m ? l = this.renderSection(g, b, c, d) : "^" === m ? l = this.renderInverted(g, b, c, d) : ">" === m ? l = this.renderPartial(g, b, c, k) : "&" === m ? l = this.unescapedValue(g, b) : "name" === m ? l = this.escapedValue(g, b) : "text" === m && (l = this.rawValue(g)),
                void 0 !== l && (e += l);
            return e
        }
        ;
        f.prototype.renderSection = function(a, c, d, k) {
            function e(a) {
                return g.render(a, c, d)
            }
            var g = this
              , l = ""
              , m = c.lookup(a[1]);
            if (m) {
                if (n(m))
                    for (var f = 0, h = m.length; f < h; ++f)
                        l += this.renderTokens(a[4], c.push(m[f]), d, k);
                else if ("object" === typeof m || "string" === typeof m || "number" === typeof m)
                    l += this.renderTokens(a[4], c.push(m), d, k);
                else if (b(m)) {
                    if ("string" !== typeof k)
                        throw Error("Cannot use higher-order sections without the original template");
                    m = m.call(c.view, k.slice(a[3], a[5]), e);
                    null != m && (l += m)
                } else
                    l += this.renderTokens(a[4], c, d, k);
                return l
            }
        }
        ;
        f.prototype.renderInverted = function(a, b, c, d) {
            var k = b.lookup(a[1]);
            if (!k || n(k) && 0 === k.length)
                return this.renderTokens(a[4], b, c, d)
        }
        ;
        f.prototype.renderPartial = function(a, c, d, k) {
            if (d && (a = b(d) ? d(a[1]) : d[a[1]],
            null != a))
                return this.renderTokens(this.parse(a, k), c, d, a)
        }
        ;
        f.prototype.unescapedValue = function(a, b) {
            var c = b.lookup(a[1]);
            if (null != c)
                return c
        }
        ;
        f.prototype.escapedValue = function(b, c) {
            var d = c.lookup(b[1]);
            if (null != d)
                return a.escape(d)
        }
        ;
        f.prototype.rawValue = function(a) {
            return a[1]
        }
        ;
        a.name = "mustache.js";
        a.version = "3.0.1";
        a.tags = ["{{", "}}"];
        var q = new f;
        a.clearCache = function() {
            return q.clearCache()
        }
        ;
        a.parse = function(a, b) {
            return q.parse(a, b)
        }
        ;
        a.render = function(a, b, c, d) {
            if ("string" !== typeof a)
                throw b = TypeError,
                a = n(a) ? "array" : typeof a,
                new b('Invalid template! Template should be a "string" but "' + a + '" was given as the first argument for mustache#render(template, view, partials)');
            return q.render(a, b, c, d)
        }
        ;
        a.to_html = function(c, d, k, e) {
            c = a.render(c, d, k);
            if (b(e))
                e(c);
            else
                return c
        }
        ;
        a.escape = function(a) {
            return String(a).replace(/[&<>"'`=\/]/g, function(a) {
                return E[a]
            })
        }
        ;
        a.Scanner = l;
        a.Context = m;
        a.Writer = f;
        return a
    });
    var xb = {
        en: {
            WishlistAddCTA: "Add to Wishlist",
            WishlistAddedCTA: "Added to Wishlist",
            WatchlistAddCTA: "Remind me when available",
            ComingSoonAddCTA: "This Product is Coming Soon",
            WishlistTooltipBefore: "Add to Wishlist",
            WatchlistTooltip: "Subscribe",
            WishlistTooltipAfter: "Added. <a class='swym-open-ui'>View Wishlist</a>"
        },
        ja: {
            WishlistAddCTA: "\u307b\u3057\u3044\u7269\u30ea\u30b9\u30c8\u306b\u8ffd\u52a0\u3059\u308b",
            WishlistAddedCTA: "\u30a6\u30a3\u30c3\u30b7\u30e5\u30ea\u30b9\u30c8\u306b\u8ffd\u52a0\u3055\u308c\u307e\u3057\u305f",
            WatchlistAddCTA: "\u5229\u7528\u53ef\u80fd\u306b\u306a\u3063\u305f\u3089\u30e1\u30fc\u30eb\u3067\u9023\u7d61",
            ComingSoonAddCTA: "\u3053\u306e\u88fd\u54c1\u306f\u307e\u3082\u306a\u304f\u767b\u5834\u3057\u307e\u3059",
            WishlistTooltipBefore: "\u307b\u3057\u3044\u7269\u30ea\u30b9\u30c8\u306b\u8ffd\u52a0\u3059\u308b",
            WatchlistTooltip: "\u767b\u9332\u3059\u308b",
            WishlistTooltipAfter: "\u8ffd\u52a0\u3057\u307e\u3057\u305f\u3002 <a class='swym-open-ui'>\u30a6\u30a3\u30c3\u30b7\u30e5\u30ea\u30b9\u30c8\u3092\u898b\u308b</a>"
        },
        fr: {
            WishlistAddCTA: "Ajouter \u00e0 Wishlist",
            WishlistAddedCTA: "Ajout\u00e9 \u00e0 Wishlist",
            WatchlistAddCTA: "Notifiez moi lorsque ce bijou sera disponible",
            ComingSoonAddCTA: "Ce produit arrive bient\u00f4t",
            WishlistTooltipBefore: "Ajouter \u00e0 Wishlist",
            WatchlistTooltip: "Inscription",
            WishlistTooltipAfter: "Ajout\u00e9. <a class='swym-open-ui'>Voir la liste de souhaits</a>"
        },
        es: {
            WishlistAddCTA: "Agregar a la lista de deseos",
            WishlistAddedCTA: "A\u00f1adido a la lista de deseos",
            WatchlistAddCTA: "Env\u00edeme Un Correo Electr\u00f3nico Cuando Est\u00e9 Disponible",
            ComingSoonAddCTA: "Este producto llegar\u00e1 pronto",
            WishlistTooltipBefore: "Agregar a la lista de deseo",
            WatchlistTooltip: "Suscribir",
            WishlistTooltipAfter: "Agregado. <a class='swym-open-ui'>Ver lista de deseos</a>"
        },
        it: {
            WishlistAddCTA: "Aggiungi alla lista dei desideri",
            WishlistAddedCTA: "Aggiunto a Wishlist",
            WatchlistAddCTA: "Inviami un'email quando sar\u00e0 disponibile",
            ComingSoonAddCTA: "Questo prodotto arriver\u00e0 presto",
            WishlistTooltipBefore: "Aggiungi alla lista dei desideri",
            WatchlistTooltip: "Iscriviti",
            WishlistTooltipAfter: "Aggiunto. Agregado. <a class='swym-open-ui'>Ver lista de deseos</a>"
        },
        de: {
            WishlistAddCTA: "Zur Wunschliste hinzuf\u00fcgen",
            WishlistAddedCTA: "Zur Wunschliste hinzugef\u00fcgt",
            WatchlistAddCTA: "Benachrichtigung erhalten, wenn der Artikel wieder auf Lager ist",
            ComingSoonAddCTA: "Dieses Produkt kommt bald",
            WishlistTooltipBefore: "Zur Wunschliste hinzuf\u00fcgen",
            WatchlistTooltip: "Abonnieren",
            WishlistTooltipAfter: "Hinzugef\u00fcgt. <a class='swym-open-ui'>Wunschliste anzeigen</a>"
        }
    }
      , Jb = {
        WidgetContainer: "swym-widget-products-template",
        ProductGridItem: "swym-product-grid-item-template"
    }
      , Ba = '<script id="swym-widget-products-template" type="x-tmpl-mustache">\n<div class="swym-widget swym-products swym-products-{{render.type}}" id="swym-widget-{{{id}}}">\n  <style>\n    @media screen and (min-width: 800px) {\n      #swym-widget-{{{id}}} .swym-product-grid-li {\n        width: {{render.widths.desktop}}%;\n      }\n      #swym-widget-{{{id}}}.swym-products-grid .swym-product-grid-li:nth-child({{render.cols.desktop}}n+1) {\n        clear: left;\n      }\n    }\n    @media screen and (max-width: 800px) {\n      #swym-widget-{{{id}}} .swym-product-grid-li {\n        width: {{render.widths.tablet}}%;\n      }\n      #swym-widget-{{{id}}} .swym-product-grid-li:nth-child({{render.cols.tablet}}n+1) {\n        clear: left;\n      }\n    }\n    @media screen and (max-width: 570px) {\n      #swym-widget-{{{id}}} .swym-product-grid-li {\n        width: {{render.widths.mobile}}%;\n      }\n      #swym-widget-{{{id}}}.swym-products-grid .swym-product-grid-li:nth-child({{render.cols.mobile}}n+1) {\n        clear: left;\n      }\n    }\n  </style>\n  <ul class="swym-products-loop"></ul>\n  {{#render.iscarousel}}\n  <div class="swym-products-nav">\n    <a class="swym-products-nav-btn swym-products-nav-left" href="#"><i class="swym-icon swym-arrow-left-grey"></i></a>\n    <a class="swym-products-nav-btn swym-products-nav-right" href="#"><i class="swym-icon swym-arrow-right-grey"></i></a>\n  </div>\n  {{/render.iscarousel}}\n</div>\n\x3c/script>\n<script id="swym-product-grid-item-template" type="x-tmpl-mustache">\n<div class="swym-product-grid-item">\n    <div class="swym-product-grid-overlay">\n    </div>\n    <a href="{{{du}}}" title="{{{dt}}}" class="swym-product-grid-hyperlink">\n      <div class="swym-product-grid-meta">\n      </div>\n      <div class="swym-product-grid-image">\n          <div class="swym-product-grid-image-placeholder">\n              <span class="swym-v-align-outer">\n                  {{#iu}}\n                  <span class="swym-v-align-inner">\n                      <img src="{{{iu}}}" itemprop="image" alt="{{{dt}}}"/>\n                  </span>\n                  {{/iu}}\n                  {{^iu}}\n                  <span class="swym-image-placeholder">\n                  </span>\n                  {{/iu}}\n              </span>\n          </div>\n      </div>\n      <div class="swym-product-grid-info">\n          <strong>{{{dt}}}</strong>\n          <span>{{{vinfo}}}</span>\n      </div>\n      <div class="swym-product-grid-price">\n          <span>{{#op}}<s class="swym-op">{{{formattedOp}}}</s> {{/op}}<strong class="swym-pr">{{{formattedPr}}}</strong></span>\n      </div>\n    </a>\n    <div class="swym-product-grid-actions">\n    </div>\n</div>\n\x3c/script>\n';
    u.prototype.getSessionId = function() {
        var a = this.get();
        a ? (a = a.replace(/[\\\"]/g, ""),
        this.setSessionId(a)) : (this.setSessionId(this.generateSwymSessionId(64)),
        this.sw.triggerSwymEvent(this.sw.JSEvents.sessionCreated),
        this.sw.collectPending = !0);
        this.canStart = !0;
        return this.sessionId
    }
    ;
    u.prototype.setSessionId = function(a) {
        this.sessionId = a;
        this.put(this.sessionId);
        return this.sessionId
    }
    ;
    u.prototype.setOnStart = function(a) {
        this.canStart && (this.sw.triggerSwymEvent(this.sw.JSEvents.sessionStarted),
        a())
    }
    ;
    u.prototype.generateSwymSessionId = function(a) {
        for (var b = "", c; b.length < a; )
            c = Math.random().toString(36).slice(2),
            b += c.slice(0, Math.min(c.length, a - b.length));
        return b.toLowerCase()
    }
    ;
    u.prototype.put = function(a) {
        return this.storage.setSessionData(this.sw.key.SESSIONID, a)
    }
    ;
    u.prototype.get = function() {
        return this.storage.get(this.sw.key.SESSIONID)
    }
    ;
    u.prototype.remove = function() {
        this.storage.remove(this.sw.key.O_S);
        return this.storage.remove(this.sw.key.SESSIONID)
    }
    ;
    u.prototype.hasSessionStorage = function() {
        if ("undefined" != typeof Storage)
            try {
                return sessionStorage.setItem("lstest", "lstest"),
                sessionStorage.removeItem("lstest"),
                !0
            } catch (a) {
                return !1
            }
        else
            return !1
    }
    ;
    var bb = {
        General: {
            Enabled: !0,
            Currency: "$",
            RetailerID: "",
            DetectIdentity: !0,
            ProductLevel: "product-variant",
            QuickViewPlugin: "",
            _v: "2",
            LoginPath: "/account/login",
            MailingListCheck: !1,
            LogoutClean: !1,
            HostedPages: {
                Wishlist: "/apps/swymWishlist/wishlist/index.php",
                SharedWishlist: "/apps/swymWishlist/shared/index.php",
                Unsubscribe: ""
            }
        },
        Email: {
            EnableEmailFriend: !0,
            DefaultNote: "",
            DefaultFromAddress: ""
        },
        Integrations: {},
        Strings: {},
        Templates: {}
    };
    h.prototype.SwymPrefix = "swym-";
    q.prototype.get = function(a, b) {
        var c = this.readCookie_("swym-" + a);
        return c ? R(c) || b : b || null
    }
    ;
    q.prototype.getRaw = function(a, b) {
        return this.readCookie_(a) || b
    }
    ;
    q.prototype.getLocal = function(a, b) {
        if (!this.canStoreLocally)
            return null;
        var c = window.localStorage.getItem("swym-" + a);
        return c ? R(c) : null
    }
    ;
    q.prototype.set = function(a, b, c) {
        this.createCookie_("swym-" + a, JSON.stringify(b), this.primaryDomain, c)
    }
    ;
    q.prototype.setSessionData = function(a, b) {
        this.createSessionCookie_("swym-" + a, JSON.stringify(b), this.primaryDomain)
    }
    ;
    q.prototype.setRaw = function(a, b) {
        this.createCookie_(a, JSON.stringify(b), this.primaryDomain)
    }
    ;
    q.prototype.setLocal = function(a, b) {
        this.canStoreLocally && window.localStorage.setItem("swym-" + a, JSON.stringify(b))
    }
    ;
    q.prototype.removeLocal = function(a) {
        this.canStoreLocally && window.localStorage.removeItem("swym-" + a)
    }
    ;
    q.prototype.remove = function(a, b) {
        this.eraseCookie_("swym-" + a, b)
    }
    ;
    q.prototype.removeNoPrefix = function(a) {
        this.eraseCookie_(a)
    }
    ;
    q.prototype.createCookie_ = function(a, b, c, d) {
        var e = new Date;
        e.setTime(e.getTime() + (d || 31536E6));
        d = "; expires=" + e.toGMTString();
        document.cookie = a + "=" + b + d + ";Secure;SameSite=None; path=/" + (c ? ";domain=." + c : "")
    }
    ;
    q.prototype.createSessionCookie_ = function(a, b, c) {
        var d = new Date;
        d.setTime(d.getTime() + 18E5);
        d = "; expires=" + d.toGMTString();
        document.cookie = a + "=" + b + d + ";Secure;SameSite=None; path=/" + (c ? ";domain=." + c : "")
    }
    ;
    q.prototype.readCookie_ = function(a) {
        a += "=";
        for (var b = document.cookie.split(";"), c = 0; c < b.length; c++) {
            for (var d = b[c]; " " == d.charAt(0); )
                d = d.substring(1, d.length);
            if (0 == d.indexOf(a))
                return d.substring(a.length, d.length)
        }
        return null
    }
    ;
    q.prototype.eraseCookie_ = function(a, b) {
        var c = b || this.primaryDomain;
        document.cookie = a + "=;path=/" + (c ? ";domain=" + c : "") + ";Secure;SameSite=None;expires=Thu, 01 Jan 1970 00:00:01 GMT;"
    }
    ;
    h.prototype.hasLocalStorage = Q;
    h.prototype.getPrimaryDomain = J;
    I.prototype.putObject = function(a) {
        a && (this.storage.setLocal(this.cacheName, a),
        this.storage.setLocal(this.cacheTimestampName, this.getCurrentTimeInSeconds()))
    }
    ;
    I.prototype.updateObject = function(a) {
        a && this.storage.setLocal(this.cacheName, a)
    }
    ;
    I.prototype.getObject = function() {
        return this.storage.getLocal(this.cacheName)
    }
    ;
    I.prototype.getCurrentTimeInSeconds = function() {
        return (new Date).getTime() / 1E3
    }
    ;
    I.prototype.isCacheEntryStale = function() {
        return (this.storage.getLocal(this.cacheTimestampName) || 0) + this.cacheTTL <= this.getCurrentTimeInSeconds()
    }
    ;
    I.prototype.makeCacheEntryStale = function() {
        this.storage.getLocal(this.cacheTimestampName);
        this.storage.setLocal(this.cacheTimestampName, 0)
    }
    ;
    I.prototype.updateCacheTsBy = function(a) {
        var b = this.storage.getLocal(this.cacheTimestampName) || 0;
        this.storage.setLocal(this.cacheTimestampName, b + Math.min(a, .1 * this.cacheTTL))
    }
    ;
    swymModules.push({
        id: "cache",
        init: function() {
            this.exports("Cache", I)
        }
    });
    y.prototype.makeCacheStale = function() {
        this.mcache = null;
        this.cached && this.lcache.makeCacheEntryStale()
    }
    ;
    y.prototype.isCacheStale = function() {
        return this.cached && this.lcache.isCacheEntryStale()
    }
    ;
    y.prototype.markHashStale = function(a) {
        a = this.hashFn(a);
        this.mcache && (delete this.mcache[a],
        this.cached && this.lcache.putObject(this.mcache))
    }
    ;
    y.prototype.triggerEvent = function(a, b) {
        var c = new SwCustomEvent(a,{
            detail: {
                d: b
            }
        });
        this.evtLayer.dispatchEvent(c);
        return c
    }
    ;
    y.prototype.fetch = function(a) {
        a.params = SwymUtils.extendDefaults(a.params, this.defaultParams);
        var b = a.hash || this.hashFn(a.params);
        a.hash = b;
        var c = this.cached && this.lcache.isCacheEntryStale(), d;
        c ? this.mcache = {} : (this.mcache || (this.mcache = this.cached ? this.lcache.getObject() || {} : {},
        this.triggerEvent("cacheloaded", this.mcache)),
        d = this.mcache[b],
        SwymUtils.isUndefined(d) && a.allowCacheMiss && (d = null));
        var e = this;
        SwymUtils.isUndefined(d) ? this.inProgress[b] ? this.callbacks[b].push(a) : (this.inProgress[b] = !0,
        this.callbacks[b] = [a],
        a.lcb && a.lcb(a),
        c && this.preloadCache ? this.preloadInProgress || (this.preloadInProgress = !0,
        this.preloadCacheFn(function(b) {
            e.preloadInProgress = !1;
            e.cacheLoadScb(a, b)
        }, function(b, c) {
            e.preloadInProgress = !1;
            e.cacheLoadFcb(a, b, c)
        })) : this.internalFn(a, function(b) {
            e.internalScb(a, b)
        }, function(b, c) {
            e.internalFcb(a, b, c)
        })) : (this.callbacks[b] = this.callbacks[b] || [],
        this.callbacks[b].push(a),
        setTimeout(function() {
            e.handleCallbacks(a, d)
        }))
    }
    ;
    y.prototype.internalScb = function(a, b) {
        var c = this.transformFn(b, a)
          , d = a.hash
          , e = {
            opts: a,
            ret: c,
            oret: b
        };
        this.mcache || (this.mcache = this.cached && !this.lcache.isCacheEntryStale() ? this.lcache.getObject() || {} : {},
        this.triggerEvent("cacheloaded", this.mcache));
        this.mcache[d] = c;
        this.cached && this.lcache.putObject(this.mcache);
        var g = this;
        setTimeout(function() {
            g.gSEvtNames.forEach(function(a) {
                this.swat.triggerSwymEvent(a + ":" + d, e);
                this.swat.triggerSwymEvent(a, c)
            }, g);
            g.lSEvtNames.forEach(function(a) {
                this.triggerEvent(a + ":" + d, e);
                this.triggerEvent(a, e)
            }, g)
        });
        this.handleCallbacks(a, c)
    }
    ;
    y.prototype.internalFcb = function(a, b, c) {
        var d = this
          , e = a.hash
          , g = {
            opts: a,
            err: b,
            xhr: c
        };
        setTimeout(function() {
            d.gFEvtNames.forEach(function(a) {
                this.swat.triggerSwymEvent(a + ":" + e, g);
                this.swat.triggerSwymEvent(a, g)
            }, d);
            d.lFEvtNames.forEach(function(a) {
                this.triggerEvent(a + ":" + e, g);
                this.triggerEvent(a, g)
            }, d)
        });
        this.handleCallbacks(a, null, b, c)
    }
    ;
    y.prototype.handleCallbacks = function(a, b, c, d) {
        var e = a.hash
          , g = this.callbacks[e] || [];
        this.internalExecCb(g, c ? function(b) {
            b.fcb && b.fcb.apply(this, [c, d, a])
        }
        : function(c) {
            c.scb && c.scb.apply(this, [b, a])
        }
        );
        this.internalExecCb(g, function(k) {
            k.ecb && k.ecb.apply(this, [a, b, c, d])
        });
        delete this.inProgress[e];
        0 == g.length && delete this.callbacks[e]
    }
    ;
    y.prototype.internalExecCb = function(a, b) {
        try {
            for (; 0 < a.length; ) {
                var c = a.shift();
                b.call(this, c)
            }
        } catch (d) {
            SwymUtils.error("InternalExecCb error", d)
        }
    }
    ;
    y.prototype.setPreloadParams = function(a) {
        this.preloadParams = a
    }
    ;
    y.prototype.cacheLoadScb = function(a, b) {
        if (Array.isArray(b))
            b.forEach(function(a, b) {
                var c = this.preloadHashFn(a, b);
                this.internalScb({
                    params: {},
                    hash: c,
                    fromPreload: !0
                }, this.preLoadTransformFn ? this.preLoadTransformFn(a) : a)
            }, this);
        else if (0 < Object.keys(b).length)
            for (var c in b) {
                var d = b[c]
                  , e = this.preloadHashFn(d, c);
                this.internalScb({
                    params: {},
                    hash: e,
                    fromPreload: !0
                }, this.preLoadTransformFn ? this.preLoadTransformFn(d) : d)
            }
        else
            a.allowCacheMiss && this.internalScb({
                params: {},
                hash: a.hash,
                fromPreload: !0
            }, null)
    }
    ;
    y.prototype.cacheLoadFcb = function(a, b, c) {
        this.internalFcb(a, b, c)
    }
    ;
    y.prototype.addCallback = function(a) {
        var b = this.hashFn(a);
        this.inProgress[b] = !0;
        this.callbacks[b] = this.callbacks[b] || [];
        this.callbacks[b].push(a)
    }
    ;
    y.prototype.isInProgress = function(a) {
        a = this.hashFn(a);
        return this.inProgress[a]
    }
    ;
    swymModules.push({
        id: "fmodel",
        init: function() {
            y.swat = y.prototype.swat = this;
            y.defaultOpts = y.prototype.defaultOpts = {
                cached: !0,
                expiry: 300,
                cacheStaleEvts: [h.JSEvents.regidRefreshed, h.JSEvents.regidCleaned],
                lSEvtNames: ["change"],
                gSEvtNames: [],
                lFEvtNames: ["failure"],
                gFEvtNames: [],
                hashFn: function(a) {
                    return SwymUtils.getHashCode(JSON.stringify(a))
                },
                transformFn: function(a, b) {
                    return a
                },
                preloadCache: !1,
                preloadCacheFn: null,
                preloadHashFn: null,
                preLoadTransformFn: null,
                defaultParams: {}
            };
            this.FetchModel = y
        }
    });
    var Kb = {
        init: function() {},
        instruments: {},
        events: {},
        cfg: {}
    };
    h.prototype.loadModule = function(a) {
        try {
            a = SwymUtils.extendDefaults(a, Kb);
            SwymUtils.log("Module loading - " + a.id);
            for (var b in a.instruments)
                h.Instrumentation[b] = a.instruments[b];
            for (b in a.events)
                h.JSEvents[b] = a.events[b];
            for (b in a.cfg)
                bb[b] = a.cfg[b];
            a.init.apply(this, [this]);
            SwymUtils.log("Module loaded - " + a.id)
        } catch (c) {
            SwymUtils.error("Error loading swymModule - " + a.id, c)
        }
    }
    ;
    h.prototype.exports = function(a, b) {
        this[a] = b
    }
    ;
    h.prototype.setSwymEmail = function(a) {
        this.set(this.key.EMAIL, a)
    }
    ;
    h.prototype.getSwymEmail = function() {
        return this.get(this.key.EMAIL)
    }
    ;
    h.prototype.setSwymUserPref = function(a) {
        this.set(this.key.UPREF, a)
    }
    ;
    h.prototype.getSwymUserPref = function() {
        return this.get(this.key.UPREF)
    }
    ;
    h.prototype.setSwymAuthn = function(a) {
        this.set(this.key.AUTHN, a)
    }
    ;
    h.prototype.isSwymAuthn = function() {
        return null != this.getSwymEmail()
    }
    ;
    h.prototype.get = function(a) {
        return a == this.key.PID ? this.pid : this.storage.get(a)
    }
    ;
    h.prototype.set = function(a, b) {
        this.key.PID == a && (this.pid = b);
        this.storage.set(a, b)
    }
    ;
    h.prototype.removeUserFromDeviceBadAuth = function(a, b) {
        var c = this;
        this.removeUserFromDeviceInternal(function() {
            c.set(c.key.MISAUTHCHK, !0);
            a && a()
        }, b)
    }
    ;
    h.prototype.refresh = function(a, b) {
        var c = this;
        if (this.get(this.key.REGID))
            this.api.authCheck(a, b);
        else {
            var d = c.getSwymRegistrationId();
            d || (c.isRegistering = !0);
            this.swymApiPost({
                endpoint: "/register",
                v3: !0,
                callbackFn: function(b, g) {
                    la(c, d, b.regid, a)
                },
                errorFn: b,
                sendRegId: !1,
                sendSessionId: !1,
                checkRegId: !1
            })
        }
    }
    ;
    h.prototype.countInternal = function(a, b, c, d, e, g) {
        this.swymApi({
            endpoint: "/eventcount",
            params: {
                du: d,
                et: a,
                epi: g,
                type: e
            },
            callbackFn: b,
            errorFn: c,
            checkRegId: !1,
            v2: !0
        })
    }
    ;
    h.prototype.socialCount = function(a, b, c, d, e, g) {
        this.swymApi({
            endpoint: "/product/social-count",
            params: {
                du: c,
                pid: e,
                empi: d,
                topic: g
            },
            callbackFn: a,
            errorFn: b,
            checkRegId: !1,
            noProvider: !0,
            v3: !0
        })
    }
    ;
    h.prototype.sendInternal = function(a, b, c) {
        a.et == this.EventTypes.addToWishList && this.storage.setSessionData(this.key.SVD, 1);
        if (a.cprops && "object" !== typeof a.cprops)
            throw Error("cprops should be an object");
        this.platform && this.platform.getCurrentCartId && (a.cart = this.platform.getCurrentCartId());
        this.triggerSwymEvent(h.JSEvents.beforeCollect, a);
        var d = this
          , e = !1;
        a = X(a);
        if (a.epi && a.empi && !a.pr && !a.iu && (e = !0,
        this.findProduct)) {
            var g = this.findProduct(a.epi, !0)
              , k = a.et;
            g && (a = Object.assign(a, g),
            a.et = k)
        }
        var l = d.getSwymRegistrationId();
        l || (d.isRegistering = !0);
        g = a.currEt;
        delete a.currEt;
        g = a.et == this.EventTypes.addToWishList || g == this.EventTypes.addToWishList;
        this.isSimpleWishlistOnly() || this.isNonFetchUI();
        a.iu && (a.iu = SwymUtils.wrapUrlWithHTTPS(a.iu));
        this.swymApiPost({
            endpoint: g ? e ? "/epiRecordWishlist" : "/recordWishlistAction" : "/collect",
            params: {
                event: a
            },
            callbackFn: function(a, c) {
                la(d, l, a.regid);
                b && b(a, c)
            },
            errorFn: c,
            checkRegId: !1,
            v2: !0
        })
    }
    ;
    h.prototype.allGetInternal = function(a, b) {
        var c = this;
        if (this.retailerSettings) {
            var d = {};
            if (!this.getSwymRegistrationId())
                this.productEts.addCallback(d),
                this.productEts.cacheLoadScb(d, [[]]);
            else if (!(this.authn.isInProgress(d) && this.currDevice.isInProgress(d) && this.productEts.isInProgress(d))) {
                this.authn.addCallback(d);
                this.productEts.addCallback(d);
                this.currDevice.addCallback(d);
                var e = this.isSimpleWishlistOnly()
                  , g = this.isNonFetchUI()
                  , k = this.get(this.key.SVD);
                null === k || 1 == k || this.isAlreadyAuth();
                this.swymApiPost({
                    endpoint: "/get",
                    params: {
                        f: g ? "noFetch" : e ? "fetchWishlist" : "fetch"
                    },
                    callbackFn: function(b, k) {
                        c.currDevice.cacheLoadScb(d, [b.devices]);
                        c.authn.cacheLoadScb(d, [b.authn]);
                        c.productEts.cacheLoadScb(d, [b.fetch]);
                        a && a(b, k)
                    },
                    errorFn: b,
                    v2: !0,
                    waitForRegister: !0
                })
            }
        }
    }
    ;
    h.prototype.sendEmailWishListInternal = function(a, b, c, d, e, g) {
        if (!SwymUtils.validateEmail(a))
            throw Error("Invalid email address");
        a = {
            toemail: a.toLowerCase(),
            fromemail: b,
            note: c
        };
        d && (a.hashtag = d);
        this.swymApiPost({
            endpoint: "/emailWishListCollection",
            params: a,
            callbackFn: e,
            errorFn: g,
            checkRegId: !0,
            sendSessionId: !0,
            v2: !0
        })
    }
    ;
    h.prototype.readRetailerConfig = function(a, b) {
        var c = this
          , d = this.storage.getLocal(this.key.RSETCACHE) || {}
          , e = this.storage.getLocal(this.key.RAPPSCACHE) || this.appsCache || [];
        this.appsCache = e;
        c.versionChecking ? (this.evtLayer.addEventListener(this.JSEvents.readApps, function(a) {
            a = a.detail.d;
            c.appsCache = a;
            c.storage.setLocal(c.key.RAPPSCACHE, a)
        }),
        this.evtLayer.addEventListener(this.JSEvents.readSettings, function(e) {
            e = e.detail.d;
            for (var k in e)
                d[k] = e[k];
            k = c.storage.getLocal(c.key.RAPPSCACHE) || c.appsCache;
            c.storage.setLocal(c.key.RSETCACHE, d);
            d.ignoreCache && c.clearSettingsCache(!0);
            d.v ? a && a(d, k, !0) : (SwymUtils.log("Error loading retailer config", !0),
            b && b(d, e))
        })) : setTimeout(function() {
            a && a(d, e, !1)
        }, 10)
    }
    ;
    h.prototype.remoteAuthRequestInternal = function(a, b, c) {
        if (!SwymUtils.validateEmail(a))
            throw Error("Invalid email address");
        var d = this
          , e = this.get(this.key.REMOTEAUTH);
        e && 1 !== e || this.swymApiPost({
            endpoint: "/remote/request",
            params: {
                email: a.toLowerCase()
            },
            callbackFn: function(a) {
                d.set(d.key.REMOTEAUTH, 1);
                d.storage.setSessionData(d.key.IGNOREAUTHCACHE, 1);
                b && b(a)
            },
            errorFn: c,
            v3: !0
        })
    }
    ;
    h.prototype.removeUserFromDeviceInternal = function(a, b) {
        if (1 == this.isSwymAuthn()) {
            var c = this;
            this.swymApiPost({
                endpoint: "/user/remove",
                callbackFn: function(b, e) {
                    var g = b.regid;
                    g && (c.set(c.key.REGID, g),
                    c.setSwymEmail(null),
                    SwymUtils.log("Registration id refreshing.." + g),
                    c.get(c.key.REMOTEAUTH) && c.storage.remove(c.key.REMOTEAUTH));
                    c.triggerSwymEvent(h.JSEvents.regidRefreshed, {
                        regid: g,
                        disconnect: !0
                    });
                    a && a(g)
                },
                errorFn: function(a) {
                    SwymUtils.log("Unable to remove this device");
                    b && b(a)
                },
                v3: !0
            })
        }
    }
    ;
    h.prototype.send = function(a, b, c) {
        var d = window._swat;
        if ("loading" != document.readyState)
            d.sendInternal(a, b, c),
            h.prototype.send = function(a, b, c) {
                d.sendInternal(a, b, c)
            }
            ;
        else
            SwymUtils.onDOMReady(function() {
                d.sendInternal(a, b, c);
                h.prototype.send = function(a, b, c) {
                    d.sendInternal(a, b, c)
                }
            })
    }
    ;
    h.prototype.versionCheck = function(a, b) {
        var c = this.storage.get(this.key.O_S)
          , d = this.storage.getLocal(this.key.RSETCACHE);
        if (c && d)
            Fa(d, this);
        else {
            this.versionChecking = !0;
            var d = d || {}
              , e = this;
            if (2 == this.storage.get(this.key.VERSIONCHECKED))
                SwymUtils.warn("Skipping version check"),
                this.versionChecking = !1,
                a && a(!1),
                e.allGetInternal();
            else {
                var g = e.getSwymRegistrationId();
                g || (e.isRegistering = !0);
                var c = {
                    js_v: __SWYM__VERSION__,
                    s_v: d.v || "0-0",
                    f: 1 == this.forceCheckFlag
                }
                  , k = window.Shopify && window.Shopify.theme.theme_store_id;
                k && (c.themeid = k);
                this.swymApiPost({
                    endpoint: "/checkAndGet",
                    params: c,
                    callbackFn: function(b) {
                        e.versionChecking = !1;
                        var c = b.get
                          , d = b.versioncheck
                          , f = b.settings
                          , h = b.apps
                          , x = b.currency
                          , F = b["sms-config"]
                          , E = b.themeversion
                          , q = b["ab-test-config"];
                        if (E) {
                            var H = e.storage.getLocal("thmver") || {}
                              , t = e.storage.getLocal("thmprst") || {};
                            E === H[k] && t[k] ? e.storage.removeLocal("rfrshthmprst") : e.storage.setLocal("rfrshthmprst", !0);
                            H[k] = E;
                            e.storage.setLocal("thmver", H)
                        }
                        x && f && (E = f.settings,
                        E.General.Currency = x,
                        f.settings = E);
                        f && (f.settings.Strings = f.settings.Strings || {},
                        e.triggerSwymEvent(e.JSEvents.preReadSettings, f),
                        f.settings.General.IgnoreCacheTS && new Date < new Date(f.settings.General.IgnoreCacheTS) && (f.ignoreCache = !0),
                        Fa(f, e));
                        if (d)
                            if (e.storage.get(e.key.VERSIONCHECKED))
                                SwymUtils.warn("Swym JS potential version change - Loaded - " + __SWYM__VERSION__);
                            else {
                                e.storage.setSessionData(e.key.VERSIONCHECKED, 1);
                                e.clearSettingsCache();
                                getSwymConfig();
                                d = document.querySelectorAll("script[src*=swym]");
                                x = [];
                                for (E = 0; E < d.length; E++)
                                    x.push(d[E].src);
                                x.forEach(function(a) {
                                    SwymUtils.ajaxOpt({
                                        method: "GET",
                                        url: a,
                                        headers: {
                                            "Cache-Control": "max-age=0"
                                        }
                                    })
                                })
                            }
                        else
                            e.storage.setSessionData(e.key.O_S, !0),
                            e.storage.remove(e.key.VERSIONCHECKED);
                        e.triggerSwymEvent(e.JSEvents.preReadApps, h);
                        e.triggerSwymEvent(e.JSEvents.readApps, h);
                        e.triggerSwymEvent(e.JSEvents.readSettings, f || {});
                        c && (f = {},
                        e.productEts.addCallback(f),
                        e.currDevice.addCallback(f),
                        e.currDevice.cacheLoadScb(f, [c.devices]),
                        e.authn.deviceCleaned || (e.authn.addCallback(f),
                        la(e, g, c.regid),
                        e.authn.cacheLoadScb(f, [c.authn])),
                        e.productEts.cacheLoadScb(f, [c.fetch]));
                        F ? e.storage.setLocal(e.key.SMSCONFIG, F) : e.storage.removeLocal(e.key.SMSCONFIG);
                        q ? e.storage.setLocal(e.key.ABTESTING, q) : e.storage.removeLocal(e.key.ABTESTING);
                        a && a(b)
                    },
                    v3: !0,
                    errorFn: b,
                    sendSessionId: !0,
                    checkRegId: !1
                })
            }
        }
    }
    ;
    h.prototype.setRetailerSettings = function(a) {
        this.retailerSettings = a
    }
    ;
    h.prototype.shouldShowEmail = function() {
        return this.retailerSettings ? this.retailerSettings.Email ? this.retailerSettings.Email.EnableEmailFriend : !0 : !0
    }
    ;
    h.prototype.setCurrency = function(a) {
        this.currency = a || this.currency
    }
    ;
    h.prototype.setCurrentPageData = function(a) {
        this.currentPageData = a || this.currentPageData
    }
    ;
    h.prototype.getCurrentPageData = function() {
        return this.currentPageData
    }
    ;
    h.prototype.fetchCurrentPageData = function(a) {
        a(this.currentPageData)
    }
    ;
    h.prototype.turnOff = function() {
        SwymUtils.addClass(document.body, "swym-turned-off");
        SwymUtils.warn("Turning off");
        for (var a in h.prototype)
            h.prototype[a] = function() {}
    }
    ;
    h.prototype.turnOffApis = function() {
        SwymUtils.warn("Turning off Apis");
        "fetch fetchWrtEventType send versionCheck authCheck devices".split(" ").forEach(function(a) {
            h.prototype[a] = function() {}
        })
    }
    ;
    h.prototype.turnOffTracking = function() {
        SwymUtils.warn("Turning off tracking");
        ["send"].forEach(function(a) {
            h.prototype[a] = function() {}
        })
    }
    ;
    h.prototype.initProductDetailsAPI = function() {
        this.platform.productDetails = new this.FetchModel({
            name: "productDetails",
            cached: !1,
            hashFn: this.platform.productDetailsCfg.hashFn,
            internalFn: this.platform.productDetailsCfg.internalFn,
            preloadHashFn: this.platform.productDetailsCfg.preloadHashFn
        })
    }
    ;
    h.prototype.fetchProductForItem = function(a, b, c) {
        var d = this;
        this.api.getProductDetails(a, function(e) {
            if (e) {
                e = d.platform.transformRawProduct(e);
                var g = e.variants.filter(function(b) {
                    return b.id == a.epi
                })[0];
                b({
                    listItem: a,
                    variantDetail: g,
                    productDetail: e
                })
            } else
                c && c(Error("Unknown product"))
        }, c)
    }
    ;
    h.prototype.fetchProductForItems = function(a, b, c, d, e) {
        var g = this
          , k = {}
          , l = [];
        if (window.Worker && this.createWorker) {
            a = a.map(function(a) {
                a.du = g.platform.getProductUrl(a.du);
                k[a.du] = k[a.du] || [];
                k[a.du].push(a);
                return a.du
            });
            var m = a.length
              , f = function() {
                m--;
                0 >= m && d && d(l)
            };
            SwymUtils.arrayPartition(a, 3).forEach(function(a) {
                g.createWorker({
                    subject: "prefetch-jsons",
                    payload: a
                }, function(a) {
                    if (a.r) {
                        var d = {};
                        d[a.l] = a.r;
                        g.platform.productDetails.cacheLoadScb({}, d);
                        k[a.l].forEach(function(a) {
                            g.fetchProductForItem(a, function(c) {
                                b(c, a);
                                l.push(c);
                                f()
                            }, function(b) {
                                c(b, a);
                                f()
                            })
                        })
                    }
                }, function(a) {
                    console.log("error", arguments);
                    c(a, k[a.l][0]);
                    e && e();
                    f()
                })
            })
        } else
            m = a.length,
            f = function() {
                m--;
                0 >= m && d && d(l)
            }
            ,
            a.forEach(function(a) {
                g.fetchProductForItem(a, function(c) {
                    b(c, a);
                    l.push(c);
                    f()
                }, function(b) {
                    c(b, a);
                    f()
                })
            })
    }
    ;
    h.prototype.getProductDetails = function(a, b, c) {
        this.platform ? (this.platform.productDetails.fetch({
            params: a,
            scb: b,
            fcb: c
        }),
        a = Object.keys(this.platform.productDetails.mcache),
        30 < a.length && delete this.platform.productDetails.mcache[a.pop()]) : c("Swym ecomm-platform not defined")
    }
    ;
    h.prototype.openCartPage = function() {
        this.retailerSettings.General.DisableAutoOpenCart || this.openDirectCartPage()
    }
    ;
    h.prototype.openDirectCartPage = function() {
        this.platform.redirectToCartPage()
    }
    ;
    h.prototype.replayAddToCart = function(a, b, c, d) {
        this.platform.addToCart({
            epi: b,
            product: a,
            callback: c,
            errorCallback: d
        })
    }
    ;
    h.prototype.clearSettingsCache = function(a) {
        this.storage.remove(this.key.O_S);
        this.storage.removeLocal(this.key.RAPPSCACHE);
        this.storage.removeLocal(this.key.RSETCACHE);
        a || (this.forceCheckFlag = !0)
    }
    ;
    h.prototype.getApp = function(a, b) {
        var c = null;
        (b || this.appsCache).forEach(function(b) {
            "string" == typeof b ? b == a && (c = {
                app: a,
                "is-paid": !0,
                enabled: !0,
                settings: this.retailerSettings[a]
            }) : b.app == a && (c = b)
        }, this);
        return c
    }
    ;
    h.prototype.getApps = function() {
        this.appsCache.forEach(function(a) {
            a.settings = this.retailerSettings[a.app]
        }, this);
        return this.appsCache
    }
    ;
    h.prototype.getAllowedApps = function() {
        var a = f.getApp("Wishlist")
          , b = f.getApp("Watchlist")
          , c = [];
        a && c.push(a);
        b && c.push(b);
        return c
    }
    ;
    h.prototype.hidePoweredBy = function() {
        return this.getApps().some(function(a) {
            return a["is-paid"]
        })
    }
    ;
    h.prototype.getEmpisFromProducts = function(a) {
        var b = [];
        a.forEach(function(a) {
            (a = a.empi) && -1 == b.indexOf(a) && b.push(a)
        });
        return b
    }
    ;
    h.prototype.customizeStyleFromSettings = function(a, b) {
        var c = "<style>"
          , d = "custom" == a.LauncherIcon ? a.CustomIcon : a.Icon;
        d && (c += "#swym-plugin #swym-anchor .swym-icon { background: url('" + d + "') !important; background-size: 20px !important;}");
        c = {
            htmlText: c
        };
        this.triggerSwymEvent(this.JSEvents.customizeStyleFromSettings, c);
        c = c.htmlText;
        this.onHostedUI() && (a.UseCustomLauncher = !0);
        this.hidePoweredBy() && (c += ".swym-powered-by{display: none;}");
        a.CustomCSS && (c += "</style><style id='swym-ui-customcss'>" + a.CustomCSS + "</style><style>");
        "custom" == a.LauncherLocation ? a.UseCustomLauncher = !0 : this.evtLayer.addEventListener(this.JSEvents.renderUI, function() {
            document.getElementById("swym-anchor").setAttribute("data-position", a.LauncherLocation || "right")
        });
        if (a.UseCustomLauncher) {
            var c = c + "#swym-anchor { display: none !important; }"
              , e = this;
            if (a.CustomAnchorSelector) {
                SwymUtils.addDOMEventListener(a.CustomAnchorSelector, "click", function(a) {
                    a.preventDefault();
                    a.stopImmediatePropagation();
                    e.ui.open()
                });
                for (var d = document.querySelectorAll(a.CustomAnchorSelector), g = 0; g < d.length; g++) {
                    var k = d[g];
                    k.onclick = null;
                    SwymUtils.addClass(k, "swym-loaded")
                }
            } else
                "custom" != a.LauncherLocation && SwymUtils.warn("ui.CustomAnchorSelector not found in config")
        }
        a.NotificationOnly ? c += "#swym-anchor { display: none !important; }.swym-view-history { display: none !important; }" : a.Enabled || (c += "#swym-anchor { display: none !important; }");
        return c += "</style>"
    }
    ;
    h.prototype.initializeUi = function(a) {
        var b = this
          , c = b.retailerSettings.General.IsHTC
          , d = b.retailerSettings.UI
          , e = b.retailerSettings.Wishlist;
        watchlist = b.retailerSettings.Watchlist;
        sa = b.retailerSettings.SA;
        if (SwymUtils.isElementAvailable("#swym-plugin"))
            SwymUtils.warn("Tried to load UI Twice"),
            a && a(!1);
        else if (SwymUtils.matchURLInArray(d.DisallowedURLPatterns || []))
            (c = document.querySelector("#swym-plugin")) && SwymUtils.addClass(c, "swym-disallowed"),
            d.Enabled = !1,
            e.Enabled = !1,
            watchlist.Enabled = !1,
            a(!1);
        else {
            var g = watchlist.UsesAppEmbedBlock
              , k = window.swymWatchlistEmbedBlockLoaded;
            g && k && window.swymSnippetNotLoadedFromThemeFiles && !window.swymWishlistEmbedLoaded ? (d.Enabled = !1,
            e.Enabled = !1,
            SwymUtils.warn("Snippet is not part of the theme files. Ignore if Wishlist Plus is disabled on live theme")) : e.IsAppEmbed && !window.swymWishlistEmbedLoaded ? (d.Enabled = !1,
            e.Enabled = !1) : g && !k && (watchlist.Enabled = !1,
            SwymUtils.warn("App Embed Block for Back in Stock App is Disabled on Live Theme. Hence, disabling Watchlist."));
            var l = function() {
                var c = ""
                  , e = document.createElement("div");
                e.id = "swym-styles";
                c += b.customizeStyleFromSettings(d, b.retailerSettings);
                e.innerHTML = c;
                document.body.appendChild(e);
                SwymUtils.getBodyTemplate(function(c) {
                    var e = document.createElement("div");
                    e.setAttribute("id", "swym-container");
                    b.retailerSettings.Templates = SwymUtils.extendDefaults(b.retailerSettings.Templates || {}, Jb);
                    e.innerHTML = c;
                    document.body.appendChild(e);
                    b.triggerSwymEvent(b.JSEvents.preRenderUI, d, e);
                    b.ui = new (b.SwymUI ? b.SwymUI : SwymUI);
                    d.NotificationOnly && b.ui.disable();
                    b.triggerSwymEvent(b.JSEvents.renderUI, sa, e);
                    setTimeout(function() {
                        b.ui.onStylesLoaded();
                        a && a(!0)
                    })
                })
            }
              , e = c ? "v3/htc.bundle.js" : "v3/apps.bundle.js"
              , e = window.__SwymUIBundlePath || getSwymConfig().assets + e;
            this._swymUI ? setTimeout(l, 100) : SwymUtils.loadUIBundle(function() {
                l()
            }, e + "?v=" + __SWYM__VERSION__)
        }
    }
    ;
    h.prototype.setupUIModule = function(a, b, c, d, e, g) {
        this.evtLayer.addEventListener(this.JSEvents.initIntegrations, function(k) {
            k = f.getApp(a);
            var l = f.retailerSettings[b];
            null != k && k.enabled || c.forEach(function(a) {
                l[a] = !1
            });
            l.Enabled && (k = l.ToggleSwitchState,
            void 0 == k || k || (l.Enabled = !1));
            l.Enabled ? (d(),
            f.evtLayer.addEventListener(f.JSEvents.customizeStyleFromSettings, function(a) {
                e(a.detail.d)
            })) : g && g()
        })
    }
    ;
    h.prototype.isSimpleWishlistOnly = function() {
        return this.retailerSettings ? this.getApp("Wishlist") && this.retailerSettings.UI.SimpleWishlistOnly : !1
    }
    ;
    h.prototype.checkNonFetchUI = function() {
        if (this.retailerSettings) {
            var a = {
                enabled: !1
            };
            this.nonFetchUI = !(this.getApp("Wishlist") || a).enabled
        } else
            this.nonFetchUI = !0
    }
    ;
    h.prototype.isNonFetchUI = function() {
        "undefined" == typeof this.nonFetchUI && this.checkNonFetchUI();
        return this.nonFetchUI
    }
    ;
    h.prototype.isCollectionsEnabled = function() {
        return this.retailerSettings ? this.retailerSettings.Wishlist.EnableCollections : !1
    }
    ;
    h.prototype.initCustomLaunchPoints = function() {
        var a = this;
        a.utils.forEachElement('a[href*="#swym-wishlist"]:not([data-swym-loaded="true"])', function(b) {
            b.setAttribute("data-swym-loaded", !0);
            a.utils.addEvent(b, "click", function(b) {
                b.preventDefault();
                a.ui.open()
            })
        });
        a.utils.forEachElement('a[href="#swym-sfl"]:not([data-swym-loaded="true"])', function(b) {
            b.setAttribute("data-swym-loaded", !0);
            a.utils.addEvent(b, "click", function(b) {
                b.preventDefault();
                a.ui.openSFL()
            })
        })
    }
    ;
    h.prototype.getHostedURL = function() {
        var a = this.retailerSettings && this.retailerSettings.General && this.retailerSettings.General.LocalePath ? this.retailerSettings.General.LocalePath.split(".").reduce(function(a, c) {
            return a && a[c]
        }, window.Shopify) : ""
          , a = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "") || a
          , a = "/" == a.charAt(a.length - 1) ? a.slice(0, -1) : a;
        return this.retailerSettings && this.retailerSettings.General.HostedPages && this.retailerSettings.General.HostedPages.Wishlist ? a + this.retailerSettings.General.HostedPages.Wishlist : "/apps/swymWishlist/wishlist/index.php"
    }
    ;
    h.prototype.getHostedShareURL = function() {
        return this.retailerSettings && this.retailerSettings.General.HostedPages && this.retailerSettings.General.HostedPages.SharedWishlist ? this.retailerSettings.General.HostedPages.SharedWishlist : "/apps/swymWishlist/shared/index.php"
    }
    ;
    h.prototype.onHostedUI = function() {
        return -1 < window.location.pathname.indexOf(this.getHostedURL())
    }
    ;
    h.prototype.onHostedSFLUI = function() {
        return -1 < window.location.pathname.indexOf(this.getHostedSFLURL())
    }
    ;
    h.prototype.getHostedSFLURL = function() {
        return this.retailerSettings && this.retailerSettings.General.HostedPages && this.retailerSettings.General.HostedPages.SFL ? this.retailerSettings.General.HostedPages.SFL : "/pages/swym-sfl"
    }
    ;
    h.prototype.getHostedShareSFLURL = function() {
        return this.retailerSettings && this.retailerSettings.General.HostedPages && this.retailerSettings.General.HostedPages.SharedSFL ? this.retailerSettings.General.HostedPages.SharedSFL : "/pages/swym-shared-sfl"
    }
    ;
    (function() {
        function a(a) {
            if (!(0 in arguments))
                throw new TypeError("1 argument is required");
            do
                if (this === a)
                    return !0;
            while (a = a && a.parentNode);
            return !1
        }
        if ("HTMLElement"in this && "contains"in HTMLElement.prototype)
            try {
                delete HTMLElement.prototype.contains
            } catch (b) {}
        "Node"in this ? Node.prototype.contains = a : document.contains = Element.prototype.contains = a
    }
    )();
    (function() {
        window.SwymUtils = window.SwymUtils || {};
        SwymUtils.Mustache = window.Mustache;
        SwymUtils.isElementAvailable = function(a) {
            return 0 < document.querySelectorAll(a).length
        }
        ;
        SwymUtils.addClass = function(a, c) {
            a.classList ? c.split(" ").forEach(function(c) {
                a.classList.add(c)
            }) : a.className += " " + c
        }
        ;
        SwymUtils.removeClass = function(a, c) {
            a.classList ? c.split(" ").forEach(function(c) {
                a.classList.remove(c)
            }) : a.className = a.className.replace(new RegExp("(^|\\b)" + c.split(" ").join("|") + "(\\b|$)","gi"), " ")
        }
        ;
        SwymUtils.removeSelectedElement = function(a) {
            a && (a = document.querySelector(a)) && a.parentNode.removeChild(a)
        }
        ;
        SwymUtils.showElem = function(a, c) {
            a && (a.style.display = c || "")
        }
        ;
        SwymUtils.hideElem = function(a, c) {
            a && (a.style.display = c || "none")
        }
        ;
        SwymUtils.hasClass = function(a, c) {
            return a.classList ? a.classList.contains(c) : (new RegExp("(^| )" + c + "( |$)","gi")).test(a.className)
        }
        ;
        SwymUtils.removeClosestElem = function(a, c) {
            a && c && a.closest(c).remove()
        }
        ;
        SwymUtils.toggleClass = function(a, c) {
            if (a.classList)
                return a.classList.toggle(c);
            for (var d = a.className.split(" "), e = -1, g = d.length; g--; )
                d[g] === c && (e = g);
            g = !1;
            0 <= e ? d.splice(e, 1) : (d.push(c),
            g = !0);
            a.className = d.join(" ");
            return g
        }
        ;
        SwymUtils.addElementDOMEventListener = function(a, c, d, e, g) {
            a = c.querySelectorAll(a);
            [].forEach.call(a, function(a) {
                a.addEventListener(d, function(a) {
                    e.call(g, a)
                })
            }, this)
        }
        ;
        SwymUtils.addDOMEventListener = function(a, c, d, e) {
            SwymUtils.addElementDOMEventListener(a, document, c, d, e)
        }
        ;
        SwymUtils.elemOffset = function(a) {
            var c, d;
            d = a.getBoundingClientRect();
            if (d.width || d.height || a.getClientRects().length)
                return c = a.ownerDocument,
                a = window,
                c = c.documentElement,
                {
                    top: d.top + a.pageYOffset - c.clientTop,
                    left: d.left + a.pageXOffset - c.clientLeft
                }
        }
        ;
        SwymUtils.elemPosition = function(a) {
            a = SwymUtils.elemOffset(a);
            return {
                top: a.top - (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0),
                left: a.left - (window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0)
            }
        }
        ;
        SwymUtils.modalPosition = function(a, c, d) {
            var e = {}
              , g = SwymUtils.elemPosition(a)
              , k = SwymUtils.viewport();
            e.top = Math.min(g.top + a.offsetHeight + 15, k.height - d - 15);
            650 > k.width ? (e.top = Math.min(150, e.top),
            e.left = e.right = 15) : (e.left = Math.min(g.left - a.offsetWidth - 15 - c / 4, k.width - c - 15),
            e.left = Math.max(15, e.left),
            e.right = Math.max(k.width - (e.left + c), 15));
            return e
        }
        ;
        SwymUtils.onDOMReady = function(a, c) {
            "loading" != document.readyState ? a(c) : document.addEventListener("DOMContentLoaded", function() {
                a(c)
            })
        }
        ;
        SwymUtils.findAncestor = function(a, c) {
            for (; (a = a.parentElement) && !a.classList.contains(c); )
                ;
            return a
        }
        ;
        SwymUtils.addEvent = function(a, c, d) {
            a.attachEvent ? a.attachEvent("on" + c, d) : a.addEventListener(c, d)
        }
        ;
        SwymUtils.addEventDelegate = function(a, c, d, e) {
            a.addEventListener(c, function(c) {
                for (var k = a.querySelectorAll(d), l = c.target, m = 0, f = k.length; m < f; m++)
                    for (var h = l, n = k[m]; h && h !== a; ) {
                        if (h === n)
                            return e.call(n, c);
                        h = h.parentNode
                    }
            })
        }
        ;
        SwymUtils.forEachNodeElem = function(a, c) {
            for (var d = 0, e = a.length; d < e; d++)
                c(a[d])
        }
        ;
        SwymUtils.forEachElement = function(a, c, d) {
            a = (d || document).querySelectorAll(a);
            this.forEachNodeElem(a, c)
        }
        ;
        SwymUtils.createElement = function(a) {
            var c = document.createDocumentFragment()
              , d = document.createElement("div");
            d.innerHTML = a;
            a = d.children[0];
            SwymUtils.addClass(a, "swym-inject");
            c.appendChild(a);
            return a
        }
        ;
        SwymUtils.viewport = function() {
            var a = window
              , c = "inner";
            "innerWidth"in window || (c = "client",
            a = document.documentElement || document.body);
            return {
                width: a[c + "Width"],
                height: a[c + "Height"]
            }
        }
        ;
        SwymUtils.isTouchDevice = function() {
            return "ontouchstart"in window || 0 < navigator.MaxTouchPoints || 0 < navigator.msMaxTouchPoints
        }
        ;
        SwymUtils.getClosest = function(a, c) {
            for (var d = c.charAt(0); a && a !== document; a = a.parentNode)
                if ("." === d && a.classList.contains(c.substr(1)) || "#" === d && a.id === c.substr(1) || "[" === d && a.hasAttribute(c.substr(1, c.length - 2)) || a.tagName.toLowerCase() === c)
                    return a;
            return !1
        }
        ;
        SwymUtils.getParent = function(a) {
            return (a = a.parentNode) && 11 !== a.nodeType ? a : null
        }
        ;
        SwymUtils.removeEvent = function(a, c, d) {
            a.detachEvent ? a.detachEvent("on" + c, d) : a.removeEventListener(c, d)
        }
        ;
        var a = {};
        SwymUtils.loadTemplate = function(b) {
            var c = a[b];
            if (!c) {
                c = document.getElementById(b);
                if (!c)
                    return SwymUtils.warn("Error cannot find the template #" + b),
                    !1;
                c = c.innerHTML.trim();
                Mustache.parse(c);
                a[Ca] = c
            }
            return c
        }
        ;
        SwymUtils.renderTemplate = function(a, c) {
            var d = SwymUtils.loadTemplate(a);
            if (!d)
                throw Error("Invalid Template", a);
            return SwymUtils.renderTemplateString(d, c)
        }
        ;
        SwymUtils.renderTemplateString = function(a, c) {
            return Mustache.render(a, c)
        }
        ;
        SwymUtils.equalsIgnoreCase = function(a, c) {
            return null == a ? !1 : a.toUpperCase() == c.toUpperCase()
        }
        ;
        SwymUtils.extendDefaults = function(a, c) {
            for (var d in c)
                a.hasOwnProperty(d) || (a[d] = c[d]);
            return a
        }
        ;
        SwymUtils.preventEvtDefault = function(a, c) {
            a.preventDefault();
            a.stopPropagation();
            c && a.stopImmediatePropagation()
        }
        ;
        SwymUtils.insertBefore = function(a, c) {
            var d = SwymUtils.createElement(a);
            c.insertAdjacentElement("beforebegin", d)
        }
        ;
        SwymUtils.appendNode = function(a, c, d) {
            d.parentNode.insertBefore(c, "before" === a ? d : d.nextSibling)
        }
        ;
        SwymUtils.stripHTMLFromString = function(a) {
            return (new DOMParser).parseFromString(a, "text/html").body.textContent || ""
        }
    }
    )();
    h.prototype.swymApi = function(a) {
        a.method = "GET";
        this.swymApiBase(a)
    }
    ;
    h.prototype.swymApiPost = function(a) {
        a.method = "POST";
        this.swymApiBase(a)
    }
    ;
    h.prototype.swymApiPut = function(a) {
        a.method = "PUT";
        this.swymApiBase(a)
    }
    ;
    h.prototype.swymApiDelete = function(a) {
        a.method = "DELETE";
        this.swymApiBase(a)
    }
    ;
    h.prototype.swymApiBase = function(a) {
        a.params && a.params.event && gb(a.params.event);
        G(a, {
            method: "GET",
            avoidPid: !1,
            checkRegId: !0,
            sendSessionId: !0,
            v2: !1,
            v3: !1,
            sendRegId: !0,
            waitForRegister: !1
        });
        var b = this
          , c = window.XMLHttpRequest ? new XMLHttpRequest : new ActiveXObject("Microsoft.XMLHTTP");
        c.onreadystatechange = function() {
            b.handleSwymResponse(c, a.callbackFn, a.errorFn, a.params, a)
        }
        ;
        a.v3 ? this.sendRequestV3(c, a) : a.v2 && this.sendRequestV2(c, a)
    }
    ;
    h.prototype.constructSwymUri = function(a, b) {
        b || (b = {});
        var c = this.swymHost + a, d = !0, e;
        for (e in b) {
            var g = b[e];
            M(g) || (d ? (c += "?",
            d = !1) : c += "&",
            "object" === typeof g && (g = JSON.stringify(g)),
            c += e + "=" + encodeURIComponent(g))
        }
        return c
    }
    ;
    h.prototype.constructSwymEndpoint = function(a) {
        return this.swymHost + a
    }
    ;
    h.prototype.processParams = function(a, b) {
        var c;
        if ("GET" == a) {
            b || (b = {});
            c = "";
            var d = !0, e;
            for (e in b) {
                var g = b[e];
                M(g) || (d ? (c += "?",
                d = !1) : c += "&",
                "object" === typeof g && (g = JSON.stringify(g)),
                c += e + "=" + encodeURIComponent(g))
            }
        } else
            c = b ? JSON.stringify(b) : "";
        c = {
            params: b,
            returnVal: c
        };
        this.triggerSwymEvent(h.JSEvents.requestParams, {
            d: c
        });
        return c.returnVal
    }
    ;
    h.prototype.processParamsV2 = function(a, b) {
        b || (b = {});
        var c = "", d = !0, e;
        for (e in b) {
            var g = b[e];
            M(g) || (d ? ("GET" == a && (c += "?"),
            d = !1) : c += "&",
            "object" === typeof g && (g = JSON.stringify(g)),
            c += e + "=" + encodeURIComponent(g))
        }
        c = {
            params: b,
            returnVal: c
        };
        this.triggerSwymEvent(h.JSEvents.requestParams, {
            d: c
        });
        return c.returnVal
    }
    ;
    h.prototype.sendRequestV2 = function(a, b) {
        var c = this.session.getSessionId()
          , d = this.get(this.key.PID)
          , e = this.get(this.key.REGID)
          , g = b.endpoint
          , k = b.method
          , l = b.params || {};
        if (b.checkRegId && !e) {
            SwymUtils.log("No regid found, wait for registration to finish");
            var m = this;
            this.isRegistering || b.waitForRegister ? this.evtLayer.addEventListener(h.JSEvents.registered, function n() {
                SwymUtils.log("Registration finished, continuing");
                m.sendRequestV2(a, b);
                m.evtLayer.removeEventListener(h.JSEvents.registered, n)
            }) : (SwymUtils.log("Registration triggered"),
            this.refresh(function() {
                SwymUtils.log("Registration finished, continuing");
                m.sendRequestV2(a, b)
            }))
        } else if (this.waitForCustomerRefresh && !b.customerRefresh)
            SwymUtils.log("Waiting for customer refresh to finish"),
            m = this,
            this.evtLayer.addEventListener(h.JSEvents.customerInfoRefreshed, function n() {
                m.waitForCustomerRefresh = !1;
                SwymUtils.log("Refresh finished, continuing");
                m.sendRequestV2(a, b);
                m.evtLayer.removeEventListener(h.JSEvents.customerInfoRefreshed, n)
            });
        else {
            var f = this.swymHost + "/api/v2";
            b.avoidPid || (f += "/provider");
            f += g;
            e && b.sendRegId && (l.regid = e);
            c && b.sendSessionId && (l.sessionid = c);
            b.avoidPid || (d = d || l.pid,
            "GET" == k ? l.pid = d : f += "?pid=" + encodeURIComponent(d));
            d = this.processParamsV2(k, l);
            "GET" == k && (f += d,
            d = null);
            c = {
                method: k,
                url: f,
                options: b,
                params: d,
                regid: e,
                sessionid: c
            };
            this.triggerSwymEvent(h.JSEvents.requestOptions, {
                d: c
            });
            a.open(c.method, c.url, !0);
            "GET" != c.method && a.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
            a.send(c.params);
            SwymUtils.log("> " + c.method + " " + c.url)
        }
    }
    ;
    h.prototype.sendRequestV3 = function(a, b) {
        var c = this.session.getSessionId()
          , d = this.get(this.key.PID)
          , e = this.get(this.key.REGID)
          , g = b.endpoint
          , k = b.method
          , f = b.params || {}
          , m = b.queryParams;
        if (b.checkRegId && !e) {
            SwymUtils.log("No regid found, wait for registration to finish");
            var p = this;
            this.isRegistering || b.waitForRegister ? this.evtLayer.addEventListener(h.JSEvents.registered, function F() {
                SwymUtils.log("Registration finished, continuing");
                p.sendRequestV3(a, b);
                p.evtLayer.removeEventListener(h.JSEvents.registered, F)
            }) : (SwymUtils.log("Registration triggered"),
            this.refresh(function() {
                SwymUtils.log("Registration finished, continuing");
                p.sendRequestV3(a, b)
            }))
        } else {
            var r = this.swymHost + "/api/v3";
            b.avoidPid || b.noProvider || (r += "/provider");
            r += g;
            e && b.sendRegId && (f.regid = e);
            c && b.sendSessionId && (f.sessionid = c);
            if ("GET" == k)
                for (var n in m)
                    f[n] = m[n];
            else
                b.avoidPid && (g = SwymUtils.getObjectAsEncoded(m).trim()) && (r += "?" + g);
            b.avoidPid || (d = d || f.pid,
            "GET" == k ? f.pid = d : (r += "?pid=" + encodeURIComponent(d),
            (g = SwymUtils.getObjectAsEncoded(m).trim()) && (r += "&" + g)));
            d = this.processParamsV2(k, f);
            "GET" == k && (r += d,
            d = null);
            c = {
                method: k,
                url: r,
                options: b,
                params: d,
                regid: e,
                sessionid: c
            };
            this.triggerSwymEvent(h.JSEvents.requestOptions, {
                d: c
            });
            a.open(c.method, c.url, !0);
            "GET" != c.method && a.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
            a.send(c.params);
            SwymUtils.log("> " + c.method + " " + c.url)
        }
    }
    ;
    h.prototype.handleSwymResponse = function(a, b, c, d, e) {
        if (4 == a.readyState)
            if (Ga(a)) {
                if (b) {
                    SwymUtils.log("< GET " + a.status + ": " + JSON.stringify(g ? g : {}));
                    var g = a.responseText
                      , g = R(g);
                    b(g, a)
                }
            } else {
                if (a.status)
                    if (this.isBadRegid(a))
                        this.correctRegid(a, e);
                    else if (401 == a.status && (g = a.responseText,
                    g = R(g),
                    "sw-expired-regn" == g.type)) {
                        f.platform && f.platform.refreshCustomerStatus ? (e.expiredFn && e.expiredFn(),
                        f.setSwymEmail(null),
                        f.platform.refreshCustomerStatus(function() {
                            f.swymApiBase(e)
                        })) : this.correctRegid(a, e);
                        return
                    }
                g = a.responseText;
                g = R(g);
                "sw-badregid" == g.type && SwymUtils.getDomainWithoutSubdomain() !== window.location.hostname ? SwymUtils.warn("Server API Error for bad regid, auto cleaning - " + a.status) : SwymUtils.error("Server API Error - " + a.status, Error("Server API Error - " + a.responseText + ", url - " + a.responseURL + ", data - " + JSON.stringify(d)));
                c && (SwymUtils.log("< GET " + a.status + "\n" + a.getAllResponseHeaders()),
                c(a.status, a))
            }
    }
    ;
    h.prototype.isBadRegid = function(a) {
        var b = !1;
        if (400 == a.status && "sw-badregid" == R(a.responseText).type) {
            a = SwymUtils.getDomainWithoutSubdomain();
            if (a !== window.location.hostname) {
                this.storage.remove(this.key.REGID, a);
                this.storage.remove(this.key.INSTRMAP, a);
                this.removeInstrMap();
                this.deviceCache.putObject({});
                this.cleanDevice();
                this.versionCheck();
                return
            }
            a = this.storage.get(this.key.BADRID) || {
                ts: Date.now(),
                cnt: 0
            };
            a.cnt += 1;
            this.storage.setSessionData(this.key.BADRID, a);
            SwymUtils.error("Bad Regid counted - " + a.cnt + " - " + a.ts, Error("BadRegidCounted"), a);
            1 < a.cnt ? (this.storage.remove(this.key.REGID),
            this.storage.remove(this.key.INSTRMAP),
            this.removeInstrMap(),
            this.deviceCache.putObject({}),
            SwymUtils.error("Bad Regid cleared - " + this.storage.get(this.key.REGID), Error("BadRegidCleared"), {
                r: this.key.REGID,
                i: this.key.INSTRMAP
            })) : SwymUtils.error("Bad Regid skipped delete", Error("BadRegid"));
            b = !0
        }
        return b
    }
    ;
    h.prototype.correctRegid = function(a, b) {
        var c = this.deviceCache.getObject()
          , d = this;
        (c = c && c["current-device-id"]) && this.swymApiPost({
            v2: !0,
            sendRegId: !1,
            sendSessionId: !1,
            checkRegId: !1,
            endpoint: "/correct-reg",
            params: {
                di: c
            },
            callbackFn: function(a, c) {
                var k = a.regid;
                k ? (d.set(d.key.REGID, k),
                d.triggerSwymEvent(h.JSEvents.regidRefreshed, k),
                d.correctInstrumentation(k),
                d.swymApiBase(b)) : SwymUtils.error("Unable to reconcile regid 200 - ", {}, a)
            },
            errorFn: function(a) {
                SwymUtils.error("Unable to reconcile regid - ", {}, a)
            }
        })
    }
    ;
    (function() {
        window.SwymUtils = window.SwymUtils || {};
        var a = /([^?=&]+)(=([^&]*))?/g;
        SwymUtils.getEncodedAsObject = function(b, c) {
            var d = {};
            try {
                b.replace(a, function(a, b, e, k) {
                    a = decodeURIComponent(k);
                    d[b] = c ? c(a) : a
                })
            } catch (e) {
                SwymUtils.error("Invalid URI passed - " + b, e)
            }
            return d
        }
        ;
        SwymUtils.getObjectAsEncoded = function(a) {
            var b = [], c;
            for (c in a)
                a.hasOwnProperty(c) && b.push(encodeURIComponent(c) + "=" + encodeURIComponent(a[c]));
            return b.join("&")
        }
        ;
        SwymUtils.getObjectAsEncodedNested = function(a, b, c) {
            c = c || [];
            b = b || "__$key$__";
            for (var d in a)
                a.hasOwnProperty(d) && ("object" == typeof a[d] ? this.getObjectAsEncodedNested(a[d], d + "[__$key$__]", c) : c.push(encodeURIComponent(b.replace("__$key$__", d)) + "=" + encodeURIComponent(a[d])));
            return c.join("&")
        }
        ;
        SwymUtils.log = function(a, b) {
            getSwymConfig().debug && console.log("Swym", a)
        }
        ;
        SwymUtils.arrayFlat = function(a) {
            var b = [];
            if (!Array.isArray(a))
                return a;
            a.map(function(a) {
                return a && a.items ? b.push.apply(b, [].concat($jscomp.arrayFromIterable(a.items))) : b.push(a)
            });
            return b
        }
        ;
        SwymUtils.warn = function(a, b) {
            console.warn("Swym", a)
        }
        ;
        SwymUtils.error = function(a, b, c) {
            console.error("Swym", a, b, c);
            window._SwymLTracker && _SwymLTracker.push({
                msg: a,
                category: "Swym-Error",
                exception: {
                    name: b.name,
                    message: b.message,
                    stack: b.stack,
                    url: JSON.stringify(location.href),
                    obj: c
                }
            })
        }
        ;
        SwymUtils.annotateLog = function(a) {
            var b = typeof a;
            if (!a || "object" !== b && "string" !== b)
                return a;
            "string" === b && (a = {
                text: a
            });
            b = (b = B.deviceCache.getObject()) && b["current-device-id"];
            a.regid = B.getSwymRegistrationId();
            a.deviceid = b;
            a.useragent = window.navigator.userAgent;
            a.v = __SWYM__VERSION__;
            a.url = location.href;
            a.pid = B.get(B.key.PID);
            return a
        }
        ;
        SwymUtils.annotateUrl = function(a, b, c, d) {
            if (!a || "string" !== typeof a)
                return a;
            a = -1 != a.indexOf("?") ? a + "&" : a + "?";
            return a += "utm_source=" + f.SwymPrefix + b + "&utm_medium=" + c + "&utm_campaign=" + d
        }
        ;
        SwymUtils.loadHTML = function(a, b, c) {
            SwymUtils.ajaxGET(a, function(a) {
                if (200 == a.status) {
                    var d = document.createElement("div");
                    d.innerHTML = a.responseText;
                    b(d, a)
                } else
                    c(a.status, a)
            }, null)
        }
        ;
        SwymUtils.matchURLInArray = function(a, b) {
            if (!a)
                return null;
            b = b || location.href;
            for (var c = b.split("?")[0], d = 0; d < a.length; d++) {
                var e = a[d];
                if (-1 != c.search(new RegExp(e,"i")))
                    return e
            }
            return null
        }
        ;
        SwymUtils.ajax = function(a, b, c, d, e) {
            SwymUtils.ajaxOpt({
                method: a,
                url: b,
                data: c,
                callback: d,
                ctx: e
            })
        }
        ;
        SwymUtils.ajaxOpt = function(a) {
            var b = a.data
              , c = a.callback
              , d = a.ctx
              , e = a.headers
              , g = new XMLHttpRequest;
            g.open(a.method, a.url, !0);
            g.isSwymUIAction = !0;
            g.timeout = 1E4;
            g.onreadystatechange = function() {
                4 == g.readyState && c && c.apply(d, [g])
            }
            ;
            a = !1;
            if (e)
                for (var f in e)
                    g.setRequestHeader(f, e[f]),
                    "Content-Type" == f && (a = !0);
            b && !a && g.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            g.send(b)
        }
        ;
        SwymUtils.ajaxGET = function(a, b, c) {
            this.ajax("GET", a, null, b, c)
        }
        ;
        SwymUtils.getPageURL = function() {
            var a = document.querySelector("link[rel=canonical]");
            return a ? a.href : document.URL
        }
        ;
        SwymUtils.getPageURLAsLocation = function() {
            return SwymUtils.getURLAsLocation(SwymUtils.getPageURL())
        }
        ;
        SwymUtils.getURLAsLocation = function(a) {
            var b = document.createElement("a");
            b.href = a;
            return b
        }
        ;
        SwymUtils.updateToCurrentDomain = function(a) {
            var b = SwymUtils.getURLAsLocation(a);
            if (b.host === window.location.host)
                return a;
            b.host = window.location.host;
            return b.href
        }
        ;
        var b = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        SwymUtils.validateEmail = function(a) {
            return b.test(a)
        }
        ;
        var c = /^\+?(?:[0-9] ?){6,14}[0-9]$/;
        SwymUtils.validatePhoneNumber = function(a) {
            return c.test(a)
        }
        ;
        var d = /^\d{6}$/;
        SwymUtils.validateOTP = function(a) {
            return d.test(a)
        }
        ;
        SwymUtils.validateUrl = function(a) {
            return -1 < a.search(/http:|https:/)
        }
        ;
        SwymUtils.getHashCode = function(a) {
            var b = 0, c, d, e;
            if (0 === a.length)
                return b;
            c = 0;
            for (e = a.length; c < e; c++)
                d = a.charCodeAt(c),
                b = (b << 5) - b + d,
                b |= 0;
            return b
        }
        ;
        SwymUtils.loadUIBundle = function(a, b) {
            SwymUtils.loadJsCssfile(b, "js", function() {
                a()
            })
        }
        ;
        SwymUtils.getBodyTemplate = function(a) {
            if (null == Ba) {
                var b = getSwymConfig().assets + "swym-body.js";
                SwymUtils.loadJsCssfile(b, "js", function() {
                    SwymUtils.getBodyTemplate(a)
                })
            } else
                setTimeout(function() {
                    a(Ba);
                    Ba = null
                }, 0)
        }
        ;
        SwymUtils.loadResFile = SwymUtils.loadJsCssfile = function(a, b, c, d) {
            var e = document.body;
            e || (e = document.documentElement);
            "js" == b ? (d = document.createElement("script"),
            d.setAttribute("type", "text/javascript"),
            d.async = !1,
            c && (d.onload = c),
            d.setAttribute("src", a),
            e.appendChild(d)) : "image" == b ? (b = new Image,
            b.onerror = d || c,
            b.onload = c,
            b.src = a) : "css" == b && (d = document.createElement("link"),
            d.setAttribute("rel", "stylesheet"),
            d.setAttribute("type", "text/css"),
            d.setAttribute("href", a),
            c && ("onload"in d ? d.onload = c : (b = new Image,
            b.onerror = c,
            b.src = a)),
            e.appendChild(d))
        }
        ;
        SwymUtils.notifyVibrate = function() {
            window.navigator.vibrate && window.navigator.vibrate(200)
        }
        ;
        SwymUtils.getOGData = function() {
            for (var a = document.querySelectorAll("meta[property^=og],meta[name^=og],meta[name^=product],meta[property^=product]"), b = a.length, c = {}, d = 0; d < b; d++) {
                var e = a[d]
                  , g = e.getAttribute("property") || e.getAttribute("name");
                (e = e.getAttribute("content")) && (c[g] = e)
            }
            return c
        }
        ;
        var e = {
            "og:title": "dt",
            "og:image": "iu",
            "og:price:amount": "pr",
            "og:price:standard_amount": "op",
            "product:original_price:amount": "op",
            "product:price:amount": "pr"
        };
        SwymUtils.getOGDataAsPageMap = function() {
            var a = this.getOGData();
            if ("product" == a["og:type"]) {
                var b = {
                    et: h.EventTypes.productView
                }, c;
                for (c in e)
                    a[c] && (b[e[c]] = a[c]);
                return b
            }
            return null
        }
        ;
        SwymUtils.EmptyFunction = function() {}
        ;
        SwymUtils.removeHash = function() {
            var a, b, c = window.location;
            "pushState"in history || (a = document.body.scrollTop,
            b = document.body.scrollLeft,
            c.hash = "",
            document.body.scrollTop = a,
            document.body.scrollLeft = b)
        }
        ;
        SwymUtils.removeComma = function(a) {
            "string" == typeof a && (a = a.replace(/,/gi, ""));
            return a
        }
        ;
        SwymUtils.getSWAction = function() {
            return (SwymUtils.getParameterByName("swaction") || "").toLowerCase()
        }
        ;
        SwymUtils.isUndefined = function(a) {
            return "undefined" == typeof a
        }
        ;
        SwymUtils.setDefaults = G;
        SwymUtils.getParameterByName = aa;
        SwymUtils.isHttpSuccess = Ga;
        SwymUtils.turnOffInstrumentation = function() {
            this._dontInstrument = !0
        }
        ;
        SwymUtils.turnOnInstrumentation = function() {
            delete this._dontInstrument
        }
        ;
        SwymUtils.appendCustomCSS = function(a) {
            document.querySelector("#swym-styles").querySelector("style:last-child").innerHTML += a
        }
        ;
        var g = /bot|googlebot|crawler|spider|robot|crawling|yandex|Google Web Preview|BingPreview/i;
        SwymUtils.isBot = function() {
            return g.test(navigator.userAgent)
        }
        ;
        SwymUtils.preventDefault = function(a) {
            a.preventDefault()
        }
        ;
        SwymUtils.debounce = function(a, b, c) {
            var d = null;
            c = c || 1;
            var e = 0;
            return function() {
                var g = this
                  , f = arguments;
                clearTimeout(d);
                e++;
                d = setTimeout(function() {
                    d = null;
                    e = 0;
                    a.apply(g, f)
                }, b * Math.min(e, c))
            }
        }
        ;
        SwymUtils.serializeForm = function(a, b) {
            if (a && "FORM" === a.nodeName) {
                var c, d, e = [];
                for (c = a.elements.length - 1; 0 <= c; --c)
                    if ("" !== a.elements[c].name)
                        switch (a.elements[c].nodeName) {
                        case "INPUT":
                            switch (a.elements[c].type) {
                            case "text":
                            case "email":
                            case "hidden":
                            case "password":
                            case "button":
                            case "reset":
                            case "submit":
                                e.push(a.elements[c].name + "=" + encodeURIComponent(a.elements[c].value));
                                break;
                            case "checkbox":
                            case "radio":
                                a.elements[c].checked && e.push(a.elements[c].name + "=" + encodeURIComponent(a.elements[c].value))
                            }
                            break;
                        case "TEXTAREA":
                            e.push(a.elements[c].name + "=" + encodeURIComponent(a.elements[c].value));
                            break;
                        case "SELECT":
                            switch (a.elements[c].type) {
                            case "select-one":
                                e.push(a.elements[c].name + "=" + encodeURIComponent(a.elements[c].value));
                                break;
                            case "select-multiple":
                                for (d = a.elements[c].options.length - 1; 0 <= d; --d)
                                    a.elements[c].options[d].selected && e.push(a.elements[c].name + "=" + encodeURIComponent(a.elements[c].options[d].value))
                            }
                            break;
                        case "BUTTON":
                            switch (a.elements[c].type) {
                            case "reset":
                            case "submit":
                            case "button":
                                e.push(a.elements[c].name + "=" + encodeURIComponent(a.elements[c].value))
                            }
                        }
                c = e.join("&");
                return b ? SwymUtils.getEncodedAsObject(c) : c
            }
        }
        ;
        SwymUtils.returnJSONParsed = function(a) {
            return JSON.parse(a.match(/[{].*.[}]/))
        }
        ;
        SwymUtils.arrayPartition = function(a, b) {
            return a.length ? [a.splice(0, b)].concat(SwymUtils.arrayPartition(a, b)) : []
        }
        ;
        SwymUtils.deferredCallback = function(a, b) {
            return setTimeout(function() {
                a()
            }, b)
        }
        ;
        SwymUtils.deepExtendDefaults = function(a, b) {
            for (var c in b) {
                var d = a[c];
                SwymUtils.isUndefined(d) ? a[c] = b[c] : "object" != typeof a[c] || Array.isArray(d) || (a[c] = SwymUtils.deepExtendDefaults(d, b[c]))
            }
            return a
        }
        ;
        SwymUtils.abbrNum = function(a, b) {
            "undefined" == typeof b && (b = 2);
            b = Math.pow(10, b);
            for (var c = ["K", "M", "B", "T"], d = c.length - 1; 0 <= d; d--) {
                var e = Math.pow(10, 3 * (d + 1));
                if (e <= a) {
                    a = Math.round(a * b / e) / b;
                    1E3 == a && d < c.length - 1 && (a = 1,
                    d++);
                    a += c[d];
                    break
                }
            }
            return a
        }
        ;
        SwymUtils.formatProductPrice = function(a) {
            a.cu = f.currency;
            parseFloat(a.op) == parseFloat(a.pr) && delete a.op;
            ["pr", "op"].forEach(function(b) {
                "number" == typeof a[b] ? a[b] = a[b].toFixed(2) : isNaN(parseFloat(a[b])) || (a[b] = parseFloat(a[b]).toFixed(2))
            });
            return a
        }
        ;
        Math.sign || (Math.sign = function(a) {
            return (0 < a) - (0 > a) || +a
        }
        );
        "function" != typeof Object.assign && Object.defineProperty(Object, "assign", {
            value: function(a, b) {
                if (null == a)
                    throw new TypeError("Cannot convert undefined or null to object");
                for (var c = Object(a), d = 1; d < arguments.length; d++) {
                    var e = arguments[d];
                    if (null != e)
                        for (var g in e)
                            Object.prototype.hasOwnProperty.call(e, g) && (c[g] = e[g])
                }
                return c
            },
            writable: !0,
            configurable: !0
        });
        SwymUtils.timeSince = function(a) {
            function b(a, c) {
                return c + " " + B.retailerSettings.Strings[a + (1 < c ? "s" : "")] + " " + B.retailerSettings.Strings.Ago
            }
            a = Math.floor((new Date - a) / 1E3);
            var c = Math.floor(a / 31536E3);
            if (1 <= c)
                return b("Year", c);
            c = Math.floor(a / 2592E3);
            if (1 <= c)
                return b("Month", c);
            c = Math.floor(a / 86400);
            if (1 <= c)
                return b("Day", c);
            c = Math.floor(a / 3600);
            if (1 <= c)
                return b("Hour", c);
            c = Math.floor(a / 60);
            if (1 <= c)
                return b("Minute", c)
        }
        ;
        SwymUtils.formatDeviceCategory = function(a) {
            if (!a)
                return "desktop";
            a = a.toLowerCase();
            return "tablet" == a ? "tablet" : "smartphone" == a ? "mobile" : "desktop"
        }
        ;
        SwymUtils.getCurrentPrimaryUrlWithProtocol = function() {
            return window.location.protocol + "//" + B.getPrimaryDomain()
        }
        ;
        SwymUtils.getUrlWithoutProtocol = function(a) {
            return SwymUtils.getURLAsLocation(a).href.replace(/https:\/\/|http:\/\//, "")
        }
        ;
        SwymUtils.wrapUrlWithHTTPS = function(a) {
            return "https://" + SwymUtils.getUrlWithoutProtocol(a)
        }
        ;
        SwymUtils.deepcopy = function(a) {
            return JSON.parse(JSON.stringify(a))
        }
        ;
        SwymUtils.isValidUserInput = function(a, b) {
            return SwymUtils[a](b)
        }
        ;
        SwymUtils.padDecimal = function(a) {
            return parseFloat(a).toFixed(2)
        }
        ;
        SwymUtils.stripScripts = function(a) {
            for (var b = a.getElementsByTagName("script"), c = b.length; c--; )
                b[c].parentNode.removeChild(b[c]);
            return a
        }
        ;
        SwymUtils.getHostedURL = function() {
            return f.getHostedURL()
        }
        ;
        SwymUtils.onHostedUI = function() {
            return f.onHostedUI()
        }
        ;
        SwymUtils.getHostedShareURL = function() {
            return f.getHostedShareURL()
        }
        ;
        SwymUtils.isDateExpired = function(a) {
            return !!((new Date(a)).getTime() < (new Date).getTime())
        }
        ;
        SwymUtils.getDomainWithoutSubdomain = function() {
            var a = window.location.hostname.split(".");
            return a.slice(0).slice(-(4 === a.length ? 3 : 2)).join(".")
        }
        ;
        SwymUtils.isElementVisible = function(a) {
            return null !== a.offsetParent
        }
        ;
        SwymUtils.shallowCopy = function(a, b) {
            for (var c in b)
                a[c] = b[c]
        }
        ;
        SwymUtils.getLocalizedStrings = function() {
            var a = "en it de es ja fr".split(" ")
              , b = f.appsCache.map(function(a) {
                return a["is-paid"]
            }).includes(!0)
              , c = "en"
              , d = ""
              , d = f.platform.type
              , e = "";
            "Shopify" == d && (e = window.Shopify.theme.id);
            var g = [];
            f.retailerSettings.UI && f.retailerSettings.UI.MultiLanguageDisabledThemes && (g = f.retailerSettings.UI.MultiLanguageDisabledThemes);
            var h = !1;
            f.retailerSettings.UI && f.retailerSettings.UI.EnableMultiLanguage && (h = f.retailerSettings.UI.EnableMultiLanguage);
            var F = function(a) {
                return parseInt(a) == e
            };
            b && h && "Shopify" == d && !g.some(F) && (c = window.Shopify.locale);
            b = c.split("-");
            c = b[0];
            d = 1 < b.length ? c : "";
            b = f.retailerSettings.Strings[d] ? d : f.retailerSettings.Strings[c] ? c : "none";
            a = a.includes(d) ? d : a.includes(c) ? c : "en";
            d = "en it de es ja fr".split(" ").includes(c);
            return {
                locale: c,
                stringFileToLoad: a,
                retailerSettingsStrings: "none" != b ? f.retailerSettings.Strings[b] : "en" != c && d ? {} : f.retailerSettings.Strings
            }
        }
        ;
        SwymUtils.safeJSONParse = R
    }
    )();
    h.JSEvents = h.prototype.JSEvents = {
        renderProducts: "sw:renderproducts",
        beforeRenderProducts: "sw:beforerenderproducts",
        renderInterestedProducts: "sw:renderinterestedproducts",
        renderNewsfeedProducts: "sw:rendernewsfeedproducts",
        beforeRenderProduct: "sw:beforerenderproduct",
        renderProduct: "sw:renderproduct",
        renderRelayUI: "sw:renderui",
        readyRelayUI: "sw:readyui",
        registered: "sw:registered",
        regidRefreshed: "sw:regidrefreshed",
        regidCleaned: "sw:regidcleaned",
        beforeRenderInterestedProducts: "sw:beforerenderinterestedproducts",
        beforeRenderNewsfeedProducts: "sw:beforerendernewsfeedproducts",
        beforeRenderNotification: "sw:beforerendernotification",
        renderNotification: "sw:rendernotification",
        configLoaded: "sw:configloaded",
        processCallbacks: "sw:processcallbacks",
        customizeStyleFromSettings: "sw:customizestylesettings",
        addedToWishlist: "sw:addedtowishlist",
        removedFromWishlist: "sw:removedfromwishlist",
        deletedFromRelay: "sw:deletedfromrelay",
        beforeCollect: "sw:beforecollect",
        trackedPageView: "sw:trackedPageView",
        relayOpened: "sw:uiopened",
        sessionStarted: "sw:sessionstarted",
        sessionCreated: "sw:sessioncreated",
        preReadApps: "sw:prereadapps",
        preReadSettings: "sw:prereadsettings",
        readApps: "sw:readapps",
        readSettings: "sw:readsettings",
        wishlistLinkLoaded: "sw:wishlistlinkloaded",
        watchlistLinkLoaded: "sw:watchlistlinkloaded",
        productImageError: "sw:productimageerror",
        externalRegisterDone: "sw:externalRegisterDone",
        renderUI: "sw:renderui",
        preRenderUI: "sw:prerenderui",
        uiOpened: "sw:uiopened",
        readyUI: "sw:readyui",
        renderProductDetailSlide: "sw:renderproductdetailslide",
        refreshProductDetailSlide: "sw:refreshproductdetailslide",
        changeVariantProductDetailSlide: "sw:changevariantproductdetailslide",
        renderProductDetailSlideError: "sw:renderproductdetailslideerror",
        newProductTracked: "sw:newproducttracked",
        watchlistPopupOpened: "sw:watchlistpopupopened",
        triggerPermissionDialogOpened: "sw:triggerpermissiondialogopened",
        productInvalidOnLoad: "sw:productinvalidonload",
        customerInfoRefreshed: "sw:customerinforefreshed",
        requestOptions: "sw:requestoptions",
        requestParams: "sw:requestparams",
        productsCacheUpdated: "sw:productscacheupdated",
        merchantAuthLoaded: "sw:list:merchantauthloaded",
        addedToSFL: "sw:addedtoSFL",
        removedFromSFL: "sw:removedfromSFL",
        removedAllFromSFL: "sw:removedAllFromSFL",
        movedToCartFromSFL: "sw:movedToCartfromSFL",
        movedAllToCartFromSFL: "sw:movedAllToCartAllFromSFL",
        addedToCartFromSharedSFL: "sw:addedToCartFromSharedSFL",
        addedAllToCartFromSharedSFL: "sw:addedAllToCartFromSharedSFL",
        storeAddedToCart: "sw:storeAddedToCart",
        storeRemovedFromCart: "sw:storeRemovedFromCart",
        UIAddedToCart: "sw:addedtocart",
        UIAddedAllToCart: "sw:addedalltocart",
        UIRemovedFromCart: "sw:removedfromcart",
        StringsLoaded: "sw:stringsLoaded",
        sbisaCTALoaded: "sw:sbisaCTALoaded",
        sflApiLoaded: "sw:sflApiLoaded",
        htcApiLoaded: "sw:htcApiLoaded"
    };
    (function() {
        var a = window.CustomEvent;
        window.SwCustomEvent = function() {
            try {
                var b = new a("cat",{
                    detail: {
                        foo: "bar"
                    }
                });
                return "cat" === b.type && "bar" === b.detail.foo
            } catch (c) {}
            return !1
        }() ? a : "function" === typeof document.createEvent ? function(a, c) {
            var d = document.createEvent("CustomEvent");
            c ? d.initCustomEvent(a, c.bubbles, c.cancelable, c.detail) : d.initCustomEvent(a, !1, !1, void 0);
            return d
        }
        : function(a, c) {
            var d = document.createEventObject();
            d.type = a;
            c ? (d.bubbles = Boolean(c.bubbles),
            d.cancelable = Boolean(c.cancelable),
            d.detail = c.detail) : (d.bubbles = !1,
            d.cancelable = !1,
            d.detail = void 0);
            return d
        }
    }
    )();
    h.prototype.triggerSwymEvent = function(a, b, c) {
        this.extendSession();
        a = new SwCustomEvent(a,{
            detail: {
                d: b,
                e: c
            }
        });
        this.evtLayer.dispatchEvent(a);
        return a
    }
    ;
    h.prototype.extendSession = SwymUtils.debounce(function() {
        this.session.getSessionId()
    }, 100);
    var hb = [], f;
    C.prototype.init = function() {
        var a = f.get(f.key.CLCTMAP);
        a || (a = {});
        if (this.isValid() && (!a.hasOwnProperty(btoa(this.id)) || a[btoa(this.id)] < this.listenThreshold)) {
            var b = this;
            "jsonp" == this.type ? (a = new MutationObserver(function(a) {
                a.forEach(function(a) {
                    for (var c = 0; c < a.addedNodes.length; c++) {
                        var g = a.addedNodes[c];
                        try {
                            var k = g.src;
                            if ("script" == g.tagName.toLowerCase() && -1 < k.toLowerCase().indexOf(b.id.toLowerCase())) {
                                var f = SwymUtils.getEncodedAsObject(k);
                                b.detect(f)
                            }
                        } catch (h) {}
                    }
                })
            }
            ),
            a.observe(b.target, {
                childList: !0
            }),
            this.listener = a) : "form" == this.type ? (a = function(a) {
                try {
                    var d = SwymUtils.serializeForm(b.target, !0);
                    b.detect(d, a)
                } catch (e) {}
            }
            ,
            this.target.addEventListener("submit", a),
            this.listener = a) : "xhrpost" == this.type ? (a = function(a) {
                a = a.detail.d;
                if (-1 < a._swAction.toLowerCase().indexOf(b.id.toLowerCase()))
                    try {
                        if ("json" == b.contentType)
                            var d = JSON.parse(a._swData);
                        else
                            "urlencoded" == b.contentType && (d = SwymUtils.getEncodedAsObject(a._swData));
                        b.detect(d, a)
                    } catch (e) {}
            }
            ,
            f.evtLayer.addEventListener(f.JSEvents.xhrTrap, a),
            this.listener = a) : "xhrget" == this.type ? (a = function(a) {
                a = a.detail.d;
                if (-1 < a._swAction.toLowerCase().indexOf(b.id.toLowerCase()))
                    try {
                        var d = SwymUtils.getEncodedAsObject(a._swAction);
                        b.detect(d, a)
                    } catch (e) {}
            }
            ,
            f.evtLayer.addEventListener(f.JSEvents.xhrTrap, a),
            this.listener = a) : "fetchpost" == this.type ? (a = function(a) {
                a = a.detail.d;
                if (-1 < a._swAction.toLowerCase().indexOf(b.id.toLowerCase()))
                    try {
                        if ("json" == b.contentType)
                            var d = JSON.parse(a._swData);
                        else
                            "urlencoded" == b.contentType && (d = {},
                            a._swData instanceof URLSearchParams || (d = SwymUtils.getEncodedAsObject(a._swData)));
                        b.detect(d, a)
                    } catch (e) {}
            }
            ,
            f.evtLayer.addEventListener(f.JSEvents.fetchTrap, a),
            this.listener = a) : "fetchget" == this.type ? (a = function(a) {
                a = a.detail.d;
                if (-1 < a._swAction.toLowerCase().indexOf(b.id.toLowerCase()))
                    try {
                        var d = SwymUtils.getEncodedAsObject(a._swAction);
                        b.detect(d, a)
                    } catch (e) {}
            }
            ,
            f.evtLayer.addEventListener(f.JSEvents.fetchTrap, a),
            this.listener = a) : "ws" == this.type && (a = function(a) {
                a = a.detail.d;
                if (-1 < a._swAction.toLowerCase().indexOf(b.id.toLowerCase()))
                    try {
                        var d = SwymUtils.returnJSONParsed(a._swData);
                        b.detect(d)
                    } catch (e) {}
            }
            ,
            f.evtLayer.addEventListener(f.JSEvents.wsTrap, a),
            this.listener = a)
        }
    }
    ;
    C.prototype.collect = function(a, b) {
        var c = this;
        setTimeout(function() {
            c.collectImmediate(a, b)
        }, 1E3)
    }
    ;
    C.prototype.collectImmediate = function(a, b) {
        if ("email" != this.detectType || SwymUtils.validateEmail(a))
            f.idCollect(a, this.id, b || "generic"),
            this.destroyCollectListener()
    }
    ;
    C.prototype.destroyCollectListener = function() {
        "jsonp" == this.type ? this.listener.disconnect() : "form" == this.type ? this.target.removeEventListener("submit", this.listener) : "xhrpost" == this.type || "xhrget" == this.type ? f.evtLayer.removeEventListener(f.JSEvents.xhrTrap, this.listener) : "ws" == this.type && f.evtLayer.removeEventListener(f.JSEvents.wsTrap, this.listener)
    }
    ;
    h.prototype.idCollect = function(a, b, c, d) {
        var e = this
          , g = this.storage.getLocal("products")
          , g = null === g ? null : g.all;
        this.swymApiPost({
            endpoint: "/c-id",
            params: {
                e: btoa(a),
                s: btoa(b.toLowerCase()),
                m: btoa(c.toLowerCase()),
                wd: null !== g && 0 !== g.length ? !0 : !1
            },
            callbackFn: function(a, c) {
                var g = btoa(b)
                  , f = e.get(e.key.CLCTMAP);
                f || (f = {});
                f.hasOwnProperty(g) ? f[g] += 1 : f[g] = 1;
                e.set(e.key.CLCTMAP, f);
                d && d(a)
            },
            sendSessionId: !1,
            checkRegId: !0,
            v2: !0
        })
    }
    ;
    swymModules.push({
        id: "id-c",
        init: function() {
            f = this;
            f.retailerSettings ? Ha() : f.evtLayer.addEventListener(f.JSEvents.configLoaded, Ha)
        }
    });
    h.EventTypes = h.prototype.EventTypes = {
        unknownView: 0,
        productView: 1,
        categoryView: 2,
        addToCart: 3,
        addToWishlist: 4,
        addToWishList: 4,
        applyCoupon: 5,
        checkout: 6,
        dropFromCart: 7,
        watchlist: 8,
        lowStock: 9,
        sharedWishlistView: 14,
        loggedIn: 100,
        checkoutBegin: 104,
        checkoutFail: 105,
        cartTotal: 106,
        deleteEvent: -1
    };
    h.ProductLevels = h.prototype.ProductLevels = {
        ProductVariant: "product-variant",
        ProductGroup: "product-group"
    };
    h.EventTypeNames = h.prototype.EventTypeNames = {};
    for (var Ca in h.EventTypes)
        h.EventTypeNames[h.EventTypes[Ca]] = Ca;
    h.Instrumentations = h.prototype.Instrumentations = {
        ChangeTab: 3,
        ItemClickFromRelay: 4,
        UISettings: 5,
        UIWelcome: 6,
        UIFirstAccess: 7,
        UIDisabled: 8,
        UIEnabled: 9,
        UIOpenProductDetails: 20,
        UIProductDetailsForAddToCart: 21,
        UICloseProductDetails: 22,
        UIViewProductDetails: 23,
        UIAddToCart: 24,
        UIOpenFromAnchor: 1,
        UIClose: 2,
        OpenEmailMyFaves: 25,
        EmailedMyFaves: 26,
        UICheckout: 27,
        ItemClickFromProductDetails: 28,
        UIOpenFromTooltip: 29,
        UIAddAllToCart: 30,
        DeleteItem: -1,
        NotificationShown: 11,
        UIOpenFromNotification: 12,
        DismissNotification: 13,
        ItemClickFromNotification: 14,
        RemovedFromNewsfeed: -2,
        ChangeAuthTab: 15,
        WatchlistOpened: 16,
        WatchlistDismissed: 17,
        WidgetItemOpen: 31,
        WidgetItemDetails: 32,
        WidgetAddToCart: 33,
        ShareWishlistHashCreated: 34,
        ShareWishlistViaMedium: 35,
        ConnectForShareWishlistButtonClicked: 36,
        LoginForShareButtonClicked: 37,
        SharedWishlistOpen: 38,
        ChangeHashtag: 41,
        TriggerPermissionDialogOpened: 43,
        TriggerPermissionGranted: 44,
        TriggerPermissionDenied: 45,
        TriggerPermissionDialogClosed: 46,
        OptInFormOpened: 43,
        OptInFormClosed: 45,
        OptInFormSubscribed: 44
    };
    var cb = 1E3;
    h.prototype.getInstrMap = function() {
        var a = this.storage.getLocal(this.key.INSTRMAP) || {};
        return this.instrumentMap = a
    }
    ;
    h.prototype.setInstrMap = function(a) {
        "object" !== typeof a || null === a ? (SwymUtils.warn("Invalid instrument map."),
        this.storage.setLocal(this.key.INSTRMAP, {})) : this.storage.setLocal(this.key.INSTRMAP, a);
        return this.getInstrMap()
    }
    ;
    h.prototype.resetInstrMap = function() {
        this.setInstrMap({})
    }
    ;
    h.prototype.removeInstrMap = function() {
        this.storage.removeLocal(this.key.INSTRMAP)
    }
    ;
    h.prototype.instrument = function(a, b) {
        try {
            if (!SwymUtils._dontInstrument) {
                var c = f.retailerSettings.General.InstrumentMapMaxLength
                  , c = "number" == typeof c ? c : 3500
                  , d = a + Math.sign(a) * cb;
                SwymUtils.log("RAT - " + d + ", data - " + JSON.stringify(b));
                var e = this.getInstrMap();
                "object" !== typeof e && (this.resetInstrMap(),
                e = this.getInstrMap());
                var g = this.get(this.key.REGID);
                if (g) {
                    var k = this.session.getSessionId()
                      , h = window.document.URL
                      , m = (new Date).getTime();
                    b || (b = {});
                    b.ts = m;
                    e[g] || (e[g] = {});
                    e[g][k] || (e[g][k] = {});
                    e[g][k][h] || (e[g][k][h] = {});
                    e[g][k][h][d] || (e[g][k][h][d] = []);
                    e[g][k][h][d].push(b);
                    JSON.stringify(e).length > c ? this.dumpRI(e) : this.setInstrMap(e)
                }
            }
        } catch (p) {
            SwymUtils.warn("Unable to instrument - " + JSON.stringify(p))
        }
    }
    ;
    h.prototype.instrumentV3 = function(a, b) {
        b || (b = {});
        b.v3 = !0;
        this.instrument(a, b)
    }
    ;
    h.prototype.correctInstrumentation = function(a) {
        var b = this.getInstrMap(), c = {}, d;
        for (d in b)
            c[a] = b[d];
        this.setInstrMap(c)
    }
    ;
    h.prototype.cleanCacheEntries = function(a) {
        var b = this.getInstrMap(), c;
        for (c in a) {
            var d = a[c];
            if (b[c])
                for (var e in d) {
                    var g = d[e];
                    if (b[c][e])
                        for (var k in g) {
                            var f = g[k];
                            if (b[c][e][k])
                                for (var h in f) {
                                    var p = f[h];
                                    b[c][e][k][h] && p.forEach(function(a) {
                                        var d = JSON.stringify(a);
                                        b[c][e][k][h].filter(function(a) {
                                            return JSON.stringify(a) != d
                                        })
                                    })
                                }
                        }
                }
        }
        this.setInstrMap(b)
    }
    ;
    swymModules.push({
        id: "instr",
        init: function() {
            var a = this.storage.get(this.key.INSTRMAP);
            SwymUtils.isUndefined(a) || null == a || ("object" == typeof a && (SwymUtils.log("Instrmap found on cookie - " + JSON.stringify(a)),
            0 < Object.keys(a).length && (SwymUtils.log("Instrmap loaded from cookie to local"),
            this.setInstrMap(a))),
            this.storage.remove(this.key.INSTRMAP));
            this.instrumentMap = this.getInstrMap();
            var b = this;
            b.evtLayer.addEventListener(b.JSEvents.configLoaded, function() {
                var a = b.getApp("Wishlist")
                  , d = b.getApp("Watchlist");
                cb = a ? 1E3 : d ? 2E3 : 3E3
            })
        }
    });
    swymModules.push({
        id: "authn",
        events: {},
        init: function() {
            var a = this
              , b = new this.FetchModel({
                endpoint: "authn",
                name: "authn",
                deviceCleaned: !1,
                hashFn: function(a) {
                    return "all"
                },
                preloadHashFn: function(a, b) {
                    return "all"
                },
                transformFn: function(b) {
                    var d = b.regid;
                    a.setSwymEmail(b.email);
                    if (b.clean) {
                        this.deviceCleaned = !0;
                        for (var e in a.key)
                            a.storage.remove(a.key[e]),
                            a.storage.removeLocal(a.key[e]);
                        a.deviceCache.putObject({});
                        SwymUtils.log("Cleanup initiated, regid refreshing..");
                        a.triggerSwymEvent(h.JSEvents.regidCleaned)
                    } else
                        b.email ? (b.authn = !0,
                        d && (b.regid = d)) : b.authn = !1,
                        d = b.regid,
                        e = a.get(a.key.REGID),
                        d && e && e != d && (a.set(a.key.REGID, d),
                        SwymUtils.log("Registration id refreshing.." + d),
                        a.productEts.makeCacheStale(),
                        a.triggerSwymEvent(h.JSEvents.regidRefreshed, {
                            regid: d
                        }));
                    return b
                },
                cacheStaleEvts: [],
                internalFn: function(a, b, e) {
                    this.swat.swymApiPost({
                        endpoint: "/authn",
                        v2: !0,
                        customerRefresh: !0,
                        callbackFn: b,
                        errorFn: e
                    })
                }
            });
            this.exports("authn", b)
        }
    });
    h.prototype.cleanDevice = function() {
        this.authn.makeCacheStale();
        this.authn.transformFn({
            clean: !0
        });
        this.clearSettingsCache();
        this.removeInstrMap();
        this.session.remove()
    }
    ;
    h.prototype.authCheck = function(a) {
        this.authn.fetch({
            scb: a
        })
    }
    ;
    h.prototype.isAlreadyAuth = function() {
        return !!this.getSwymEmail()
    }
    ;
    swymModules.push({
        id: "filters",
        init: function() {
            this.exports("filtersCfg", [])
        }
    });
    h.prototype.getRelayFilters = function() {
        return this.getSimpleWishlistFilters()
    }
    ;
    h.prototype.getSimpleWishlistFilters = function() {
        var a = {};
        a[this.retailerSettings.UI.Title] = this.EventTypes.addToWishlist;
        return a
    }
    ;
    h.prototype.wishlist || (h.prototype.wishlist = {});
    h.prototype.shopper || (h.prototype.shopper = {});
    h.prototype.wrapLogin = function(a) {
        a = a || {
            authnCheck: !1
        };
        var b = a.redirectPath || window.location.href
          , c = a.callFunction || SwymUtils.EmptyFunction
          , d = this;
        (a.authnCheck ? function() {
            return d.getSwymEmail()
        }
        : a.storefrontCheck ? function() {
            return d.platform.isLoggedIn()
        }
        : function() {
            return !1
        }
        )() ? c() : (f.storage.setSessionData(f.key.POSTLOGINRD, b),
        this.platform.redirectToLoginPage())
    }
    ;
    h.prototype.setRetailerId = function(a) {
        try {
            a = JSON.parse(a),
            console.warn("Swym PID metafield seems to be mangled, continuing with temporary fix")
        } catch (b) {}
        this.set(this.key.PID, a);
        this.versionCheck()
    }
    ;
    h.prototype.getSwymRegistrationId = function() {
        return this.get(this.key.REGID)
    }
    ;
    h.prototype.getSwymHostUri = function() {
        return this.swymHost
    }
    ;
    h.prototype.trackPageview = function(a, b) {
        this.currentPageData = a;
        this.trackPageview_(this.enrichOOSVariantsForProduct(a), function(a) {
            b && b(a)
        })
    }
    ;
    h.prototype.reportPageview = function(a, b) {
        this.send(G(a, {
            et: this.EventTypes.productView
        }), b)
    }
    ;
    h.prototype.trackPageview_ = function(a, b) {
        var c = this
          , d = this.getInstrMap()
          , e = Ja(d);
        a = G(a, {
            ri: e
        });
        e = function() {
            c.send(a, function(d) {
                c.triggerSwymEvent(h.JSEvents.trackedPageView, a);
                d.batch_report && (c.instrumentMap = {},
                c.resetInstrMap());
                b && b(d)
            })
        }
        ;
        if (a.et !== h.EventTypes.productView && this.collectPending)
            this.collectPending = !1,
            e();
        else {
            var g = this.retailerSettings && this.retailerSettings.Recommendations && this.retailerSettings.Recommendations.Enabled
              , d = 300 < JSON.stringify(d).length;
            !(this.getSwymRegistrationId() && -1 < [h.EventTypes.unknownView, h.EventTypes.categoryView].indexOf(a.et)) || g && d ? e() : setTimeout(function() {
                b && b({})
            }, 100)
        }
    }
    ;
    h.prototype.dumpRI = function(a, b) {
        var c = this
          , d = a || this.getInstrMap();
        this.instrumentMap = {};
        var e = Ja(d)
          , e = G({}, {
            et: h.EventTypes.unknownView,
            ri: e
        });
        this.send(e, function(a) {
            a.batch_report && c.cleanCacheEntries(d);
            b && b(a)
        })
    }
    ;
    h.prototype.addToCart = function(a, b) {
        this.send(G(a, {
            et: this.EventTypes.addToCart,
            qty: 1
        }), b)
    }
    ;
    h.prototype.reportAddToCart = h.prototype.addToCart;
    h.prototype.reportDropFromCart = function(a, b) {
        this.send(G(a, {
            et: this.EventTypes.dropFromCart,
            qty: 1
        }), b)
    }
    ;
    h.prototype.addToWishList = function(a, b, c, d) {
        var e = this;
        ["epi", "empi"].forEach(function(b) {
            if (!a[b])
                throw Error("Add to Wishlist call should have epi & empi");
        });
        if (a.du && !SwymUtils.validateUrl(a.du))
            throw Error("du should be an absolute URL");
        this.send(G(a, {
            et: this.EventTypes.addToWishlist
        }), function(c) {
            e.scheduleUserPreferenceAsk();
            c = c && c.event ? c.event : a;
            e.triggerSwymEvent(h.JSEvents.addedToWishlist, c);
            b(c)
        })
    }
    ;
    h.prototype.removeFromWishList = function(a, b) {
        var c = this;
        a.et = this.EventTypes.addToWishlist;
        a.type = this.retailerSettings.General.ProductLevel;
        this.api.deleteEvent(function() {
            c.triggerSwymEvent(h.JSEvents.removedFromWishlist, a);
            b(a)
        }, null, a)
    }
    ;
    h.prototype.addToWatchList = function(a, b, c, d, e) {
        var g = ba(b);
        ["epi", "empi", "iu"].forEach(function(a) {
            if (!g[a])
                throw Error("Page data should have du, epi, empi, iu");
        });
        ["pr"].forEach(function(a) {
            if (SwymUtils.isUndefined(g[a]) || null == g[a])
                throw Error("Page data should have valid pr");
        });
        if (g.du && !SwymUtils.validateUrl(g.du))
            throw Error("du should be an absolute URL");
        this.ui.openRemindMe(a, this.decorateProduct(g, "watchlist"), c, d, e)
    }
    ;
    h.prototype.sendWatchlistV3 = function(a, b, c, d, e, g) {
        if ("object" === typeof a) {
            for (var k = !1, h = 0, m = a.length; h < m; h++) {
                var p = a[h].medium
                  , r = a[h].mediumvalue;
                "email" !== p || SwymUtils.validateEmail(r) ? "sms" !== p || SwymUtils.validatePhoneNumber(r) || (k = !0) : k = !0
            }
            if (k) {
                SwymUtils.error("Invalid medium value for one of the inputs");
                return
            }
        }
        a = {
            event: X(G(b, {
                et: this.EventTypes.watchlist
            })),
            topics: g || "backinstock",
            mediums: a
        };
        f.retailerSettings.Watchlist.MailingListCheckInPopup && (a.addtomailinglist = e);
        e = !1;
        a.event.epi && a.event.empi && !a.event.iu && !a.event.pr && (e = !0);
        g = void 0;
        for (var n in window.SwymProductVariants)
            window.SwymProductVariants[n].epi == b.epi && (g = window.SwymProductVariants[n]);
        g && (a.event.stk = g.stk,
        "Shopify" == f.platform.type && (a.sprops = {
            variantInfo: {
                empi: g.empi,
                epi: g.epi,
                stk: g.stk,
                variants: g.variants,
                available: f.SwymShopifyCurrentVariant && f.SwymShopifyCurrentVariant.available
            }
        }));
        this.swymApiPost({
            endpoint: e ? "/epiAddToWatchlist" : "/addToWatchlist",
            params: a,
            callbackFn: c,
            v3: !0,
            errorFn: d
        })
    }
    ;
    h.prototype.sendWatchlist = function(a, b, c, d, e, g, k) {
        if ("email" != b || SwymUtils.validateEmail(a)) {
            if (!c.epi || !c.empi)
                throw Error("Add to Watchlist call should have epi & empi");
            var l = window._swat;
            if (c.cprops && "object" !== typeof c.cprops)
                throw Error("cprops should be an object");
            var m = {
                event: X(G(c, {
                    et: this.EventTypes.watchlist
                })),
                mediumvalue: a,
                medium: b,
                topics: k || "backinstock"
            }, p = void 0, r;
            for (r in window.SwymProductVariants)
                window.SwymProductVariants[r].epi == c.epi && (p = window.SwymProductVariants[r]);
            p && (m.event.stk = p.stk,
            "Shopify" == f.platform.type && (m.sprops = {
                variantInfo: {
                    empi: p.empi,
                    epi: p.epi,
                    stk: p.stk,
                    variants: p.variants,
                    available: f.SwymShopifyCurrentVariant && f.SwymShopifyCurrentVariant.available
                }
            }));
            try {
                null !== c.variants && "object" === typeof c.variants && (c.variants = JSON.stringify(c.variants))
            } catch (n) {
                SwymUtils.error("Error in stringifying variants key - " + n)
            }
            f.retailerSettings.Watchlist.MailingListCheckInPopup && (m.addtomailinglist = g);
            a = Object.assign({}, m.event, {
                mediumvalue: a,
                medium: b,
                topics: k || "backinstock"
            });
            l.triggerSwymEvent(h.JSEvents.addedToWatchlist, a);
            l.sendWatchlistInternal(m, d, e)
        } else
            SwymUtils.error("Invalid email address")
    }
    ;
    h.prototype.subscribeForProductAlert = function(a, b, c, d, e, g, f) {
        var l;
        l = {
            email: SwymUtils.validateEmail,
            sms: SwymUtils.validatePhoneNumber
        };
        l = 0 > Object.keys(l).indexOf(b) ? !1 : l[b](a) ? !0 : !1;
        if (l)
            if (c.epi && c.empi)
                if (c.cprops && "object" !== typeof c.cprops)
                    SwymUtils.error("cprops should be an object");
                else {
                    l = {
                        event: X(G(c, {
                            et: this.EventTypes.watchlist
                        })),
                        mediumvalue: a,
                        medium: b,
                        topics: f || "backinstock"
                    };
                    try {
                        null !== c.variants && "object" === typeof c.variants && (c.variants = JSON.stringify(c.variants))
                    } catch (m) {
                        SwymUtils.error("Error in stringifying variants key - " + m)
                    }
                    g && !this.retailerSettings.Watchlist.MailingListCheckInPopup ? SwymUtils.error("Enable Mailing list check from dashboard") : (this.retailerSettings.Watchlist.MailingListCheckInPopup && (l.addtomailinglist = g),
                    a = Object.assign({}, l.event, {
                        mediumvalue: a,
                        medium: b,
                        topics: f || "backinstock"
                    }),
                    this.triggerSwymEvent(h.JSEvents.addedToWatchlist, a),
                    this.sendWatchlistInternal(l, d, e))
                }
            else
                SwymUtils.error("Product object must have epi & empi");
        else
            SwymUtils.error("Invalid medium and/or mediumInfo value")
    }
    ;
    h.prototype.sendWatchlistInternal = function(a, b, c) {
        var d = !1;
        a.event.epi && a.event.empi && !a.event.iu && !a.event.pr && (d = !0);
        this.swymApiPost({
            endpoint: d ? "/epiAddToWatchlist" : "/addToWatchlist",
            params: a,
            callbackFn: b,
            v2: !0,
            errorFn: c
        })
    }
    ;
    h.prototype.fetch = function(a, b) {
        this.productEts.fetchWrtEventType({
            params: {
                medium: b ? b : "relay"
            },
            scb: a
        })
    }
    ;
    h.prototype.count = function(a, b, c, d, e, g, f) {
        var h = this.get("pid");
        this.retailerSettings && this.retailerSettings.FeatureToggles && this.retailerSettings.FeatureToggles.use_mongo_SwymEtCountStore ? this.socialCount(b, c, d, f, h, "addToWishlist") : this.countInternal(a, b, c, d, e, g)
    }
    ;
    h.prototype.countEvents = function(a, b) {
        this.productEts.fetchWrtEventType({
            params: {
                et: a,
                medium: "relay"
            },
            scb: function(a) {
                b(a.length)
            }
        })
    }
    ;
    h.prototype.fetchWrtEventTypeET = function(a, b, c) {
        this.productEts.fetchWrtEventType({
            params: {
                medium: c ? c : "relay",
                et: b
            },
            scb: a
        })
    }
    ;
    h.prototype.wishlistCount = function(a) {
        this.countEvents(this.EventTypes.addToWishlist, a)
    }
    ;
    h.prototype.renderWishlistCount = function(a, b, c) {
        var d = 0, e, g = this, f = function(c) {
            0 < c ? (SwymUtils.addClass(a, "show-badge"),
            SwymUtils.addClass(a, "update-badge"),
            clearTimeout(e),
            e = setTimeout(function() {
                SwymUtils.removeClass(a, "update-badge")
            }, 2E3)) : SwymUtils.removeClass(a, "show-badge");
            a.setAttribute("data-count", c);
            d = a.innerHTML = c;
            b && b(c, a)
        };
        this.wishlistCount(f);
        if (c)
            var l = f, m, f = function(a) {
                d = a;
                clearTimeout(m);
                m = setTimeout(function() {
                    l(a)
                }, c)
            };
        this.evtLayer.addEventListener(this.JSEvents.addedToWishlist, function() {
            f(d + 1)
        });
        this.evtLayer.addEventListener(this.JSEvents.removedFromWishlist, function() {
            g.wishlistCount(f)
        });
        this.evtLayer.addEventListener(this.JSEvents.removeWishlistCollection, function() {
            g.wishlistCount(f)
        });
        this.evtLayer.addEventListener(this.JSEvents.customerInfoRefreshed, function() {
            g.wishlistCount(f)
        });
        this.evtLayer.addEventListener(this.JSEvents.deletedFromRelay, function(a) {
            a.detail.d.currEt == g.EventTypes.addToWishList && f(Math.max(d - 1, 0))
        });
        this.evtLayer.addEventListener(this.JSEvents.regidRefreshed, function(a) {
            g.wishlistCount(f)
        });
        this.evtLayer.addEventListener(h.JSEvents.productInvalidOnLoad, function(a) {
            a.detail.d.product.et == g.EventTypes.addToWishList && f(Math.max(d - 1, 0))
        })
    }
    ;
    h.prototype.enrichOOSVariantsForProduct = function(a) {
        try {
            var b = f.platform.getOOSVariantsForProduct(a);
            a.oosvariants = b
        } catch (c) {
            SwymUtils.error("Error while fetching OOS Variants for a product : " + c),
            a.oosvariants = []
        }
        return a
    }
    ;
    h.prototype.logoutCleanUp = function() {
        this.retailerSettings.General.LogoutClean && this.isAlreadyAuth() && (this.cleanDevice(),
        this.refresh(SwymUtils.EmptyFunction))
    }
    ;
    h.prototype.remoteAuthRequest = function(a, b, c) {
        this.remoteAuthRequestInternal(c, a, b)
    }
    ;
    h.prototype.saveShopperContext = function(a, b, c, d, e) {
        var g = {};
        if (a && !SwymUtils.validateEmail(a))
            throw Error("Invalid email address");
        a && (g.email = a);
        if (e && !SwymUtils.validatePhoneNumber(e))
            throw Error("Invalid phone number");
        e && (g.phone = e);
        var f = this;
        b.src && (g.src = b.src);
        b.app && (g.app = b.app);
        b.skipConnect && (g.skipConnect = b.skipConnect);
        b.fname && (g.fname = b.fname);
        b.lname && (g.lname = b.lname);
        SwymUtils.isUndefined(b.acceptMarketing) || (g.acceptMarketing = b.acceptMarketing);
        this.swymApiPost({
            endpoint: "/user/save",
            params: g,
            callbackFn: function(a) {
                f.storage.setSessionData(f.key.IGNOREAUTHCACHE, 1);
                c && c(a)
            },
            errorFn: d,
            v3: !0
        })
    }
    ;
    h.prototype.removeUserFromDevice = function(a, b) {
        var c = this;
        this.removeUserFromDeviceInternal(function(b) {
            a(b);
            c.set(c.key.REMOTEAUTH, 0);
            c.storage.removeLocal(c.key.listCurrentId)
        }, b)
    }
    ;
    h.prototype.disconnectShopperContext = function(a, b) {
        var c = this;
        this.platform && this.platform.isLoggedIn() ? (this.cleanDevice(),
        this.platform.redirectToLogoutPage()) : this.removeUserFromDeviceInternal(function(b) {
            a(b);
            c.set(c.key.REMOTEAUTH, 0);
            c.storage.removeLocal(c.key.listCurrentId)
        }, b)
    }
    ;
    h.prototype.deleteEvent = function(a, b, c) {
        var d = this
          , e = !1;
        c ? (c = ba(c),
        c.et == d.EventTypes.addToWishlist && (e = !0),
        c.currEt = c.et,
        c.et = d.EventTypes.deleteEvent,
        ["op", "pr"].forEach(function(a) {
            c[a] && -1 != c[a].toString().indexOf("$ ") && (c[a] = parseFloat(c[a].split("$ ")[1]))
        }),
        c = d.cleanEventMap(c),
        d.triggerSwymEvent(h.JSEvents.deletedFromRelay, c),
        d.send(G(c, {
            qty: 1
        }), a),
        e && (c.type = window._swat.retailerSettings.General.ProductLevel)) : (c = {},
        this.api.fetch(function() {
            (c = d.productEts.quickFindEvent({
                _id: b
            })) ? d.api.deleteEvent(a, b, c) : a(null)
        }))
    }
    ;
    h.prototype.cleanEventMap = function(a) {
        var b = {};
        "et du epi empi ct iu dt pr pt variants currEt".split(" ").forEach(function(c) {
            SwymUtils.isUndefined(a[c]) || (b[c] = a[c])
        });
        return b
    }
    ;
    h.prototype.initSwymWidgets = function(a, b, c) {
        var d = window._swat, e, g = d.retailerSettings;
        b || (b = SwymUtils.getPageURLAsLocation().href);
        g ? g.Wishlist.EnableFaveCount && (e = document.querySelector(g.Wishlist.FaveCountSelector)) : e = document.getElementById("swym-fave-count");
        e && (d.evtLayer.addEventListener(h.JSEvents.addedToWishlist, function() {
            d.populateFaveButton(e, b, g.General.ProductLevel, a, c);
            d.incFaveButton(e)
        }),
        d.evtLayer.addEventListener(h.JSEvents.removedFromWishlist, function() {}),
        d.evtLayer.addEventListener(d.JSEvents.variantChanged, function(f) {
            f = f.detail.d.variant;
            a = f.id;
            d.populateFaveButton(e, b, g.General.ProductLevel, f.id, c)
        }),
        d.populateFaveButton(e, b, g.General.ProductLevel, a, c))
    }
    ;
    h.prototype.populateFaveButton = function(a, b, c, d, e) {
        var g = !1;
        this.retailerSettings && this.retailerSettings.FeatureToggles && this.retailerSettings.FeatureToggles.use_mongo_SwymEtCountStore && (g = this.retailerSettings.FeatureToggles.use_mongo_SwymEtCountStore);
        this.count(h.EventTypes.addToWishlist, function(b) {
            var c = g ? b.data.count : b.count;
            SwymUtils.onDOMReady(function() {
                a.setAttribute("data-count", c);
                a.innerHTML = SwymUtils.abbrNum(c)
            })
        }, SwymUtils.EmptyFunction, b, c, d, e)
    }
    ;
    h.prototype.incFaveButton = function(a) {
        if (a) {
            var b = parseInt(a.getAttribute("data-count") || 0, 10);
            a.setAttribute("data-count", b + 1);
            a.innerHTML = SwymUtils.abbrNum(b + 1)
        }
    }
    ;
    h.prototype.decFaveButton = function(a) {
        if (a) {
            var b = parseInt(a.getAttribute("data-count") || 0, 10);
            a.setAttribute("data-count", b - 1);
            a.innerHTML = SwymUtils.abbrNum(b - 1)
        }
    }
    ;
    h.prototype.reportTierMismatch = function(a, b) {
        this.swymApiPost({
            endpoint: "/report-tier-mismatch",
            params: {},
            callbackFn: function() {
                a()
            },
            v3: !0,
            errorFn: function(a) {
                b(a)
            },
            sendSessionId: !1,
            sendRegId: !1
        })
    }
    ;
    h.prototype.updateUserEmailPreference = function(a, b, c, d, e) {
        if (!0 !== b && !1 !== b || !a)
            throw Error("Email preference has to be a boolean");
        this.isAlreadyAuth() || this.idCollect(a, "swym", "triggerpermission");
        b = {
            SendEmail: {
                enabled: b,
                source: "client"
            }
        };
        this.retailerSettings.General.MailingListCheck && c && (b.AddToMailingList = {
            enabled: c,
            appname: "Wishlist"
        });
        this.api.updateUserPreferences(a, b, d, e)
    }
    ;
    h.prototype.getUserPreferences = function(a, b, c, d) {
        var e = this
          , g = this.getSwymUserPref();
        g ? c(g) : this.swymApi({
            endpoint: "/user-preference",
            params: {
                prefkeys: b,
                userid: a
            },
            callbackFn: function(a) {
                a && (e.setSwymUserPref(a),
                c(a))
            },
            v2: !0,
            errorFn: d,
            sendSessionId: !1,
            waitForRegister: !1,
            checkRegId: !1
        })
    }
    ;
    h.prototype.getPreferencesV3 = function(a, b) {
        this.swymApi({
            endpoint: "/user-preference",
            callbackFn: a,
            errorFn: b,
            v3: !0
        })
    }
    ;
    h.prototype.mediumValidate = function(a, b, c, d, e, g) {
        this.swymApiPost({
            endpoint: "/user/mediums/validate",
            params: {
                context: {
                    topics: a,
                    event: X(G(b, {
                        et: this.EventTypes.watchlist
                    }))
                },
                medium: c,
                mediumvalue: d
            },
            v3: !0,
            noProvider: !0,
            callbackFn: e,
            errorFn: g
        })
    }
    ;
    h.prototype.postUserSubscriptions = function(a) {
        this.swymApiPost({
            endpoint: "/user/subscriptions",
            params: a,
            callbackFn: function() {},
            v3: !0,
            errorFn: function(a) {
                SwymUtils.error("Could not subscribe:", a)
            },
            sendSessionId: !1,
            waitForRegister: !1,
            checkRegId: !1,
            avoidPid: !0
        })
    }
    ;
    h.prototype.postUserPreference = function(a, b) {
        this.swymApiPost({
            endpoint: "/user-preference",
            params: {
                email: a || null,
                prefmap: b
            },
            callbackFn: function() {},
            v3: !0,
            errorFn: function(a) {
                SwymUtils.error("Could not subscribe:", a)
            },
            sendSessionId: !0,
            waitForRegister: !1,
            checkRegId: !1
        })
    }
    ;
    h.prototype.updateUserPreferences = function(a, b, c, d) {
        var e = this;
        if (a)
            this.swymApiPost({
                endpoint: "/user-preference",
                params: {
                    prefmap: b,
                    userid: a
                },
                callbackFn: function(a) {
                    e.setSwymUserPref(b);
                    c(a)
                },
                v2: !0,
                errorFn: d,
                sendSessionId: !0,
                checkRegId: !1,
                waitForRegister: !1
            });
        else
            throw Error("Preferences currently saved only for users who have authorized.");
    }
    ;
    h.prototype.scheduleUserPreferenceAsk = function() {
        function a() {
            if (1 != b.isMailModalLoading) {
                b.isMailModalLoading = !0;
                var a = b.storage.get(b.key.TPERMTS);
                b.storage.get(b.key.MKTDENIED) || a && !(a && a <= Date.now()) || SwymUtils.deferredCallback(function() {
                    b.ui.openGetTriggerPermissionDialog(function() {
                        b.isMailModalLoading = !1
                    });
                    var a = b.retailerSettings.UI.UserPrefDelayHours || 24;
                    b.storage.get(b.key.TPERMTS) && (a += 2 * a);
                    b.storage.set(b.key.TPERMTS, Date.now() + 36E5 * a)
                }, 5E3)
            }
        }
        var b = this;
        this.getCheckUserPreferenceMeta(function(c) {
            c = c.CheckUserPreference ? c.CheckUserPreference : !1;
            var d = b.storage.get(b.key.CLCTMAP) ? !0 : !1;
            if ((!0 === c || void 0 === c) && !d) {
                var e = b.getSwymEmail() || (f && f.retailerSettings && f.retailerSettings.UI && f.retailerSettings.UI.DisableOOSFormEmailPrefill ? null : b.storage.get(f.key.WEML));
                b.api.authCheck(function(c) {
                    c.regn && c.regn.userinfo || b.getUserPreferences(e, ["SendEmail", "AddToMailingList"], function(b) {
                        b && !b.hasOwnProperty("SendEmail") && a()
                    }, function(a) {})
                })
            }
        })
    }
    ;
    h.prototype.unsubscribeFromSwym = function(a, b, c) {
        f.swymApiPost({
            endpoint: "/unsubscribeFromSwym",
            params: a,
            callbackFn: b,
            errorFn: c,
            v2: !0
        })
    }
    ;
    h.prototype.isInWishlist = function(a, b) {
        var c = this;
        this.api.fetchWrtEventTypeET(function(d) {
            b(!!c.productEts.quickFindIdxForEpiEt(a.epi, c.EventTypes.addToWishlist))
        }, this.EventTypes.addToWishlist)
    }
    ;
    h.prototype.wishlist.getSocialCount = function(a, b, c) {
        if ((f.getApp("Wishlist") || {}).enabled) {
            if ("object" !== typeof a || "function" !== typeof b || "function" !== typeof c)
                return Error("Error in wishlist.getSocialCount API. Invalid argument supplied");
            a.empi ? f.swymApiPost({
                endpoint: "/product/wishlist/social-count",
                params: {
                    empi: a.empi
                },
                callbackFn: b,
                errorFn: c,
                checkRegId: !0,
                noProvider: !0,
                v3: !0
            }) : c(Error("Error in wishlist.getSocialCount API. empi must be supplied inside the product info"))
        } else
            c(Error("Error in wishlist.getSocialCount API. Wishlist Plus is not enabled"))
    }
    ;
    h.prototype.wishlist.fetchPaginatedList = function(a, b, c) {
        a = void 0 === a ? {} : a;
        Ia("Wishlist", [{
            param: a,
            type: "object"
        }, {
            param: b,
            type: "function"
        }, {
            param: c,
            type: "function"
        }]);
        if (a.sortby && "title" !== a.sortby && "price" !== a.sortby)
            throw Error("Incorrect 'sortby' value provided");
        if (a.sortorder && "asc" !== a.sortorder && "desc" !== a.sortorder)
            throw Error("Incorrect 'sortorder' value provided");
        if (a.filterby && "instock" !== a.filterby && "outofstock" !== a.filterby)
            throw Error("Incorrect 'filterby' value provided");
        f.swymApiPost({
            endpoint: "/lists/fetch-user-list",
            params: a,
            callbackFn: b,
            errorFn: c,
            checkRegId: !0,
            sendSessionId: !0,
            v3: !0,
            noProvider: !0
        })
    }
    ;
    h.prototype.wishlist.fetchUserLists = function(a, b) {
        Ia("Wishlist", [{
            param: a,
            type: "function"
        }, {
            param: b,
            type: "function"
        }]);
        f.swymApiPost({
            endpoint: "/lists/fetch-user-lists",
            callbackFn: a,
            errorFn: b,
            checkRegId: !0,
            v3: !0,
            noProvider: !0
        })
    }
    ;
    h.prototype.fetchSubscriptions = function(a, b, c) {
        a = a || {};
        f.swymApiPost({
            endpoint: "/subscriptions/fetch-subs",
            params: {
                topic: void 0 === a.topic ? "backinstock" : a.topic,
                medium: a.medium,
                limit: a.limit,
                offset: a.offset
            },
            noProvider: !0,
            callbackFn: b,
            errorFn: c,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    swymModules.push({
        id: "fetch",
        events: {
            fetchProducts: "sw:fetchproducts"
        },
        init: function() {
            function a(a) {
                var b = {}
                  , c = [];
                a.forEach(function(a, d) {
                    if (b[a.epi])
                        if (-1 < e.indexOf(a.et))
                            c = c.filter(function(b) {
                                return b.epi != a.epi
                            });
                        else
                            return;
                    c.push(a);
                    b[a.epi] = a
                });
                return c
            }
            function b(b) {
                var c = b.epis
                  , e = b.metadata;
                c && e && (b = c.map(function(a) {
                    var b = d.findProduct(a.epi, !0);
                    return Object.assign({}, a, b)
                }));
                return a(b)
            }
            var c = new this.FetchModel({
                name: "products",
                hashFn: function(a) {
                    return "all"
                },
                preloadHashFn: function(a, b) {
                    return "all"
                },
                cacheStaleEvts: [this.JSEvents.removedFromWishlist, this.JSEvents.deletedFromRelay].concat(this.FetchModel.defaultOpts.cacheStaleEvts),
                gSEvtNames: [this.JSEvents.fetchProducts],
                transformFn: a,
                preLoadTransformFn: a,
                internalFn: function(a, b, c) {
                    function d() {
                        e.swat.isSimpleWishlistOnly();
                        if (e.swat.isNonFetchUI())
                            setTimeout(function() {
                                b([])
                            });
                        else {
                            var f = e.swat.get(e.swat.key.SVD)
                              , h = e.swat;
                            null === f || 1 == f || e.swat.isAlreadyAuth();
                            f = {
                                q: a.params.query
                            };
                            h = "/" + h.getFetchEndpointFn();
                            e.swat.swymApiPost({
                                endpoint: h,
                                v2: !0,
                                params: f,
                                callbackFn: function(a) {
                                    b(a)
                                },
                                errorFn: c
                            })
                        }
                    }
                    var e = this;
                    e.swat.retailerSettings ? d() : e.evtLayer.addEventListener(e.swat.JSEvents.configLoaded, function() {
                        d()
                    })
                }
            })
              , d = this
              , e = [d.EventTypes.addToCart, d.EventTypes.checkout];
            c.fetchWrtEventType = function(a) {
                var b = a.scb;
                a.scb = function(c, d) {
                    var e = c
                      , e = this.filterEvents(c, a.params.et);
                    e.forEach(function(b) {
                        b.du && (b.du = this.swat.tagURL(b.du, a.params.medium))
                    }, this);
                    b.apply(this, [e, a])
                }
                ;
                a.scb = a.scb.bind(this);
                this.fetch(a)
            }
            ;
            c.quickFindForEpi = function(a) {
                for (var b = this.mcache.all, c = b.length, d, e = 0; e < c; e++) {
                    var f = b[e];
                    if (f.epi == a) {
                        d = f;
                        break
                    }
                }
                return d
            }
            ;
            c.quickFindIdxForEpiEt = function(a, b) {
                for (var c = this.mcache.all, d = c.length, e, f = 0; f < d; f++) {
                    var h = c[f];
                    if (h.epi == a && h.et == b) {
                        e = {
                            evt: h,
                            idx: f
                        };
                        break
                    }
                }
                return e
            }
            ;
            c.quickFindForDu = function(a) {
                for (var b = this.mcache.all, c = b.length, d, e = 0; e < c; e++) {
                    var f = b[e];
                    if (f["raw-du"] == a) {
                        d = f;
                        break
                    }
                }
                return d
            }
            ;
            c.quickFindEvent = function(a) {
                for (var b = this.mcache.all, c = b.length, d, e = 0; e < c; e++) {
                    var f = b[e], h = !0, x;
                    for (x in a)
                        h = a[x] == f[x];
                    if (h) {
                        d = f;
                        break
                    }
                }
                return d
            }
            ;
            c.filterEvents = function(a, b) {
                return SwymUtils.isUndefined(b) ? a : a.filter(function(a) {
                    return b == a.et
                })
            }
            ;
            c.updateCacheTsBy = SwymUtils.debounce(function(a) {
                c.lcache.updateCacheTsBy(a)
            }, 1E3);
            c.reassignPreloadHashFn = !1;
            this.exports("productEts", c);
            d = this;
            this.isSimpleWishlistOnly() || this.evtLayer.addEventListener(this.JSEvents.fetchProducts, SwymUtils.debounce(function(a) {
                a = a.detail.d;
                d.get(d.key.SVD) && d.storage.setSessionData(d.key.SVD, -1);
                0 < d.productEts.filterEvents(a, d.EventTypes.addToWishList).length && d.storage.setSessionData(d.key.SVD, 1)
            }, 10));
            this.productEts.updateCache = function(a) {
                try {
                    if (this.mcache && this.mcache.all) {
                        this.mcache = this.lcache.getObject();
                        if (this.quickFindForEpi(a.epi))
                            this.makeCacheStale();
                        else {
                            var b = JSON.parse(JSON.stringify(a));
                            b.ts = Date.now();
                            b.et = a.et;
                            b._id = "temp_" + b.ts;
                            b["raw-du"] = b.du;
                            this.mcache.all.unshift(b);
                            this.lcache.updateObject(this.mcache)
                        }
                        this.swat.triggerSwymEvent(this.swat.JSEvents.productsCacheUpdated, this.mcache)
                    }
                } catch (c) {
                    console.log("Skipping error", c)
                }
            }
            ;
            this.productEts.checkAndClearCache = function(a) {
                this.lcache.updateCacheTsBy(a || -60)
            }
            ;
            this.productCache = this.productEts.lcache;
            this.evtLayer.addEventListener(this.JSEvents.configLoaded, function() {
                function a(b) {
                    d.productEts.updateCache(b.detail.d);
                    d.productEts.checkAndClearCache()
                }
                d.isSimpleWishlistOnly() ? d.evtLayer.addEventListener(d.JSEvents.addedToWishlist, a) : d.evtLayer.addEventListener(d.JSEvents.addedToWishlist, function() {
                    d.productEts.makeCacheStale()
                })
            });
            d.productEts.reassignFnForMetadataStore = function() {
                d.productEts.preLoadTransformFn = b;
                d.productEts.transformFn = b
            }
        }
    });
    h.prototype.tagURL = function(a, b) {
        a = a.replace("utm_source=swym", "").replace("utm_medium=tooltip", "").replace("utm_medium=relay", "");
        0 == (a.split("?")[1] || "").length && (a = a.replace("?", ""));
        return a
    }
    ;
    h.prototype.tagURLWithHash = function(a, b) {
        var c = SwymUtils.getURLAsLocation(a);
        c.search = c.search.replace("utm_source=swym", "").replace("utm_medium=tooltip", "").replace("utm_medium=relay", "");
        c.hash += "-swym-" + b;
        return c.href
    }
    ;
    h.prototype.tagURLWithUTM = function(a, b) {
        return a += (-1 == a.indexOf("?") ? "?" : "&") + (-1 == a.indexOf("utm_source=swym") ? "utm_source=swym&" : "") + "utm_medium=" + b
    }
    ;
    h.prototype.decorateProduct = function(a, b) {
        a && a.du && (a.du = this.tagURL(a.du, b));
        return a
    }
    ;
    h.prototype.getFetchEndpointFn = function() {
        this.isSimpleWishlistOnly();
        var a = this.get(this.key.SVD);
        null === a || 1 == a || this.isAlreadyAuth();
        return "fetchWishlist"
    }
    ;
    swymModules.push({
        id: "devices",
        events: {
            fetchDevices: "sw:fetchdevices"
        },
        init: function() {
            var a = new this.FetchModel({
                name: "devices",
                hashFn: function(a) {
                    return "all"
                },
                preloadHashFn: function(a, c) {
                    return "all"
                },
                gSEvtNames: [this.JSEvents.fetchDevices],
                internalFn: function(a, c, d) {
                    this.swat.swymApiPost({
                        endpoint: "/devices",
                        v2: !0,
                        callbackFn: c,
                        errorFn: d
                    })
                }
            });
            this.exports("currDevice", a);
            this.deviceCache = this.currDevice.lcache
        }
    });
    h.prototype.devices = function(a) {
        this.currDevice.fetch({
            scb: a
        })
    }
    ;
    swymModules.push({
        id: "uprefcheckmeta",
        events: {
            fetchUserPrefCheckMeta: "sw:fetchuserprefcheckmeta"
        },
        init: function() {
            var a = new this.FetchModel({
                name: "uprefcheckmeta",
                hashFn: function(a) {
                    return "all"
                },
                preloadHashFn: function(a, c) {
                    return "all"
                },
                gSEvtNames: [this.JSEvents.fetchUserPrefCheckMeta],
                internalFn: function(a, c, d) {
                    this.swat.swymApi({
                        endpoint: "/user-pref-check-flags",
                        params: {},
                        callbackFn: c,
                        v2: !0,
                        errorFn: d,
                        sendSessionId: !1,
                        sendRegId: !1,
                        waitForRegister: !1,
                        checkRegId: !1
                    })
                }
            });
            this.exports("uprefCheckMeta", a)
        }
    });
    h.prototype.getCheckUserPreferenceMeta = function(a) {
        this.uprefCheckMeta.fetch({
            scb: a
        })
    }
    ;
    swymModules.push({
        id: "productsstore",
        events: {
            productsStoreUpdated: "sw:productsstoreupdated"
        },
        init: function() {
            var a = this;
            a.productMetadataCache = new I("productsstore",86400,a.storage);
            var b = a.productMetadataCache.getObject() || [];
            h.prototype.getProductMetadata = SwymUtils.debounce(function(b, d, e) {
                a.swymApiPost({
                    endpoint: "/getProductMetadata",
                    v2: !0,
                    params: {
                        products: b
                    },
                    callbackFn: function(b) {
                        a.upsertProductsToCache(b);
                        d(b, {
                            found: [],
                            inactive: []
                        })
                    },
                    errorFn: e
                })
            }, 500);
            a.transformProductMetadata = function(b) {
                var d = {}
                  , e = SwymUtils.deepcopy(b);
                e.dt = e.title;
                e.ct = e.prodtype;
                e.du = e["raw-du"] = a.platform.getDuFromVariantUri(e.uri);
                d[a.platform.getVariantString(e)] = e.epi;
                e.variants = JSON.stringify([d]);
                "title hashtags prodtype vkey1 vkey2 vkey3 vval1 vval2 vval3 vendor iqty id uri".split(" ").forEach(function(a) {
                    delete e[a]
                });
                return e
            }
            ;
            a.getCachedProducts = function() {
                var c = [];
                a.productMetadataCache.isCacheEntryStale() || (c = b.map(function(a) {
                    return {
                        _hv: a._hv,
                        epi: a.epi
                    }
                }));
                return c
            }
            ;
            a.findProduct = function(c, d) {
                if (a.productMetadataCache.isCacheEntryStale())
                    return {};
                for (var e, g = b.length - 1; 0 <= g; g--)
                    if (b[g].epi === c) {
                        e = b[g];
                        break
                    }
                return e = e ? d ? a.transformProductMetadata(e) : e : {}
            }
            ;
            a.getUpdatedProductsMetaData = function(a, b) {
                for (var e = !1, g, f = a.length - 1; 0 <= f; f--)
                    if (g = a[f],
                    g.epi === b.epi) {
                        e = !0;
                        g._hv !== b._hv && (a[f] = b);
                        break
                    }
                e || a.push(b);
                return a
            }
            ;
            a.upsertProductsToCache = function(c) {
                for (var d = c.length - 1; 0 <= d; d--)
                    delete c[d].hashtags,
                    b = a.getUpdatedProductsMetaData(b, c[d]);
                a.triggerSwymEvent(a.JSEvents.productsStoreUpdated);
                a.productMetadataCache.putObject(b)
            }
        }
    });
    h.prototype.validateUserLogin = function(a, b, c, d) {
        var e = this
          , g = this;
        g.waitForCustomerRefresh = !0;
        this.swymApiPost({
            endpoint: "/lists/user-validate-sync",
            params: {
                platform: a,
                extuid: b,
                extras: d || {}
            },
            callbackFn: function(a) {
                g.waitForCustomerRefresh = !1;
                var b = a.regid
                  , d = g.get(g.key.REGID);
                a.email && e.setSwymEmail(a.email);
                b && d != b && (SwymUtils.isUndefined(a.regn) && (a.regn = SwymUtils.deepcopy(a)),
                g.authn.cacheLoadScb({}, [a]),
                g.set(g.key.REGID, b),
                g.triggerSwymEvent(g.JSEvents.customerInfoRefreshed));
                c && c()
            },
            errorFn: function() {
                g.waitForCustomerRefresh = !1;
                c && c()
            },
            customerRefresh: !0,
            sendRegId: !0,
            sendSessionId: !0,
            noProvider: !0,
            v3: !0
        })
    }
    ;
    h.prototype.reportOrderId = function(a, b, c) {
        this.swymApiPost({
            endpoint: "/reportOrderId",
            params: {
                orderid: a,
                orderval: b
            },
            callbackFn: function(a, b) {
                c && c(a, b)
            },
            errorFn: function() {
                c(null)
            },
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.addProductsToList = function(a, b, c, d, e) {
        var g = this;
        this.updateSingleListCtx(a, "a", b, function(d) {
            d.a.forEach(function(a) {
                a && !a.error ? g.triggerSwymEvent(h.JSEvents.addedToWishlist, a) : e && e(a ? a.error : a)
            });
            c(d.a, b, a);
            g.scheduleUserPreferenceAsk()
        }, d)
    }
    ;
    h.prototype.addProductToLists = function(a, b, c, d, e) {
        var g = this;
        this.updateMultipleListCtx(a, "a", b, function(f) {
            var l = [];
            f.a.forEach(function(a) {
                a && a.error ? (e && e(a),
                l.push(a)) : a && g.triggerSwymEvent(h.JSEvents.addedToWishlist, a)
            });
            l.length ? d(l) : c(f.a, a, b);
            g.scheduleUserPreferenceAsk()
        }, d)
    }
    ;
    h.prototype.removeProductsFromList = function(a, b, c, d, e) {
        var g = this;
        this.updateSingleListCtx(a, "d", b, function(d) {
            d.d.forEach(function(a) {
                a && !a.error ? g.triggerSwymEvent(h.JSEvents.removedFromWishlist, a) : e && e(a ? a.error : a)
            });
            c(d.d, b, a)
        }, d)
    }
    ;
    h.prototype.removeProductFromLists = function(a, b, c, d, e) {
        var g = this;
        this.updateMultipleListCtx(a, "d", b, function(d) {
            d.d.forEach(function(a) {
                a && !a.error ? g.triggerSwymEvent(h.JSEvents.removedFromWishlist, a) : e && e(a ? a.error : a)
            });
            c(d.d, a, b)
        }, d)
    }
    ;
    h.prototype.addToList = function(a, b, c, d, e, g) {
        var f = this;
        this.updateSingleListCtx(a, "a", [b], function(a) {
            if (!e) {
                a = a.a[0];
                if (a.error) {
                    d(a.error);
                    return
                }
                g || f.triggerSwymEvent(h.JSEvents.addedToWishlist, a)
            }
            f.scheduleUserPreferenceAsk();
            c(b)
        }, d)
    }
    ;
    h.prototype.updateListItem = function(a, b, c, d) {
        this.updateSingleListCtx(a, "u", [b], function(d) {
            c(d.u[0]);
            b;
            a
        }, d)
    }
    ;
    h.prototype.deleteListItem = h.prototype.deleteFromList = function(a, b, c, d) {
        var e = this;
        this.updateSingleListCtx(a, "d", [b], function(d) {
            d.d.forEach(function(a) {
                e.triggerSwymEvent(h.JSEvents.removedFromWishlist, a)
            });
            c(d.d[0], b, a)
        }, d)
    }
    ;
    h.prototype.updateSingleListCtx = function(a, b, c, d, e) {
        c.forEach(function(a) {
            ["epi", "empi", "du"].forEach(function(b) {
                if (!a[b])
                    throw Error("List item must have epi, empi & du");
            });
            if (a.cprops && "object" !== typeof a.cprops)
                throw Error("cprops should be an object");
            a.du && SwymUtils.validateUrl(a.du) && (a.du = (new URL(a.du)).href)
        });
        a = {
            lid: a
        };
        a[b] = c;
        this.swymApiPost({
            endpoint: "/lists/update-ctx",
            params: a,
            noProvider: !0,
            callbackFn: function(a, b) {
                d && d(a, b)
            },
            errorFn: e,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.updateMultipleListCtx = function(a, b, c, d, e) {
        a.du && SwymUtils.validateUrl(a.du) && (a.du = (new URL(a.du)).href);
        a = {
            listItem: a
        };
        a[b] = c;
        this.swymApiPost({
            endpoint: "/lists/update-multiple-ctx",
            params: a,
            noProvider: !0,
            callbackFn: function(a, b) {
                d && d(a, b)
            },
            errorFn: e,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.createList = function(a, b, c) {
        ["lname"].forEach(function(b) {
            if (!a[b])
                throw Error("List definition must have lname (list name)");
        });
        this.swymApiPost({
            endpoint: a.foruser ? "/lists/create-for" : "/lists/create",
            params: a,
            noProvider: !0,
            callbackFn: function(a, c) {
                b && b(a, c)
            },
            errorFn: c,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.createLists = function(a, b, c, d) {
        var e = this;
        a.forEach(function(a) {
            ["lname"].forEach(function(b) {
                if (!a[b])
                    throw Error("List definition must have lname (list name)");
            })
        });
        this.swymApiPost({
            endpoint: "/lists/create-multiple",
            params: {
                lists: a
            },
            noProvider: !0,
            callbackFn: function(a, c) {
                for (var f = 0; f < (d || 0); f++)
                    e.triggerSwymEvent(h.JSEvents.addedToWishlist, a);
                b && b(a, c)
            },
            errorFn: c,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.createListsFor = function(a, b, c, d) {
        a.forEach(function(a) {
            ["lname"].forEach(function(b) {
                if (!a[b])
                    throw Error("List definition must have lname (list name)");
            })
        });
        this.swymApiPost({
            endpoint: "/lists/create-multiple-for",
            params: {
                foruser: b,
                lists: a
            },
            noProvider: !0,
            callbackFn: function(a, b) {
                c && c(a, b)
            },
            errorFn: d,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.updateList = function(a, b, c) {
        var d = {};
        "lid lty lname lnote ldesc lprops".split(" ").forEach(function(b) {
            d[b] = a[b]
        });
        this.swymApiPost({
            endpoint: "/lists/update",
            params: d,
            noProvider: !0,
            callbackFn: function(a, c) {
                b && b(a, c)
            },
            errorFn: c,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.updateArchivalTime = function(a, b, c) {
        var d = {};
        ["lid", "archMs"].forEach(function(b) {
            d[b] = a[b]
        });
        this.swymApiPost({
            endpoint: "/lists/updateArchivalTime",
            params: d,
            noProvider: !0,
            callbackFn: function(a, c) {
                b && b(a, c)
            },
            errorFn: c,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.fetchListsMine = function(a, b, c) {
        this.swymApiPost({
            endpoint: "/lists/fetch-lists",
            params: a,
            noProvider: !0,
            callbackFn: b,
            errorFn: c,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.fetchListsFor = function(a, b, c) {
        this.swymApiPost({
            endpoint: "/lists/fetch-lists-for",
            params: {
                foruser: a.foruser
            },
            noProvider: !0,
            sendSessionId: !1,
            callbackFn: b,
            errorFn: c,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.fetchListShares = function(a, b, c) {
        this.swymApiPost({
            endpoint: "/lists/fetch-shares",
            params: {},
            noProvider: !0,
            callbackFn: function(a, c) {
                b && b(a, c)
            },
            errorFn: c,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.fetchLists = function(a) {
        var b = this
          , c = a.foruser;
        c ? b.fetchListsFor({
            foruser: c,
            lty: a.lty
        }, function(b, c) {
            a.callbackFn && a.callbackFn(b, {
                sharedWithMe: b,
                mine: []
            }, c)
        }, a.errorFn) : a.lty ? b.fetchListsMine({
            lty: a.lty
        }, function(b, c) {
            a.callbackFn && a.callbackFn(b, {
                mine: b
            }, c)
        }, a.errorFn) : b.fetchListsMine({}, function(c, e) {
            a.includeSharedWithMe ? b.fetchListsSharedWithMe({}, function(b) {
                a.callbackFn && a.callbackFn(c.concat.apply(c, b), {
                    sharedWithMe: b,
                    mine: c
                }, e)
            }, a.errorFn) : a.callbackFn && a.callbackFn(c, {
                sharedWithMe: [],
                mine: c
            }, e)
        }, a.errorFn)
    }
    ;
    h.prototype.fetchListDetails = function(a, b, c) {
        this.swymApiPost({
            endpoint: "/lists/fetch-list-with-contents",
            params: {
                lid: "string" == typeof a ? a : a.lid
            },
            noProvider: !0,
            callbackFn: function(a, c) {
                b && b(a, c)
            },
            errorFn: c,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.fetchListCtx = function(a, b, c) {
        a = "string" == typeof a ? a : a.lid;
        if (!a)
            throw Error("List ID (lid) is required in listConfig object");
        var d = this;
        this.swymApiPost({
            endpoint: "/lists/fetch-ctx",
            params: {
                lid: a
            },
            noProvider: !0,
            callbackFn: function(a, c) {
                var f = [];
                a.epis.forEach(function(b) {
                    var c = a.metadata.filter(function(a) {
                        return b.epi == a.epi
                    })[0]
                      , g = d.transformProductMetadata(c);
                    g.product = c;
                    f.push(Object.assign({}, b, g))
                });
                b && b(f, c)
            },
            errorFn: c,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.deleteList = function(a, b, c) {
        var d = this;
        this.swymApiPost({
            endpoint: "/lists/delete-list",
            params: {
                lid: a
            },
            noProvider: !0,
            callbackFn: function(a, c) {
                for (var f = 0; f < a.cnt; f++)
                    d.triggerSwymEvent(h.JSEvents.removedFromWishlist, {});
                b && b(a, c)
            },
            errorFn: c,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.shopper.fetchRecentlyViewedProducts = function(a, b) {
        f = window._swat;
        f.swymApiPost({
            endpoint: "/shopper/fetch-recently-viewed-products",
            params: {},
            noProvider: !0,
            callbackFn: function(b, d) {
                a && a(b)
            },
            errorFn: b,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.shopper.fetchSavedCartProducts = function(a, b) {
        f = window._swat;
        f.swymApiPost({
            endpoint: "/shopper/fetch-saved-cart-products",
            params: {},
            noProvider: !0,
            callbackFn: function(b, d) {
                a && a(b)
            },
            errorFn: b,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.markListPublic = function(a, b, c) {
        this.swymApiPost({
            endpoint: "/lists/markPublic",
            params: {
                lid: a
            },
            noProvider: !0,
            callbackFn: function(a, c) {
                b && b(a, c)
            },
            errorFn: c,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.makeListShortlink = function(a, b, c) {
        this.swymApiPost({
            endpoint: "/lists/make-shortlink",
            params: a,
            noProvider: !0,
            callbackFn: function(a, c) {
                b && b(a, c)
            },
            errorFn: c,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.markListPrivate = function(a, b, c) {
        this.swymApiPost({
            endpoint: "/lists/markPrivate",
            params: {
                lid: a
            },
            noProvider: !0,
            callbackFn: function(a, c) {
                b && b(a, c)
            },
            errorFn: c,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.markListArchived = function(a, b, c) {
        this.swymApiPost({
            endpoint: "/lists/markArchived",
            params: {
                lid: a
            },
            noProvider: !0,
            callbackFn: function(a, c) {
                b && b(a, c)
            },
            errorFn: c,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.markListUnarchived = function(a, b, c) {
        this.swymApiPost({
            endpoint: "/lists/markUnarchived",
            params: {
                lid: a
            },
            noProvider: !0,
            callbackFn: function(a, c) {
                b && b(a, c)
            },
            errorFn: c,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.fetchListsSharedWithMe = function(a, b, c) {
        this.swymApiPost({
            endpoint: "/lists/fetch-lists-shared-with-me",
            params: {},
            noProvider: !0,
            callbackFn: function(a, c) {
                b && b(a, c)
            },
            errorFn: c,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.assignListTo = function(a, b, c, d) {
        this.swymApiPost({
            endpoint: "/lists/assign-to-user",
            noProvider: !0,
            params: {
                assignTo: a,
                note: d.note
            },
            callbackFn: function(a, c) {
                b && b(a, c)
            },
            errorFn: c,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.notifyStore = function(a, b, c) {
        this.swymApiPost({
            endpoint: "/lists/notify-store",
            noProvider: !0,
            params: {
                note: c.note
            },
            callbackFn: function(b, c) {
                a && a(b, c)
            },
            errorFn: b,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.fetchUserMeta = function(a, b) {
        this.swymApiPost({
            endpoint: "/lists/usermeta",
            noProvider: !0,
            callbackFn: function(b, d) {
                a && a(b, d)
            },
            errorFn: b,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.getListsForProduct = function(a, b, c) {
        this.api.fetchLists({
            callbackFn: function(c) {
                var e = [];
                c.forEach(function(b) {
                    var c = b.listcontents.filter(function(b) {
                        return b.epi == a.epi
                    })[0];
                    c && e.push({
                        list: b,
                        listItem: c
                    })
                });
                b && b(e)
            },
            errorFn: c
        })
    }
    ;
    h.prototype.sendEmailList = function(a, b, c, d, e, g, f) {
        this.sendEmailListInternal(b, c, d, e, f, a, g)
    }
    ;
    h.prototype.sendListViaEmail = function(a, b, c) {
        this.sendEmailListInternal(a.toEmailId, a.fromName, a.note, a.lid, a.cprops, b, c)
    }
    ;
    h.prototype.fetchList = function(a, b, c) {
        var d = {};
        ["lid", "excludeArchived"].forEach(function(b) {
            d[b] = a[b]
        });
        this.swymApiPost({
            endpoint: "/lists/fetch-list",
            params: d,
            noProvider: !0,
            callbackFn: function(a, c) {
                b(a)
            },
            errorFn: c,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.fetchListSharedWith = function(a, b, c) {
        this.swymApiPost({
            endpoint: "/lists/fetch-list-shared-with",
            params: {
                lid: a
            },
            noProvider: !0,
            callbackFn: function(a, c) {
                b(a)
            },
            errorFn: c,
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.sendEmailListInternal = function(a, b, c, d, e, g, f) {
        if (!SwymUtils.validateEmail(a))
            throw Error("Invalid email address");
        d ? (a = {
            toemail: a.toLowerCase(),
            fromname: b,
            note: c,
            lid: d
        },
        this.swymApiPost({
            endpoint: "/lists/emailList",
            noProvider: !0,
            params: a,
            callbackFn: g,
            errorFn: f,
            checkRegId: !0,
            v3: !0
        })) : this.sendEmailWishListInternal(a, b, c, null, g, f)
    }
    ;
    h.prototype.isInList = function(a, b) {
        a.forEach(function(a) {
            ["epi", "empi"].forEach(function(b) {
                if (!a[b])
                    throw Error("List item must have epi, empi & du");
            })
        });
        var c = [];
        this.swymApiPost({
            endpoint: "/lists/listsForProducts",
            params: {
                products: a
            },
            noProvider: !0,
            callbackFn: function(d, e) {
                var g = d.epis;
                a.forEach(function(a) {
                    for (var b = 0; b < g.length; b++)
                        a.epi == g[b].epi && c.push(a)
                });
                b && b(c)
            },
            checkRegId: !0,
            v3: !0
        })
    }
    ;
    h.prototype.removeWishlistDefault = function(a, b) {
        var c = this;
        this.swymApiPost({
            endpoint: "/removeWishlistDefault",
            params: {},
            callbackFn: function(b, e) {
                c.productEts.makeCacheStale();
                a(b);
                c.triggerSwymEvent(h.JSEvents.removeWishlistCollection, {})
            },
            errorFn: b,
            checkRegId: !0,
            sendSessionId: !0,
            v2: !0
        })
    }
    ;
    var Ka = {
        trackPageview: 150,
        addToWishList: 151,
        addToCart: 152,
        replayAddToCart: 153,
        addToWatchList: 154,
        sendWatchlist: 155,
        removeFromWishList: 156,
        sendEmailList: 157,
        updateUserPreferences: 159,
        deleteEvent: 160,
        fetch: 161,
        fetchWrtEventType: 162,
        authCheck: 163,
        getProductDetails: 164,
        fetchWrtEventTypeET: 165,
        fetchWishlistWRTHashtag: 166,
        addCollectionsToProduct: 167,
        addProductsToCollection: 168,
        getAllCollections: 169,
        removeCollectionsFromProduct: 170,
        removeProductsFromCollection: 171,
        removeWishlistCollection: 172,
        shareWishlistSocial: 173,
        generateSharedWishlistURL: 174,
        generateSharedListURL: 174
    }
      , La = {
        fetchRecentlyViewedProducts: 175,
        fetchSavedCartProducts: 176
    }
      , ma = {
        fetch: !1,
        fetchWrtEventType: !1,
        fetchWrtEventTypeET: !1,
        fetchWishlistWRTHashtag: !1,
        getProductDetails: !1,
        authCheck: !1,
        generateSharedWishlistURL: !1
    }
      , lb = {
        createList: 250,
        deleteList: 251,
        updateList: 252,
        fetchLists: 253,
        fetchListDetails: 254,
        fetchListCtx: 255,
        addToList: 256,
        deleteFromList: 257,
        updateListItem: 258,
        addProductsToList: 259,
        removeProductsFromList: 260,
        addProductToLists: 261,
        removeProductFromLists: 262,
        markListPublic: 263,
        sendListViaEmail: 264,
        shareListSocial: 265,
        saveShopperContext: 270,
        disconnectShopperContext: 271,
        subscribeForProductAlert: 272,
        fetchSubscriptions: 281
    }
      , nb = {
        addComment: 266,
        fetchListComments: 267,
        fetchListItemComments: 268,
        deleteComment: 269
    }
      , ob = {
        fetchUserLists: 273,
        fetchPaginatedList: 274,
        getSocialCount: 275
    }
      , mb = {
        init: 276,
        add: 277,
        remove: 278,
        fetch: 279,
        update: 280
    }
      , db = function(a, b, c) {
        return function() {
            c(f.Instrumentations[a], {
                channel: "custom-js-api"
            });
            return b.apply(f, arguments)
        }
    }
      , ca = function(a, b, c) {
        c = void 0 === c ? null : c;
        Object.keys(a).forEach(function(d) {
            var e = Y(d, c);
            f.Instrumentations[e] = a[d];
            var g = c ? f[c][d] : f[d];
            g ? c ? (f[c][d] = db(e, g, b),
            f.api[c][d] = function() {
                return g.apply(f, arguments)
            }
            ) : (f[d] = db(e, g, b),
            f.api[d] = function() {
                return g.apply(f, arguments)
            }
            ) : SwymUtils.log("" + (c ? c + "." : "") + d + " function not exist, not instrumented")
        })
    };
    swymModules.push({
        id: "apiinstrument",
        init: function() {
            f = this;
            ib()
        }
    });
    swymModules.push({
        id: "setup",
        events: {
            readRetailerConfig: "sw:readretailerconfig",
            initIntegrations: "sw:initintegrations",
            xhrTrap: "sw:xhrtrap",
            fetchTrap: "sw:fetchtrap",
            wsTrap: "sw:wstrap"
        },
        init: function() {
            function a() {
                if (!window.SwymIntCallbacks._swOriPush) {
                    window.SwymIntCallbacks.forEach(function(a) {
                        var b = {
                            SwymTracker: h,
                            SwymUtils: SwymUtils,
                            _swat: n
                        };
                        try {
                            with (b)
                                a.call(n, n, b)
                        } catch (c) {
                            SwymUtils.error("Error calling window.SwymIntCallbacks", c, b)
                        }
                    });
                    var a = window.SwymIntCallbacks.push;
                    window.SwymIntCallbacks._swOriPush = a;
                    window.SwymIntCallbacks.push = function(b) {
                        var c = {
                            SwymTracker: h,
                            SwymUtils: SwymUtils,
                            _swat: n
                        };
                        try {
                            with (c)
                                b.call(n, n, c)
                        } catch (d) {
                            SwymUtils.error("Error calling window.SwymIntCallbacks", d, c)
                        }
                        a.apply(this, [b])
                    }
                }
            }
            function b() {
                m = m || window[window.SwymRetailerConfig] || function(a, b) {
                    this[a] = b
                }
                ;
                if (m.RetailerId)
                    (m.BaseConfig || getSwymConfig)(),
                    SwymUtils.onDOMReady(c);
                else {
                    SwymUtils.warn("No Retailer Id specified! Maybe lazy initialized. Keeping in wait");
                    var a = m;
                    m.LoadState || (SwymUtils.log("Setting load state now"),
                    m.LoadState = 1,
                    m = function(c, d) {
                        var e = a.apply(a, arguments);
                        m[c] = d;
                        setTimeout(b, 100);
                        return e
                    }
                    ,
                    n.postLoader = window[window.SwymRetailerConfig] = m)
                }
            }
            function c() {
                SwymUtils.addClass(document.body, "swym-loading");
                if (2 == m.LoadState)
                    try {
                        r || M(m.PreCallback) || (m.PreCallback.call(n, n),
                        r = !0)
                    } catch (b) {
                        SwymUtils.error("Error calling continueConfig pre callback", b)
                    }
                else if (3 == m.LoadState)
                    try {
                        p || M(m.Callback) || (m.Callback.call(n, n),
                        p = !0)
                    } catch (b) {
                        SwymUtils.error("Error calling continueConfig post callback", b)
                    }
                else
                    a(),
                    m.LoadState = 2,
                    d(n)
            }
            function d(a) {
                if (-1 < [].indexOf(m.RetailerId))
                    a.turnOff();
                else {
                    if (!M(m.PreCallback))
                        try {
                            m.PreCallback.call(a, a),
                            r = !0
                        } catch (b) {
                            SwymUtils.error("Error calling config precallback", b)
                        }
                    var c = SwymUtils.getSWAction();
                    SwymUtils.getParameterByName("swfilter");
                    "clearcache" == c && a.clearSettingsCache();
                    a.setRetailerId(m.RetailerId);
                    a.readRetailerConfig(function(b, c, d) {
                        if (b.settings) {
                            var e = function() {
                                SwymUtils.removeClass(document.body, "swym-loading");
                                SwymUtils.addClass(document.body, "swym-ready");
                                a.notepad = {
                                    openNotepad: function() {
                                        a.ui.open.apply(a.ui, arguments)
                                    },
                                    closeNotepad: function() {
                                        a.ui.close.apply(a.ui, arguments)
                                    }
                                };
                                a.retailerSettings.RelayUI = a.retailerSettings.UI;
                                a.retailerSettings.UI.DisableOOSFormEmailPrefill && a.storage.remove(a.key.WEML);
                                if (!M(m.Callback))
                                    try {
                                        m.Callback.call(a, a),
                                        p = !0
                                    } catch (b) {
                                        SwymUtils.error("Error calling config postcallback", b)
                                    }
                                m.LoadState = 3;
                                a.processCallbacks();
                                a.triggerSwymEvent(a.JSEvents.configLoaded);
                                g(a);
                                l(a);
                                f(a)
                            };
                            m.Settings = SwymUtils.safeJSONParse(b.settings);
                            a.retailerSettings = m.Settings;
                            m.Settings = SwymUtils.deepExtendDefaults(m.Settings, bb);
                            var r = SwymUtils.originalRenderFn = SwymUtils.renderTemplateString;
                            SwymUtils.renderTemplateString = function(b, c) {
                                c.STRINGS = a.retailerSettings.Strings;
                                c.SETTINGS = a.retailerSettings;
                                return r.apply(SwymUtils, [b, c])
                            }
                            ;
                            a.triggerSwymEvent(a.JSEvents.readRetailerConfig, m);
                            M(m.Settings) ? e() : (m.HideUIOverride && (m.Settings.UI.Enabled = !1,
                            m.Settings.Watchlist.Enabled = !1,
                            m.Settings.Wishlist.Enabled = !1),
                            a.setRetailerSettings(m.Settings),
                            b = m.Settings.General,
                            c = m.Settings.UI,
                            b.Enabled || (a.turnOff(),
                            c.Enabled = !1,
                            c = {}),
                            a.setCurrency(b.Currency),
                            b = (b.URLTagging || "").toLowerCase(),
                            "utm" == b ? h.prototype.tagURL = h.prototype.tagURLWithUTM : "hash" == b && (h.prototype.tagURL = h.prototype.tagURLWithHash),
                            a.triggerSwymEvent(a.JSEvents.initIntegrations),
                            a.initializeUi ? a.initializeUi(function(b) {
                                b && a.initCustomLaunchPoints();
                                e()
                            }) : e())
                        } else
                            SwymUtils.log("No settings found for retailer")
                    }, function() {
                        SwymUtils.log("Retailer config not found, could be Magento extension", !0)
                    })
                }
            }
            function e(a, b) {
                var c = b.open;
                b.open = function(a, b) {
                    try {
                        this._swAction = b,
                        this._swMethod = a,
                        this._swHeaders = {},
                        this._swIsSWAction = -1 < b.indexOf("swymrelay.com|interfaceStore.php")
                    } catch (d) {
                        SwymUtils.error("Error -- XHR.open - ", d)
                    }
                    c.apply(this, arguments)
                }
                ;
                b.open.toString = function() {
                    return "Swym - " + c.toString()
                }
                ;
                b.wrappedSetRequestHeader = b.setRequestHeader;
                b.setRequestHeader = function(a, b) {
                    try {
                        this.wrappedSetRequestHeader(a, b),
                        this._swHeaders = this._swHeaders || {},
                        this._swHeaders[a] = b
                    } catch (c) {
                        SwymUtils.error("Error -- XHR.setRequestHeader - ", c)
                    }
                }
                ;
                b.setRequestHeader.toString = function() {
                    return "Swym - " + this.wrappedSetRequestHeader.toString()
                }
                ;
                var d = b.send;
                b.send = function() {
                    try {
                        this._swData = arguments[0];
                        this._swOnSendComplete = null;
                        this._swOnSendCallbacks = [];
                        this._swAction || (this._swAction = this._url || "");
                        this._swAddSendCallbacks = function(a) {
                            this._swOnSendCallbacks.push(a)
                        }
                        ;
                        a.triggerSwymEvent(a.JSEvents.xhrTrap, this);
                        if (this._swOnSendComplete && this.addEventListener) {
                            var b = this;
                            this.addEventListener("load", function(a) {
                                b._swOnSendComplete.apply(b, arguments)
                            })
                        }
                        this.addEventListener && 0 < this._swOnSendCallbacks.length && (b = this,
                        this.addEventListener("load", function(a) {
                            b._swOnSendCallbacks.forEach(function(a) {
                                try {
                                    a.apply(b, arguments)
                                } catch (c) {
                                    SwymUtils.error("Error -- XHR.send Callbacks - ", c)
                                }
                            })
                        }))
                    } catch (c) {
                        SwymUtils.error("Error -- XHR.send - ", c)
                    }
                    d.apply(this, arguments)
                }
                ;
                b.send.toString = function() {
                    return "Swym - " + d.toString()
                }
                ;
                return b
            }
            function g(a) {
                var b = XMLHttpRequest;
                window._swymXMLHttpRequest && (b = window._swymXMLHttpRequest);
                b.prototype._swymd || (b.prototype._swymd = !0,
                e(a, XMLHttpRequest.prototype))
            }
            function f(a) {
                if (window.fetch && !window.fetch.polyfill && !window.fetch._swymd) {
                    window.fetch._swymd = !0;
                    var b = window.fetch;
                    window.fetch = function(c, d) {
                        var e = {};
                        d = d || {};
                        e._swAction = "" + c;
                        e._swOnSendCallbacks = [];
                        e._swAddSendCallbacks = function(a) {
                            e._swOnSendCallbacks.push(a)
                        }
                        ;
                        e._swMethod = d.method || "GET";
                        e._swHeaders = d.headers || {};
                        e._swData = d.body;
                        a.triggerSwymEvent(a.JSEvents.fetchTrap, e);
                        var g = b.apply(this, arguments);
                        e._swOnSendComplete && (g = g.then(function(a) {
                            e._swOnSendComplete.apply(e, arguments);
                            return a
                        }));
                        if (0 < e._swOnSendCallbacks.length)
                            var f = e
                              , g = g.then(function(a) {
                                f._swfetchReponse = a;
                                f._swOnSendCallbacks.forEach(function(a) {
                                    try {
                                        a.apply(f, arguments)
                                    } catch (b) {
                                        SwymUtils.error("Error -- ", b)
                                    }
                                });
                                return a
                            });
                        return g
                    }
                }
            }
            function l(a) {
                if (window.WebSocket && !window.WebSocket._swymd) {
                    window.WebSocket._swymd = !0;
                    var b = window.WebSocket.prototype.send;
                    window.WebSocket.prototype.send = function() {
                        var c = arguments[0];
                        this._swAction = this.url;
                        this._swData = c;
                        a.triggerSwymEvent(a.JSEvents.wsTrap, this);
                        b.apply(this, arguments)
                    }
                }
            }
            window.SwymCallbacks = window.SwymCallbacks || [];
            window.SwymIntCallbacks = window.SwymIntCallbacks || [];
            var m, p = !1, r = !1, n = this;
            n.holdCallbacks = function() {
                this._holdCallbackLoop = this.retailerSettings && this.retailerSettings.General.LogoutClean && !0
            }
            ;
            n.continueCallbacks = function() {
                this._holdCallbackLoop = !1;
                this.processCallbacks()
            }
            ;
            n.processCallbacks = function() {
                if (3 == m.LoadState && !window.SwymCallbacks._swOriPush && !this._holdCallbackLoop) {
                    n.triggerSwymEvent(n.JSEvents.processCallbacks);
                    window.SwymCallbacks.forEach(function(a) {
                        try {
                            a.call(n, n)
                        } catch (b) {
                            SwymUtils.error("Error calling window.SwymCallbacks", b)
                        }
                    });
                    var a = window.SwymCallbacks.push;
                    window.SwymCallbacks._swOriPush = a;
                    window.SwymCallbacks.push = function(b) {
                        try {
                            b.call(n, n)
                        } catch (c) {
                            SwymUtils.error("Error calling window.SwymCallbacks", c)
                        }
                        a.apply(this, [b])
                    }
                }
            }
            ;
            h.prototype.getRetailerConfig = function(a) {
                return (m || {})[a]
            }
            ;
            b()
        }
    });
    swymModules.push({
        id: "wishlist",
        cfg: {
            Wishlist: {
                Enabled: !1,
                ToggleSwitchState: !0,
                NoButtonInject: !1,
                EnableFaveCount: !0,
                FaveCountSelector: ".swym-fave-count",
                ShowBadge: !0,
                TooltipBefore: "Add to Wishlist",
                TooltipAfter: "Added. <a class='swym-open-ui'>View Wishlist</a>",
                AllowToggle: !1,
                AddCTA: "Add to Wishlist",
                AddedCTA: "Added",
                ButtonType: "icon",
                ButtonIcon: "heart",
                ButtonIconAdded: "",
                AttachButtonSelector: "",
                CreateCustomButtonBefore: "",
                OoSAttachButtonSelector: "",
                OoSCreateCustomButtonBefore: "",
                AddClasses: "",
                DisallowedTags: ["swym-wl-disabled"],
                AllowSharing: !1,
                RemoveClasses: "",
                SharingModes: [{
                    type: "facebook",
                    iconurl: "https://swymdev.azureedge.net/swym-shared/facebook.png",
                    url: "https://www.facebook.com/sharer.php?u={{shareurl}}&t={{note}}"
                }, {
                    type: "twitter",
                    iconurl: "https://swymdev.azureedge.net/swym-shared/twitter.png",
                    url: "https://www.twitter.com/intent/tweet?url={{shareurl}}&text={{note}}"
                }],
                ShareBaseUrl: "{{{storeurl}}}{{{hostedshareurl}}}?hkey={{hkey}}&lid={{lid}}",
                ShareShowConnect: !0,
                ShareShowSiteLogin: !0,
                ShareWithEmailIconUrl: "https://swymdev.azureedge.net/swym-shared/email-icon.png",
                EnableCollections: !1,
                HashtagEditorPreset: []
            }
        },
        init: function() {
            this.evtLayer.addEventListener(this.JSEvents.preReadSettings, function(a) {
                (a = a.detail.d.settings) && 2 != a.General._v && a.Wishlist && (a = a.Wishlist,
                a.NoButtonInject = a.UseCustomButton)
            });
            var a = this;
            a.wishlistSources = {
                cg: "collections-grid",
                pdp: "pdp",
                qv: "quick-view",
                fg: "featured-grid",
                recos: "recommendations",
                sr: "search-results"
            };
            a.setupUIModule("Wishlist", "Wishlist", ["Enabled", "AllowSharing"], function() {
                a.retailerSettings.UI.Enabled = !0
            }, function(b) {
                var c = a.retailerSettings.UI
                  , d = a.retailerSettings.Wishlist
                  , e = c.Color;
                c.LauncherType && "floating" != c.LauncherType && (c.LauncherLocation = "custom",
                e = d.ButtonColor);
                e && (b.htmlText += "#swym-plugin .swym-primary-background-color {background: " + e + " !important;} #swym-plugin .swym-primary-border-color {border-color: " + e + " !important;} #swym-plugin .swym-primary-color {color: " + e + " !important;}",
                b.htmlText += ".swym-background-color,#swym-notification.swym-santa .swym-image { background-color: " + e + " !important; }",
                b.htmlText += "@media (max-width: 820px){ #swym-plugin #swym-notepad .swym-item-filter li.is-active { background-color: " + e + " !important; } }",
                b.htmlText += ".swym-text-color { color: " + e + " !important; }");
                d.ButtonType || (d.ButtonType = "icon");
                if (d.ButtonColor) {
                    b.htmlText += ".swym-add-to-wishlist-view-product:after{color: " + d.ButtonColor + " !important;}";
                    var g = ["icon", "btnlink", "iconbtnlink"];
                    -1 < g.indexOf(d.ButtonType) ? b.htmlText += ".swym-add-to-wishlist, .swym-add-to-wishlist:after, .swym-fave-count {color: " + d.ButtonColor + " !important;}" : b.htmlText += ".swym-add-to-wishlist {background: " + d.ButtonColor + " !important; color: #FFF !important;} .swym-add-to-wishlist+.swym-fave-count{border-color: " + d.ButtonColor + " !important;}";
                    b.htmlText += "#swym-trigger-email-auth-button {background: " + d.ButtonColor + " !important; color: #FFF !important;}"
                }
                d.AddedButtonColor && (b.htmlText += ".swym-added.swym-add-to-wishlist-view-product:after{color: " + d.AddedButtonColor + " !important;}",
                g = ["icon", "btnlink", "iconbtnlink"],
                -1 < g.indexOf(d.ButtonType) ? b.htmlText += ".swym-added.swym-add-to-wishlist, .swym-added.swym-add-to-wishlist:after, .swym-added.swym-add-to-wishlist + .swym-fave-count {color: " + d.AddedButtonColor + " !important;}" : b.htmlText += ".swym-added.swym-add-to-wishlist {background: " + d.AddedButtonColor + " !important; color: #FFF !important;} .swym-added.swym-add-to-wishlist+.swym-fave-count{border-color: " + d.AddedButtonColor + " !important;}");
                if (d.Customizations) {
                    e = d.Customizations;
                    c = function(a) {
                        var b = null;
                        a = Object.assign({}, a);
                        "custom"in a && (b = a.custom,
                        delete a.custom);
                        return {
                            styles: JSON.stringify(a).replaceAll('"', "").replaceAll(",", "!important;").replaceAll("}", "!important }"),
                            customStyles: b
                        }
                    }
                    ;
                    if (e.AddToWishlistButton) {
                        g = ["icon", "btnlink", "iconbtnlink"];
                        if (e.AddToWishlistButton.ATWButtonTexts) {
                            var f = e.AddToWishlistButton.ATWButtonTexts;
                            b.htmlText += ".swym-add-to-wishlist" + c(f).styles;
                            "color"in f && (b.htmlText += ".swym-add-to-wishlist:after {color: " + f.color + " !important}",
                            -1 < g.indexOf(d.ButtonType) && (b.htmlText += ".swym-fave-count {color: " + f.color + " !important;}"))
                        }
                        if (e.AddToWishlistButton.ATWButtonFormatting && (f = e.AddToWishlistButton.ATWButtonFormatting,
                        -1 == g.indexOf(d.ButtonType) && (b.htmlText += ".swym-add-to-wishlist" + c(f).styles,
                        f["border-width"] || f["border-color"]) && (b.htmlText += ".swym-add-to-wishlist{border-style: solid !important}"),
                        "border-color"in f && (b.htmlText += ".swym-add-to-wishlist+.swym-fave-count {border-color:  " + f["border-color"] + " !important}"),
                        f = c(f).customStyles,
                        null != f && f.ATWButtonFit))
                            switch (f.ATWButtonFit) {
                            case "Fill Width":
                                -1 == g.indexOf(d.ButtonType) && (b.htmlText += ".swym-button-bar.swym-wishlist-button-bar{width: 100% !important; margin-left: 0 !important; margin-right: 0 !important} .swym-btn-container{display: flex !important; justify-content: space-between !important;} .swym-add-to-wishlist{width: 100% !important}",
                                "icontext" == d.ButtonType && (b.htmlText += ".swym-button.swym-add-to-wishlist:after{content : unset !important} .swym-button.swym-add-to-wishlist:before{content : '\uf08a'; font-family: 'swym-font';} .swym-button.swym-add-to-wishlist {display: flex !important; justify-content: center !important; align-items: center !important;}"));
                                break;
                            case "Custom":
                                b.htmlText += ".swym-button-bar.swym-wishlist-button-bar{height: " + f.ATWButtonHeight + "!important;width: " + f.ATWButtonWidth + "!important;max-width: 100%;margin-left: 0 !important; margin-right: 0 !important} .swym-btn-container{display: flex !important; justify-content: space-between !important;} .swym-add-to-wishlist{width: 100% !important}.swym-add-to-wishlist{height: " + f.ATWButtonHeight + "!important}.swym-fave-count{display: flex !important; align-items:center !important; height: " + f.ATWButtonHeight + "!important}"
                            }
                    }
                    e.WishlistUIButtons && (e.WishlistUIButtons.WishlistUIButtonStyling && (g = e.WishlistUIButtons.WishlistUIButtonStyling,
                    b.htmlText += ".swym-wishlist-grid .swym-wishlist-item .swym-add-to-cart-btn, .swym-wishlist-product-detail-content .swym-wishlist-add-to-cart-btn{background: " + g["background-color"] + "}",
                    b.htmlText += ".swym-empty-wishlist-container .swym-empty-wishlist-continue-btn{background: " + g["background-color"] + "}",
                    b.htmlText += ".swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-summary .swym-login-btn{background: " + g["background-color"] + "}",
                    b.htmlText += ".swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-logged-in .swym-log-out-btn{background: " + g["background-color"] + "}",
                    b.htmlText += ".swym-add-wishlist-modal .swym-modal-content .swym-add-to-list-btn{background: " + g["background-color"] + "}",
                    b.htmlText += ".swym-ui-components .swym-add-wishlist-modal .swym-wishlist-item .swym-icon::before, .swym-add-wishlist-modal .swym-wishlist-item .swym-icon::before{color: " + g["background-color"] + " !important}",
                    b.htmlText += ".swym-add-wishlist-modal .swym-modal-content .swym-new-wishlist-btn{border-color: " + g["background-color"] + "; border-width: " + g["border-width"] + "}",
                    b.htmlText += ".swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-summary .swym-save-list-btn{border-color: " + g["background-color"] + "; border-width: " + g["border-width"] + "}",
                    b.htmlText += ".swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-list .swym-save-list-btn{background: " + g["background-color"] + "}",
                    b.htmlText += ".swym-duplicate-wishlist-modal .swym-duplicate-wishlist-modal-dialog .swym-duplicate-wishlist-btn{background: " + g["background-color"] + "}",
                    b.htmlText += ".swym-mailing-list-modal .swym-mailing-list-modal-dialog .swym-add-mailing-list-btn{background: " + g["background-color"] + "}",
                    b.htmlText += ".swym-share-wishlist-modal .swym-share-wishlist-modal-dialog .swym-share-wishlist-email-btn{background: " + g["background-color"] + "}",
                    b.htmlText += ".swym-clear-wishlist-modal .swym-clear-wishlist-modal-dialog .swym-clear-wishlist-btn{background: " + g["background-color"] + "}",
                    b.htmlText += ".swym-clear-wishlist-modal .swym-clear-wishlist-modal-dialog .swym-cancel-clear-wishlist-btn{border-color: " + g["background-color"] + "; border-width: " + g["border-width"] + "}"),
                    e.WishlistUIButtons.WishlistUIFilledButtonText && (g = c(e.WishlistUIButtons.WishlistUIFilledButtonText).styles,
                    b.htmlText += ".swym-wishlist-grid .swym-wishlist-item .swym-add-to-cart-btn, .swym-wishlist-product-detail-content .swym-wishlist-add-to-cart-btn" + g,
                    b.htmlText += ".swym-add-wishlist-modal .swym-modal-content .swym-add-to-list-btn" + g,
                    b.htmlText += ".swym-empty-wishlist-container .swym-empty-wishlist-continue-btn" + g,
                    b.htmlText += ".swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-summary .swym-login-btn" + g,
                    b.htmlText += ".swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-logged-in .swym-log-out-btn" + g,
                    b.htmlText += ".swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-list .swym-save-list-btn" + g,
                    b.htmlText += ".swym-duplicate-wishlist-modal .swym-duplicate-wishlist-modal-dialog .swym-duplicate-wishlist-btn" + g,
                    b.htmlText += ".swym-mailing-list-modal .swym-mailing-list-modal-dialog .swym-add-mailing-list-btn" + g,
                    b.htmlText += ".swym-share-wishlist-modal .swym-share-wishlist-modal-dialog .swym-share-wishlist-email-btn" + g,
                    b.htmlText += ".swym-clear-wishlist-modal .swym-clear-wishlist-modal-dialog .swym-clear-wishlist-btn" + g),
                    e.WishlistUIButtons.WishlistUIPlainButtonText && (g = e.WishlistUIButtons.WishlistUIPlainButtonText,
                    f = c(g).styles,
                    b.htmlText += ".swym-add-wishlist-modal .swym-modal-content .swym-new-wishlist-btn" + f,
                    b.htmlText += ".swym-wishlist-list-card .swym-wishlist-link" + f,
                    b.htmlText += ".swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-list .swym-back-btn" + f,
                    b.htmlText += ".swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-summary .swym-save-list-btn" + f,
                    b.htmlText += ".swym-action-bar .swym-back-btn" + f,
                    b.htmlText += ".swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-logged-in .swym-back-btn" + f,
                    b.htmlText += ".swym-mailing-list-modal .swym-mailing-list-modal-dialog .swym-cancel-mailing-list-btn" + f,
                    b.htmlText += ".swym-clear-wishlist-modal .swym-clear-wishlist-modal-dialog .swym-cancel-clear-wishlist-btn" + f,
                    b.htmlText += ".swym-duplicate-wishlist-modal .swym-duplicate-wishlist-modal-dialog .swym-cancel-duplicate-wishlist-btn" + f,
                    b.htmlText += ".swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-logged-in .swym-back-btn" + f,
                    b.htmlText += ".swym-wishlist-product-detail-content .swym-more-details-btn" + f,
                    b.htmlText += ".swym-wishlist-context-menu .swym-wishlist-context-menu-item{font-family: " + g["font-family"] + "; font-weight: " + g["font-weight"] + "!important}.swym-wishlist-context-menu .swym-wishlist-context-menu-item:not(.swym-delete)" + f));
                    e.WishlistUIStatusBar && (e.WishlistUIStatusBar.WishlistUIBarStyling && (b.htmlText += ".swym-ui-component .swym-wishlist-modal .swym-modal-content .swym-wishlist-container-title-bar" + c(e.WishlistUIStatusBar.WishlistUIBarStyling).styles),
                    e.WishlistUIStatusBar.WishlistUIBarText && (b.htmlText += ".swym-user-login-status::before,.swym-wishlist-modal .swym-modal-content .swym-close-btn{color: " + e.WishlistUIStatusBar.WishlistUIBarText.color + "!important; background: transparent !important} .swym-user-login-status > .swym-user-text , .swym-ui-component .swym-wishlist-modal .swym-modal-content .swym-wishlist-container-title-bar > .swym-wishlist-main-title" + c(e.WishlistUIStatusBar.WishlistUIBarText).styles));
                    e.WishlistUIText && (e = e.WishlistUIText,
                    e.WishlistUINotifTexts && (b.htmlText += ".swym-notification-wishlist .swym-details" + c(e.WishlistUINotifTexts).styles),
                    e.WishlistUITitleTexts && (g = c(e.WishlistUITitleTexts).styles,
                    b.htmlText += ".swym-wishlist-list .swym-wishlist-list-header, .swym-wishlist-detail-header .swym-wishlist-main-title" + g,
                    b.htmlText += ".swym-wishlist-product-detail-content .swym-wishlist-product-title" + g,
                    b.htmlText += ".swym-add-wishlist-modal .swym-modal-content .swym-product-name" + g,
                    b.htmlText += ".swym-add-wishlist-modal .swym-modal-content .swym-wishlist-item" + g,
                    b.htmlText += ".swym-wishlist-list-card .swym-wishlist-name, .swym-wishlist-selector-dropdown .swym-selected-wishlist-container .swym-selected-wishlist-name" + g,
                    b.htmlText += ".swym-wishlist-grid .swym-wishlist-item .swym-title" + g,
                    b.htmlText += ".swym-empty-wishlist-container .swym-empty-wishlist-title" + g,
                    b.htmlText += ".swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-text-heading" + g,
                    b.htmlText += ".swym-share-wishlist-modal .swym-share-wishlist-modal-dialog .swym-text-heading" + g,
                    b.htmlText += ".swym-mailing-list-modal .swym-mailing-list-modal-dialog .swym-text-heading" + g,
                    b.htmlText += ".swym-clear-wishlist-modal .swym-clear-wishlist-modal-dialog .swym-text-heading" + g,
                    b.htmlText += ".swym-duplicate-wishlist-modal .swym-duplicate-wishlist-modal-dialog .swym-text-heading" + g),
                    e.WishlistUIBodyTexts && (g = c(e.WishlistUIBodyTexts).styles,
                    b.htmlText += ".swym-wishlist-list-card .swym-wishlist-product-count" + g,
                    b.htmlText += ".swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-text-content" + g,
                    b.htmlText += ".swym-add-wishlist-modal .swym-modal-content .swym-wishlist-items-title" + g,
                    b.htmlText += ".swym-empty-wishlist-container .swym-empty-wishlist-text" + g,
                    b.htmlText += ".swym-mailing-list-modal .swym-mailing-list-modal-dialog .swym-sub-heading, .swym-mailing-list-modal .swym-mailing-list-modal-dialog .swym-add-mailing-list-description" + g,
                    b.htmlText += ".swym-clear-wishlist-modal .swym-clear-wishlist-modal-dialog .swym-text-content" + g,
                    b.htmlText += ".swym-wishlist-selector-dropdown .swym-selected-wishlist-container .swym-selected-wishlist-label" + g),
                    e.WishlistUIPriceTexts && (g = c(e.WishlistUIPriceTexts),
                    b.htmlText += ".swym-product-price .swym-product-final-price" + g.styles,
                    null != g.customStyles && (b.htmlText += ".swym-product-price .swym-product-final-price{color: " + g.customStyles.WishlistUIPriceFontColor + "!important}"),
                    b.htmlText += ".swym-product-price .swym-product-original-price" + g.styles,
                    null != g.customStyles && (b.htmlText += ".swym-product-price .swym-product-original-price{color: " + g.customStyles.WishlistUIComparedPriceFontColor + "!important}")),
                    e.WishlistUIInputTitleTexts && (g = c(e.WishlistUIInputTitleTexts).styles,
                    b.htmlText += ".swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-list .swym-input-label" + g,
                    b.htmlText += ".swym-share-wishlist-modal .swym-share-wishlist-modal-dialog .swym-share-wishlist-input-container .swym-input-label" + g,
                    b.htmlText += ".swym-mailing-list-modal .swym-mailing-list-modal-dialog .swym-mailing-list-input-container .swym-input-label" + g),
                    e.WishlistUIInputContentTexts && (c = c(e.WishlistUIInputContentTexts),
                    b.htmlText += ".swym-input" + c.styles,
                    null != c.customStyles && (b.htmlText += ".swym-input{color: " + c.customStyles.WishlistUIInputFontColor + "!important}.swym-input::placeholder{color: " + c.customStyles.WishlistUIDefaultInputFontColor + "!important}"),
                    b.htmlText += ".swym-share-wishlist-email, .swym-share-wishlist-name,.swym-share-wishlist-note" + c.styles,
                    null != c.customStyles && (b.htmlText += ".swym-share-wishlist-email, .swym-share-wishlist-name,.swym-share-wishlist-note{color: " + c.customStyles.WishlistUIInputFontColor + "!important}.swym-share-wishlist-email::placeholder, .swym-share-wishlist-name::placeholder,.swym-share-wishlist-note::placeholder{color: " + c.customStyles.WishlistUIDefaultInputFontColor + "!important}"),
                    b.htmlText += ".swym-new-wishlist-item .swym-new-wishlist-name" + c.styles,
                    null != c.customStyles && (b.htmlText += ".swym-new-wishlist-item .swym-new-wishlist-name{color: " + c.customStyles.WishlistUIInputFontColor + "!important}.swym-new-wishlist-item .swym-new-wishlist-name::placeholder{color: " + c.customStyles.WishlistUIDefaultInputFontColor + "!important}")))
                }
                var h = d.Screen;
                if (h) {
                    var m = f = g = e = c = ""
                      , p = "";
                    h.BackgroundColor && (c += "\n            .swym-ui-component .swym-simple-wishlist-modal .swym-modal-content, .swym-ui-component .swym-wishlist-container-content, div#swym-wishlist-render-container,\n            .swym-ui-component .swym-share-wishlist-modal .swym-share-wishlist-modal-dialog,.swym-ui-component .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog, .swym-ui-component .swym-clear-wishlist-modal .swym-clear-wishlist-modal-dialog, \n            .swym-ui-component .swym-duplicate-wishlist-modal .swym-duplicate-wishlist-modal-dialog, .swym-ui-component .swym-wishlist-context-menu .swym-wishlist-context-menu-content, \n            .swym-ui-component .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog, .swym-ui-component .swym-share-wishlist-login-modal .swym-share-wishlist-login-modal-dialog,\n            .swym-ui-component .swym-wishlist-selector-dropdown .swym-wishlist-dropdown-wrapper, .swym-ui-component .swym-add-wishlist-modal .swym-modal-content, \n            .swym-ui-component .swym-wishlist-list-card, \n          .swym-ui-component .swym-share-wishlist-modal .swym-share-wishlist-modal-dialog .swym-share-wishlist-input-container .swym-share-wishlist-name,\n          .swym-ui-component .swym-share-wishlist-modal .swym-share-wishlist-modal-dialog .swym-share-wishlist-input-container .swym-share-wishlist-email,\n          .swym-ui-component .swym-share-wishlist-modal .swym-share-wishlist-modal-dialog .swym-share-wishlist-input-container .swym-share-wishlist-note,\n          .swym-ui-component .swym-duplicate-wishlist-modal .swym-duplicate-wishlist-modal-dialog .swym-duplicate-wishlist-input-container .swym-duplicate-list-name,\n          .swym-ui-component .swym-wishlist-selector-dropdown .swym-wishlist-input,\n          .swym-ui-component .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-list .swym-input,\n          .swym-ui-component .swym-add-wishlist-modal .swym-modal-content .swym-new-wishlist-item .swym-new-wishlist-name {\n              background-color: " + h.BackgroundColor + ";\n            }\n              \n            \n          .swym-ui-component.swym-wishlist-page .swym-sfl-tab-container .swym-sfl-list-view .swym-sfl-layout-grid .swym-sfl-card-product-item,\n          .swym-ui-component .swym-simple-wishlist-container .swym-sfl-tab-container .swym-sfl-list-view .swym-sfl-layout-grid .swym-sfl-card-product-item {\n              background-color: #fff;\n            }");
                    h.TextColor && (e += "\n            .swym-ui-component .swym-wishlist-main-title.swym-heading.swym-heading-1, h3.swym-empty-wishlist-title.swym-heading.swym-heading-1, p.swym-empty-wishlist-text.swym-text.swym-text-1,\n            .swym-clear-wishlist-modal-dialog h2.swym-text-heading.swym-heading.swym-heading-1, .swym-ui-component .swym-text-content.swym-text.swym-text-1, .swym-save-wishlist-modal-dialog h2.swym-text-heading.swym-heading.swym-heading-1,\n            .swym-ui-component .swym-text-content.swym-text.swym-text-1, .swym-ui-component .swym-text-content.swym-text.swym-text-1, \n            .swym-text-content.swym-text.swym-text-1,\n            .swym-text-content.swym-text.swym-text-1 > span.swym-color-2,\n            .swym-ui-component .swym-wishlist-list-card .swym-wishlist-name, .swym-ui-component .swym-wishlist-list-card .swym-wishlist-product-count, .swym-ui-component .swym-wishlist-list-card .swym-empty-wishlist-list, \n            \n            .swym-ui-component .swym-wishlist-selector-dropdown .swym-selected-wishlist-container .swym-selected-wishlist-label,\n            .swym-ui-component .swym-wishlist-selector-dropdown .swym-selected-wishlist-container .swym-selected-wishlist-name, \n            .swym-ui-component .swym-add-wishlist-modal .swym-modal-content .swym-wishlist-item .swym-icon::before,\n            .swym-ui-component .swym-add-wishlist-modal .swym-modal-content .swym-new-wishlist-item .swym-icon::before, \n            .swym-ui-component .swym-add-wishlist-modal .swym-modal-content .swym-wishlist-item,\n            .swym-ui-component .swym-add-wishlist-modal .swym-modal-content .swym-new-wishlist-item,\n            .swym-ui-component .swym-wishlist-context-menu .swym-wishlist-context-menu-item, .swym-ui-component .swym-add-wishlist-modal .swym-modal-content .swym-wishlist-items-title, .swym-ui-component .swym-add-wishlist-modal .swym-modal-content .swym-product-name,\n            .swym-ui-component .swym-share-wishlist-modal .swym-share-wishlist-modal-dialog .swym-close-btn, .swym-ui-component .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-close-btn , .swym-ui-component .swym-share-wishlist-login-modal .swym-share-wishlist-login-modal-dialog .swym-close-btn,\n            .swym-ui-component .swym-duplicate-wishlist-modal .swym-duplicate-wishlist-modal-dialog .swym-close-btn, \n            .swym-ui-component .swym-wishlist-selector-dropdown .swym-wishlist-item,\n            .swym-wishlist-search-list .swym-no-results, .swym-share-wishlist-modal-dialog h2.swym-text-heading.swym-heading.swym-heading-1,\n            \n            .swym-ui-component.swym-wishlist-page .swym-wishlist-detail .swym-action-bar .swym-back-btn,\n            .swym-ui-component .swym-action-bar .swym-back-btn, .swym-ui-component .swym-share-wishlist-login-modal .swym-share-wishlist-login-modal-dialog .swym-message-content, .swym-ui-component .swym-share-wishlist-login-modal .swym-share-wishlist-login-modal-dialog .swym-text-heading,\n            .swym-duplicate-wishlist-modal-dialog h2.swym-text-heading.swym-heading.swym-heading-1, .swym-ui-component .swym-wishlist-list-header .swym-heading.swym-heading-1,\n            .swym-ui-component .swym-htc-tabs .swym-htc-tab-item, \n            .swym-ui-component.swym-wishlist-page .swym-sfl-tab-container .swym-sfl-list-view .swym-sfl-list-heading .swym-sfl-title,\n            .swym-ui-component .swym-simple-wishlist-container .swym-sfl-tab-container .swym-sfl-list-view .swym-sfl-list-heading .swym-sfl-title, \n            .swym-ui-component .swym-sfl-list-empty-content .swym-sfl-list-empty-text,\n            .swym-ui-component .swym-sfl-list-empty-content .swym-sfl-list-empty-text2, .swym-sfl-action-button .swym-share-sfl-btn,\n            \n          .swym-ui-component .swym-share-wishlist-modal .swym-share-wishlist-modal-dialog .swym-share-wishlist-input-container .swym-share-wishlist-name,\n          .swym-ui-component .swym-share-wishlist-modal .swym-share-wishlist-modal-dialog .swym-share-wishlist-input-container .swym-share-wishlist-email,\n          .swym-ui-component .swym-share-wishlist-modal .swym-share-wishlist-modal-dialog .swym-share-wishlist-input-container .swym-share-wishlist-note,\n          .swym-ui-component .swym-duplicate-wishlist-modal .swym-duplicate-wishlist-modal-dialog .swym-duplicate-wishlist-input-container .swym-duplicate-list-name,\n          .swym-ui-component .swym-wishlist-selector-dropdown .swym-wishlist-input,\n          .swym-ui-component .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-list .swym-input,\n          .swym-ui-component .swym-add-wishlist-modal .swym-modal-content .swym-new-wishlist-item .swym-new-wishlist-name, \n          .swym-ui-component .swym-share-wishlist-modal .swym-share-wishlist-modal-dialog .swym-share-wishlist-input-container .swym-input-label,\n          .swym-share-wishlist-input-container .swym-text-md.swym-info-grey,\n          .swym-ui-component .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-list .swym-input-label,\n          .swym-save-list .swym-text-md.swym-info-grey {\n              color: " + h.TextColor + ";\n            }\n              \n            \n          .swym-ui-component .swym-share-wishlist-modal .swym-share-wishlist-modal-dialog .swym-share-wishlist-input-container .swym-share-wishlist-name,\n          .swym-ui-component .swym-share-wishlist-modal .swym-share-wishlist-modal-dialog .swym-share-wishlist-input-container .swym-share-wishlist-email,\n          .swym-ui-component .swym-share-wishlist-modal .swym-share-wishlist-modal-dialog .swym-share-wishlist-input-container .swym-share-wishlist-note,\n          .swym-ui-component .swym-duplicate-wishlist-modal .swym-duplicate-wishlist-modal-dialog .swym-duplicate-wishlist-input-container .swym-duplicate-list-name,\n          .swym-ui-component .swym-wishlist-selector-dropdown .swym-wishlist-input,\n          .swym-ui-component .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-list .swym-input,\n          .swym-ui-component .swym-add-wishlist-modal .swym-modal-content .swym-new-wishlist-item .swym-new-wishlist-name {\n              border: 1px solid " + h.TextColor + ";\n            }",
                    m += "\n            .swym-ui-component .swym-share-btn, .swym-ui-component .swym-wishlist-context-menu {\n              color: " + h.TextColor + ";\n            }\n              \n            .swym-ui-component .swym-wishlist-detail-separator, .swym-ui-component .swym-add-wishlist-modal .swym-modal-content .swym-product-title:after {\n              background: " + h.TextColor + ";\n            }\n\n            .swym-ui-component.swym-wishlist-page .swym-wishlist-container-title-bar, \n            .swym-ui-component .swym-add-wishlist-modal .swym-modal-content .swym-wishlist-item,\n            .swym-ui-component .swym-add-wishlist-modal .swym-modal-content .swym-new-wishlist-item, .swym-ui-component .swym-htc-tabs, \n            .swym-ui-component.swym-wishlist-page .swym-sfl-tab-container .swym-sfl-list-view .swym-sfl-detail-separator,\n            .swym-ui-component .swym-simple-wishlist-container .swym-sfl-tab-container .swym-sfl-list-view .swym-sfl-detail-separator {\n              border-bottom: 1px solid " + h.TextColor + "\n            }\n              \n            .swym-ui-component.swym-wishlist-page .swym-wishlist-container-title-bar .swym-user-login-status {\n              color: " + h.TextColor + "\n            }\n            ");
                    var r = h.PrimaryButtonConfig;
                    if (r) {
                        var n = r.BackgroundColor
                          , q = r.TextColor
                          , r = r.BorderRadius;
                        n && (g += "\n              .swym-ui-component .swym-empty-wishlist-container .swym-empty-wishlist-continue-btn, .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-logged-in .swym-log-out-btn, .swym-ui-component .swym-share-wishlist-modal .swym-share-wishlist-modal-dialog .swym-share-wishlist-email-btn,\n              .swym-ui-component .swym-clear-wishlist-modal .swym-clear-wishlist-modal-dialog .swym-clear-wishlist-btn, \n            .swym-ui-component .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-summary .swym-login-btn,\n            .swym-ui-component .swym-share-wishlist-login-modal .swym-share-wishlist-login-modal-dialog .swym-share-login .swym-login-btn , .swym-ui-component .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-list .swym-save-list-btn,\n              .swym-ui-component .swym-duplicate-wishlist-modal .swym-duplicate-wishlist-modal-dialog .swym-duplicate-wishlist-btn, .swym-ui-component .swym-add-wishlist-modal .swym-modal-content .swym-add-to-list-btn, .swym-ui-component .swym-htc-tabs .swym-htc-tab-item.swym-selected,\n              .swym-ui-component .swym-sfl-list-empty-content .swym-sfl-cart-btn , \n            .swym-ui-component.swym-wishlist-page .swym-sfl-tab-container .swym-sfl-list-view .swym-sfl-list-heading .swym-sfl-action-button .swym-sfl-add-all-to-cart-btn,\n            .swym-ui-component .swym-simple-wishlist-container .swym-sfl-tab-container .swym-sfl-list-view .swym-sfl-list-heading .swym-sfl-action-button .swym-sfl-add-all-to-cart-btn, \n          .swym-ui-component.swym-wishlist-page .swym-sfl-tab-container .swym-sfl-list-view .swym-sfl-layout-grid .swym-sfl-card-product-item .swym-sfl-add-to-cart-btn,\n          .swym-ui-component .swym-simple-wishlist-container .swym-sfl-tab-container .swym-sfl-list-view .swym-sfl-layout-grid .swym-sfl-card-product-item .swym-sfl-add-to-cart-btn {\n                background-color: " + n + " ;\n              }",
                        f += "\n              .swym-ui-component .swym-clear-wishlist-modal .swym-clear-wishlist-modal-dialog .swym-cancel-clear-wishlist-btn, .swym-ui-component .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-summary .swym-save-list-btn, .swym-ui-component .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-logged-in .swym-back-btn,\n              .swym-ui-component .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-list .swym-back-btn, .swym-ui-component .swym-wishlist-list-card .swym-wishlist-link, .swym-ui-component .swym-duplicate-wishlist-modal .swym-duplicate-wishlist-modal-dialog .swym-cancel-duplicate-wishlist-btn,\n              .swym-ui-component .swym-add-wishlist-modal .swym-modal-content .swym-new-wishlist-btn {\n                color: " + n + " \n              }",
                        m += "\n              .swym-ui-component .swym-simple-wishlist-modal .swym-modal-content .swym-wishlist-container-title-bar, .swym-ui-component .swym-wishlist-modal .swym-modal-content .swym-wishlist-container-title-bar {\n                background-color: " + n + ";\n              }");
                        q && (g += "\n              .swym-ui-component .swym-empty-wishlist-container .swym-empty-wishlist-continue-btn, .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-logged-in .swym-log-out-btn, .swym-ui-component .swym-share-wishlist-modal .swym-share-wishlist-modal-dialog .swym-share-wishlist-email-btn,\n              .swym-ui-component .swym-clear-wishlist-modal .swym-clear-wishlist-modal-dialog .swym-clear-wishlist-btn, \n            .swym-ui-component .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-summary .swym-login-btn,\n            .swym-ui-component .swym-share-wishlist-login-modal .swym-share-wishlist-login-modal-dialog .swym-share-login .swym-login-btn , .swym-wishlist-grid .swym-wishlist-item .swym-add-to-cart-btn, .swym-wishlist-product-detail-content .swym-wishlist-add-to-cart-btn,\n              .swym-ui-component .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-list .swym-save-list-btn, .swym-ui-component .swym-duplicate-wishlist-modal .swym-duplicate-wishlist-modal-dialog .swym-duplicate-wishlist-btn, .swym-ui-component .swym-htc-tabs .swym-htc-tab-item.swym-selected,\n              .swym-ui-component .swym-add-wishlist-modal .swym-modal-content .swym-add-to-list-btn, .swym-ui-component .swym-sfl-list-empty-content .swym-sfl-cart-btn , \n            .swym-ui-component.swym-wishlist-page .swym-sfl-tab-container .swym-sfl-list-view .swym-sfl-list-heading .swym-sfl-action-button .swym-sfl-add-all-to-cart-btn,\n            .swym-ui-component .swym-simple-wishlist-container .swym-sfl-tab-container .swym-sfl-list-view .swym-sfl-list-heading .swym-sfl-action-button .swym-sfl-add-all-to-cart-btn,\n              \n          .swym-ui-component.swym-wishlist-page .swym-sfl-tab-container .swym-sfl-list-view .swym-sfl-layout-grid .swym-sfl-card-product-item .swym-sfl-add-to-cart-btn,\n          .swym-ui-component .swym-simple-wishlist-container .swym-sfl-tab-container .swym-sfl-list-view .swym-sfl-layout-grid .swym-sfl-card-product-item .swym-sfl-add-to-cart-btn {\n                color: " + q + ";\n              }",
                        m += "\n              .swym-ui-component .swym-modal-content .swym-user-login-status, .swym-ui-component .swym-simple-wishlist-modal .swym-modal-content .swym-close-btn .swym-icon::before {\n                color: " + q + ";\n              }");
                        r && (g += "\n              .swym-ui-component .swym-empty-wishlist-container .swym-empty-wishlist-continue-btn, .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-logged-in .swym-log-out-btn, .swym-ui-component .swym-share-wishlist-modal .swym-share-wishlist-modal-dialog .swym-share-wishlist-email-btn,\n              .swym-ui-component .swym-clear-wishlist-modal .swym-clear-wishlist-modal-dialog .swym-clear-wishlist-btn, \n            .swym-ui-component .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-summary .swym-login-btn,\n            .swym-ui-component .swym-share-wishlist-login-modal .swym-share-wishlist-login-modal-dialog .swym-share-login .swym-login-btn , .swym-ui-component .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-list .swym-save-list-btn, \n              .swym-ui-component .swym-duplicate-wishlist-modal .swym-duplicate-wishlist-modal-dialog .swym-duplicate-wishlist-btn, .swym-ui-component .swym-add-wishlist-modal .swym-modal-content .swym-add-to-list-btn, .swym-wishlist-grid .swym-wishlist-item .swym-add-to-cart-btn, .swym-wishlist-product-detail-content .swym-wishlist-add-to-cart-btn,\n              .swym-ui-component .swym-sfl-list-empty-content .swym-sfl-cart-btn , \n            .swym-ui-component.swym-wishlist-page .swym-sfl-tab-container .swym-sfl-list-view .swym-sfl-list-heading .swym-sfl-action-button .swym-sfl-add-all-to-cart-btn,\n            .swym-ui-component .swym-simple-wishlist-container .swym-sfl-tab-container .swym-sfl-list-view .swym-sfl-list-heading .swym-sfl-action-button .swym-sfl-add-all-to-cart-btn, \n          .swym-ui-component.swym-wishlist-page .swym-sfl-tab-container .swym-sfl-list-view .swym-sfl-layout-grid .swym-sfl-card-product-item .swym-sfl-add-to-cart-btn,\n          .swym-ui-component .swym-simple-wishlist-container .swym-sfl-tab-container .swym-sfl-list-view .swym-sfl-layout-grid .swym-sfl-card-product-item .swym-sfl-add-to-cart-btn {\n                border-radius: " + r + " ;\n              }",
                        f += "\n              .swym-ui-component .swym-clear-wishlist-modal .swym-clear-wishlist-modal-dialog .swym-cancel-clear-wishlist-btn, .swym-ui-component .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-summary .swym-save-list-btn, .swym-ui-component .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-logged-in .swym-back-btn,\n              .swym-ui-component .swym-save-wishlist-modal .swym-save-wishlist-modal-dialog .swym-save-list .swym-back-btn, .swym-ui-component .swym-add-wishlist-modal .swym-modal-content .swym-new-wishlist-btn {\n                border-radius: " + r + "; \n              }")
                    }
                    if (h = h.ProductCardConfig)
                        p += "\n            .swym-wishlist-grid .swym-wishlist-item .swym-add-to-cart-btn, .swym-wishlist-product-detail-content .swym-wishlist-add-to-cart-btn {\n              margin: 0px 10px 10px 10px;\n            }",
                        h.Border && (p += "\n              .swym-ui-component .swym-wishlist-grid .swym-wishlist-item, \n          .swym-ui-component.swym-wishlist-page .swym-sfl-tab-container .swym-sfl-list-view .swym-sfl-layout-grid .swym-sfl-card-product-item,\n          .swym-ui-component .swym-simple-wishlist-container .swym-sfl-tab-container .swym-sfl-list-view .swym-sfl-layout-grid .swym-sfl-card-product-item {\n                border: " + h.Border + ";\n              }");
                    b.htmlText += c + e + g + f + m + p
                }
                "custom" == d.ButtonIcon && d.CustomIcon && (b.htmlText += ".swym-button.swym-add-to-wishlist:after,.swym-button.swym-add-to-wishlist-view-product:after { background-image: url('" + d.CustomIcon + "'); }")
            }, function() {
                a.retailerSettings.UI.Enabled = !1;
                a.retailerSettings.UI.SimpleWishlistOnly = !0
            })
        }
    });
    swymModules.push({
        id: "watchlist",
        cfg: {
            Watchlist: {
                Enabled: !1,
                ToggleSwitchState: !0,
                Topics: ["backinstock"],
                ButtonType: "icontext",
                CTA: "",
                OnlyStock: !0,
                Tooltip: "",
                ButtonIcon: "",
                Position: "left",
                NoButtonInject: !1,
                AddClasses: "",
                RemoveClasses: "",
                MailingListCheckInPopup: !1,
                VariantSelectorInPopup: !1,
                ShowVariantSelectorOnlyOnOOS: !1,
                InlineForm: !1,
                Color: "",
                DisallowedTags: ["swym-disabled"],
                ShowIfOneOOS: !1
            }
        },
        events: {
            addedToWatchlist: "sw:addedtowatchlist"
        },
        init: function() {
            this.evtLayer.addEventListener(this.JSEvents.preReadSettings, function(a) {
                if ((a = a.detail.d.settings) && 2 != a.General._v && a.Watchlist) {
                    var c = a.Watchlist
                      , d = a.General;
                    c.NoButtonInject = c.UseCustomButton;
                    [{
                        o: "MailingListCheckInPopup",
                        n: "MailingListCheck"
                    }].forEach(function(a) {
                        SwymUtils.isUndefined(c[a.o]) || (d[a.n] = c[a.o])
                    })
                }
                if (a.Watchlist.ShowIfOneOOS || a.Watchlist.ShowVariantSelectorOnlyOnOOS)
                    a.Watchlist.InlineForm = !1,
                    a.Watchlist.NoButtonInject = !1,
                    a.Watchlist.VariantSelectorInPopup = !0;
                a.Watchlist.InlineForm && (a.Watchlist.NoButtonInject = !0,
                a.Watchlist.VariantSelectorInPopup = !1)
            });
            var a = this;
            a.setupUIModule("Watchlist", "Watchlist", ["Enabled"], SwymUtils.EmptyFunction, function(b) {
                function c(a, b) {
                    for (var c = [{
                        obj1: a,
                        obj2: b
                    }]; c.length; ) {
                        var d = c.pop(), e = d.obj1, d = d.obj2, f;
                        for (f in d)
                            "object" === typeof d[f] && null !== d[f] ? "object" === typeof e[f] && null !== e[f] ? c.push({
                                obj1: e[f],
                                obj2: d[f]
                            }) : e[f] = Object.assign({}, d[f]) : e[f] = d[f]
                    }
                    return a
                }
                var d = SwymUtils.getSWAction();
                if ("previewsbisa" == d.toLowerCase()) {
                    a.clearSettingsCache();
                    var e = a.retailerSettings.Watchlist && a.retailerSettings.Watchlist.PreviewSettings;
                    null != e && (a.retailerSettings = Object.assign({}, c(a.retailerSettings, e)))
                }
                "previewtestsbisa" == d.toLowerCase() && a.evtLayer.addEventListener(a.JSEvents.addedToWatchlist, function(a) {
                    a = a.detail.d;
                    "email" == a.medium && "backinstock" == a.topics && window.opener.postMessage({
                        email: a.mediumvalue,
                        epi: a.epi
                    }, "*")
                });
                d = a.retailerSettings.Watchlist;
                d.Color && (b.htmlText = "default" == d.Position ? d.ButtonType && "icon" != d.ButtonType ? b.htmlText + (".swym-add-to-watchlist { background: " + d.Color + " !important;}") : b.htmlText + (".swym-add-to-watchlist { color: " + d.Color + " !important;}") : b.htmlText + (".swym-add-to-watchlist { background: " + d.Color + " !important;}"));
                d.ButtonType || (d.ButtonType = "icon");
                d.SMSEnabled && (a.storage.get("validatedUserContactNo") || a.getPreferencesV3(function(b) {
                    b && b.Mediums && a.storage.set("validatedUserContactNo", b.Mediums.sms ? b.Mediums.sms.values || [] : [])
                }))
            })
        }
    });
    var Da = function() {
        return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "").slice(0, -1)
    };
    h.prototype.initShareWishlist = function() {
        var a = new this.FetchModel({
            name: "wishlisthkey",
            hashFn: function(a) {
                return a.hashtag ? a.hashtag : "all"
            },
            preloadHashFn: function(a, c) {
                return "all"
            },
            cacheStaleEvts: [this.JSEvents.fetchProducts].concat(this.FetchModel.defaultOpts.cacheStaleEvts),
            gSEvtNames: [this.JSEvents.hashkeyReceived],
            internalFn: function(a, c, d) {
                this.swat.swymApiPost({
                    endpoint: "/shareWishlist",
                    params: a.params.hashtag ? {
                        hashtag: a.params.hashtag
                    } : {},
                    callbackFn: c,
                    errorFn: d,
                    checkRegId: !0,
                    sendSessionId: !0,
                    v2: !0
                })
            }
        });
        this.exports("wishlistHashkey", a)
    }
    ;
    h.prototype.generateSharedWishlistURL = function(a, b, c) {
        var d = this.retailerSettings.Wishlist.ShareBaseUrl
          , e = this;
        this.wishlistHashkey.fetch({
            params: {
                hashtag: a
            },
            scb: function(a) {
                if (a.error)
                    c(a.error);
                else {
                    var f = a.hash
                      , h = SwymUtils.getCurrentPrimaryUrlWithProtocol()
                      , m = window.Shopify ? Da() : "";
                    e.triggerSwymEvent(e.JSEvents.hashkeyReceived, {
                        hash: a.hash
                    });
                    var p = {};
                    try {
                        p = e.productEts.quickFindForEpi(a.epis[0])
                    } catch (r) {}
                    a = SwymUtils.renderTemplateString(d, {
                        storeurl: h + m,
                        hostedshareurl: e.getHostedShareURL(),
                        hkey: f,
                        firstProduct: p,
                        urlEncoded: function() {
                            return function(a, b) {
                                return encodeURIComponent(b(a))
                            }
                        }
                    });
                    a = SwymUtils.annotateUrl(a, "Wishlist", "shared-wishlist", f);
                    b(a, f)
                }
            },
            fcb: function(a) {
                c(a)
            }
        })
    }
    ;
    h.prototype.shareWishlistSocial = function(a, b, c, d, e) {
        var f = this;
        this.api.generateSharedWishlistURL(a, function(a, e) {
            a += "&utm_content=" + c;
            var h = SwymUtils.renderTemplateString(b, {
                note: encodeURIComponent(d).replace(/[!'()*]/g, escape),
                shareurl: encodeURIComponent(a)
            });
            f.reportListShare(e, null, c, d, a);
            window.open(h, "_blank", "toolbar=1,status=1,resizable=1,scrollbars=1,width=626,height=436")
        }, function(a) {
            e(a)
        })
    }
    ;
    h.prototype.generateSharedListURL = function(a, b, c) {
        var d = this.retailerSettings.Wishlist.ShareBaseUrl
          , e = this;
        null == a ? this.api.generateSharedWishlistURL(null, b, c) : this.api.markListPublic(a, function(c) {
            var f = c.lid
              , h = SwymUtils.getCurrentPrimaryUrlWithProtocol()
              , m = window.Shopify ? Da() : "";
            c = c.listcontents[0];
            h = SwymUtils.renderTemplateString(d, {
                storeurl: h + m,
                hostedshareurl: e.getHostedShareURL(),
                hkey: f,
                lid: a,
                firstProduct: c,
                urlEncoded: function() {
                    return function(a, b) {
                        return encodeURIComponent(b(a))
                    }
                }
            });
            h = SwymUtils.annotateUrl(h, "Wishlist", "shared-wishlist", f);
            b(h, a)
        }, c)
    }
    ;
    h.prototype.generateSharedSFLListURL = function(a, b, c) {
        var d = this.retailerSettings.Wishlist.ShareBaseUrl
          , e = this;
        null == a ? this.api.generateSharedWishlistURL(null, b, c) : this.api.markListPublic(a, function(c) {
            var f = c.lid
              , h = SwymUtils.getCurrentPrimaryUrlWithProtocol()
              , m = window.Shopify ? Da() : "";
            c = c.listcontents[0];
            h = SwymUtils.renderTemplateString(d, {
                storeurl: h + m,
                hostedshareurl: e.getHostedShareSFLURL(),
                hkey: f,
                lid: a,
                firstProduct: c,
                urlEncoded: function() {
                    return function(a, b) {
                        return encodeURIComponent(b(a))
                    }
                }
            });
            h = SwymUtils.annotateUrl(h, "SFL", "shared-sfl", f);
            b(h, a)
        }, c)
    }
    ;
    h.prototype.generateListShortlink = function(a, b, c) {
        var d = this.retailerSettings.Wishlist.ShareBaseUrl
          , e = a.lid
          , f = a.list;
        if (null == e)
            a = Error("lid cannot be null"),
            c(a);
        else if (null != f && Array.isArray(f.listcontents) && 0 != f.listcontents.length) {
            var h = f.listcontents[0]
              , f = {
                utmSource: "swym-Wishlist",
                utmMedium: "shared-wishlist",
                socialTitle: f.lname || this.retailerSettings.Strings.WishlistTitle,
                socialDescription: this.retailerSettings.Wishlist.ShortlinkSocialDescription,
                socialImageLink: SwymUtils.wrapUrlWithHTTPS(h.iu || this.retailerSettings.Wishlist.ShortlinkSocialImage)
            }
              , l = SwymUtils.getCurrentPrimaryUrlWithProtocol()
              , d = SwymUtils.renderTemplateString(d, {
                storeurl: l,
                hostedshareurl: this.getHostedShareURL(),
                hkey: e,
                lid: e,
                firstProduct: h,
                urlEncoded: function() {
                    return function(a, b) {
                        return encodeURIComponent(b(a))
                    }
                }
            })
              , d = SwymUtils.annotateUrl(d, "Wishlist", "shared-wishlist", e);
            a.link = d;
            var m = SwymUtils.deepcopy(a);
            ["list"].forEach(function(a) {
                delete m[a]
            });
            m = SwymUtils.extendDefaults(m, f);
            this.makeListShortlink(m, function(a) {
                b(a.link, e)
            }, c)
        } else
            a = Error("list cannot be null or empty"),
            c(a)
    }
    ;
    h.prototype.shareListSocial = function(a, b, c, d, e, g) {
        this.api.generateSharedListURL(a, function(a, g) {
            a += "&utm_content=" + d;
            var h = SwymUtils.renderTemplateString(c, {
                note: encodeURIComponent(e).replace(/[!'()*]/g, escape),
                shareurl: encodeURIComponent(a)
            });
            f.reportListShare(g, b, d, e, a);
            window.open(h, "_blank", "toolbar=1,status=1,resizable=1,scrollbars=1,width=626,height=436")
        }, function(a) {
            g(a)
        })
    }
    ;
    h.prototype.shareSFLListSocial = function(a) {
        var b = a.fromName
          , c = a.platformShareUrlTemplate
          , d = a.platform
          , e = a.note
          , g = a.errCallback;
        this.generateSharedSFLListURL(a.lid, function(a, g) {
            a += "&utm_content=" + d;
            var h = SwymUtils.renderTemplateString(c, {
                note: encodeURIComponent(e).replace(/[!'()*]/g, escape),
                shareurl: encodeURIComponent(a)
            });
            f.reportListShare(g, b, d, e, a);
            window.open(h, "_blank", "toolbar=1,status=1,resizable=1,scrollbars=1,width=626,height=436")
        }, function(a) {
            g(a)
        })
    }
    ;
    h.prototype.reportListShare = function(a, b, c, d, e) {
        this.swymApiPost({
            endpoint: "/lists/reportShare",
            params: {
                lid: a,
                medium: c,
                note: d,
                fromname: b,
                shareurl: e
            },
            checkRegId: !0,
            sendSessionId: !0,
            noProvider: !0,
            v3: !0
        })
    }
    ;
    swymModules.push({
        id: "sharewishlist",
        init: function() {
            var a = this, b = {
                hashkeyReceived: "sw:hashkeyReceived"
            }, c;
            for (c in b)
                h.JSEvents[c] = b[c];
            a.evtLayer.addEventListener(a.JSEvents.initIntegrations, function() {
                (a.retailerSettings.Wishlist.AllowSharing || a.retailerSettings.Wishlist.Enabled) && a.initShareWishlist()
            })
        }
    });
    swymModules.push({
        id: "widget",
        events: {
            fetchWidget: "sw:fetchwidget",
            renderWidget: "sw:renderwidget",
            fetchShared: "sw:fetchshared",
            renderShared: "sw:rendershared"
        },
        cfg: {
            Widget: {
                Enabled: !1,
                RenderCfg: {
                    type: "grid",
                    gridtmpl: "",
                    itemtmpl: "",
                    loadingtmpl: "",
                    cols: {
                        mobile: 1,
                        tablet: 3,
                        desktop: 4
                    },
                    actions: [1],
                    attrs: []
                },
                Defs: []
            }
        },
        instruments: {},
        init: function() {
            function a(a) {
                SwymUtils.removeClass(a.grid, "loading");
                SwymUtils.addClass(a.grid, "loaded")
            }
            function b(a, b) {
                SwymUtils.addClass(a, "loading")
            }
            function c(a, b) {
                SwymUtils.addClass(a, "error")
            }
            function d(a, b) {
                var c = h[a];
                return "sw-rfr=" + (h[a + "-" + b] || c || h.site).toString(16)
            }
            this.sharedWlApi = new this.FetchModel({
                name: "shared",
                hashFn: function(a) {
                    return a.hkey
                },
                internalFn: function(a, b, c) {
                    this.swat.swymApiPost({
                        endpoint: "/getSharedWishlist",
                        v2: !0,
                        params: {
                            hkey: a.params.hkey
                        },
                        callbackFn: b,
                        sendRegId: !0,
                        sendSessionId: !0,
                        errorFn: c
                    })
                }
            });
            this.widgetProductsApi = new this.FetchModel({
                name: "widget",
                hashFn: function(a) {
                    return a.type
                },
                internalFn: function(a, b, c) {
                    a = a.params;
                    this.swat.swymApiPost({
                        endpoint: "/widgets/getWidgetData",
                        v2: !0,
                        params: {
                            querytype: a.type,
                            n: a.n,
                            days: a.days
                        },
                        callbackFn: b,
                        checkRegId: !1,
                        sendRegId: !1,
                        sendSessionId: !1,
                        errorFn: c
                    })
                }
            });
            this.widgetProductsApi.fetchWrtType = function(a, b) {
                var c = a.src || "site"
                  , e = a.pos;
                l.widgetProductsApi.fetch({
                    params: {
                        type: a.type,
                        n: a.n || 10,
                        days: a.days || 30
                    },
                    scb: function(a) {
                        var f = JSON.parse(JSON.stringify(a.productmetadata))
                          , g = d(c, e);
                        f.forEach(function(a) {
                            var b = a.uri
                              , c = -1 < b.indexOf("?") ? "&" : "?";
                            a.uri = b + c + g
                        });
                        b(f, a.querystr)
                    },
                    lcb: function() {
                        a.lcb && a.lcb(this, arguments)
                    },
                    fcb: function() {
                        a.fcb && a.fcb.apply(this, arguments)
                    }
                })
            }
            ;
            var e, f, h = {
                site: 1E4,
                "site-collections": 10002,
                "site-product": 10001,
                "site-cart": 10003,
                "site-wishlist": 10004,
                "site-page": 10005,
                "site-checkout": 10006
            };
            this.widget = {
                init: function() {
                    e.Defs.filter(function(a) {
                        return a.enabled
                    }).forEach(function(d) {
                        d.containers.filter(function(a) {
                            return a.allowedurl ? -1 < location.href.search(new RegExp(a.allowedurl)) : !0
                        }).filter(function(a) {
                            return a.disallowedurl ? -1 == location.href.search(new RegeExp(a.disallowedurl)) : !0
                        }).filter(function(a) {
                            return !!document.querySelector(a.selector)
                        }).forEach(function(f) {
                            this.createContainer({
                                type: d.type,
                                render: f.render || e.RenderCfg,
                                id: d.type + "_" + f.id,
                                selector: f.selector,
                                src: f.src,
                                pos: f.pos,
                                n: d.n,
                                days: d.days
                            }, a, b, c)
                        }, this)
                    }, this)
                },
                renderContainer: function(a) {
                    a.render.iscarousel = "carousel" == a.render.type;
                    a.render.widths = {};
                    for (var b in a.render.cols)
                        a.render.widths[b] = 100 / a.render.cols[b];
                    b = SwymUtils.renderTemplate(f.WidgetContainer, a);
                    a = document.createDocumentFragment();
                    var c = document.createElement("div");
                    c.innerHTML = b;
                    b = c.children[0];
                    a.appendChild(b);
                    return b
                },
                createContainer: function(a, b, c, d) {
                    var e = this.renderContainer(a)
                      , f = e.querySelector(".swym-products-loop");
                    a.lcb = function() {
                        c(e, f)
                    }
                    ;
                    a.fcb = function() {
                        SwymUtils.error("Error fetching widget", arguments);
                        d(null)
                    }
                    ;
                    l.widgetProductsApi.fetchWrtType(a, function(c, d) {
                        var g = l.widget.renderProducts(f, a.render, c, !0)
                          , g = {
                            grid: e,
                            productsElem: g,
                            products: c,
                            query: d,
                            cfg: a
                        };
                        l.triggerSwymEvent(l.JSEvents.renderWidget, g);
                        document.querySelector(g.cfg.selector).appendChild(e);
                        b(g)
                    })
                },
                refreshContainer: function(a, b) {},
                formatPrice: function(a) {
                    try {
                        if (window.SwymOverrideFormatMoneyFn)
                            return window.SwymOverrideFormatMoneyFn(a);
                        if (l.platform.formatMoney && l.platform.currentMoneyFormat && l.platform.currentMoneyFormat())
                            return l.platform.formatMoney(100 * a, l.platform.currentMoneyFormat())
                    } catch (b) {
                        l.utils.warn("Error formatting price - " + a + b)
                    }
                    return l.currency + l.utils.padDecimal(a)
                },
                renderProduct: function(a, b) {
                    b.pr && (b.formattedPr = this.formatPrice(b.pr));
                    b.op && (b.formattedOp = this.formatPrice(b.op));
                    b = SwymUtils.formatProductPrice(b);
                    [["dt", "title"], ["du", "uri"]].forEach(function(a) {
                        b[a[0]] = b[a[0]] || b[a[1]]
                    });
                    b.render = a;
                    return SwymUtils.renderTemplate(f.ProductGridItem, b)
                },
                renderProducts: function(a, b, c, d) {
                    c.forEach(function(c, d) {
                        var e = document.createElement("li");
                        e.setAttribute("data-idx", d);
                        e.className = "swym-product-grid-li";
                        e.innerHTML = this.renderProduct(b, c);
                        a.appendChild(e)
                    }, this);
                    return a
                },
                renderSharedWishlist: function(a, b, c, d) {
                    if (l.retailerSettings.Wishlist.Enabled) {
                        var f = l.retailerSettings.Wishlist.SharingViewConfig || e.RenderCfg
                          , g = {
                            id: "shared-" + a,
                            render: f
                        }
                          , h = l.widget.renderContainer(g)
                          , k = h.querySelector(".swym-products-loop");
                        l.sharedWlApi.fetch({
                            params: {
                                hkey: a
                            },
                            scb: function(a) {
                                var c = JSON.parse(JSON.stringify(a.queryres))
                                  , d = l.widget.renderProducts(k, f, c, !0);
                                a = {
                                    grid: h,
                                    productsElem: d,
                                    products: c,
                                    query: a.querystr,
                                    cfg: g
                                };
                                l.triggerSwymEvent(l.JSEvents.renderShared, a);
                                b(a)
                            },
                            lcb: function() {
                                c(h, k)
                            },
                            fcb: function() {
                                SwymUtils.error("Error fetching shared wishlist", arguments);
                                d(null)
                            }
                        });
                        l.instrument(l.Instrumentations.SharedWishlistOpen, {
                            hkey: a
                        });
                        a = l.getCurrentPageData();
                        a.et = l.EventTypes.sharedWishlistView;
                        l.api.trackPageview(a)
                    } else
                        d("Wishlist not enabled")
                }
            };
            var l = this;
            this.evtLayer.addEventListener(this.JSEvents.initIntegrations, function() {
                e = l.retailerSettings.Widget;
                f = l.retailerSettings.Templates;
                l.retailerSettings.Widget.Enabled && 0 < e.Defs.length && l.evtLayer.addEventListener(l.JSEvents.renderUI, function() {
                    l.ui.loadSecondaryStyles();
                    l.widget.init()
                })
            })
        }
    });
    var da;
    window.SwymViewProducts || (window.SwymViewProducts = {});
    window.SwymWatchProducts || (window.SwymWatchProducts = {});
    window.SwymProductVariants || (window.SwymProductVariants = {});
    var N, L, ra, Pa = !1, eb = !1, t, v, V = !1, Ra = !1, pa, ea, K, w;
    h.prototype.injectSwymButtonOnProductGrid = SwymUtils.debounce(function() {
        if (K) {
            var a = f.retailerSettings.Wishlist.ProductGridButton;
            if (a) {
                var b = f.getApp("Wishlist")
                  , c = f.getApp("ShoppingAssistant")
                  , d = a.Enabled;
                if (b && b.enabled && d || c && c.enabled && d) {
                    var e = a.attachButtonSelector
                      , c = K.productTileSelector
                      , g = a.iconType;
                    SwymUtils.forEachElement(c, function(a) {
                        if (!a.querySelector('[data-swaction="addToWishlist"]')) {
                            var b = "swym-button swym-add-to-wishlist-view-product";
                            "heart" !== g && (b = b + " custom-grid-icon-" + g);
                            b = SwymUtils.createElement('<button class="' + b + '" data-swaction="addToWishlist" onclick="event.preventDefault(); event.stopPropagation();" aria-label="' + w.WishlistAddCTA + '"></button>');
                            (a = e ? a.querySelector(e) : null) && a.insertAdjacentElement("afterend", b)
                        }
                    });
                    f.initializeActionButtonsOnProductGrid(c)
                }
            }
            var h = f.retailerSettings.Watchlist.ProductGridButton;
            h && (a = f.getApp("Watchlist"),
            c = f.getApp("ShoppingAssistant"),
            b = h.Enabled,
            a && a.enabled && b || c && c.enabled && b) && (e = h.attachButtonSelector,
            c = K.productTileSelector,
            SwymUtils.forEachElement(c, function(a) {
                var b = a.querySelector('[data-swaction="addToWatchlist"]')
                  , c = h.soldOutPatternSelector.selector
                  , c = c ? a.querySelector(c) : null
                  , d = h.soldOutPatternSelector.keyword
                  , f = !1;
                c && c.innerText === d && (f = !0);
                !b && f && (b = h.ButtonType || "icon",
                c = '<button class="swym-button swym-add-to-watchlist-view-product swym-grid-watchlist-btn" data-swaction="addToWatchlist" onclick="event.preventDefault(); event.stopPropagation();" aria-label="' + w.WatchlistAddCTA + '">',
                d = h.ButtonText ? h.ButtonText : w.WatchlistAddCTA,
                b = "icon" === b ? SwymUtils.createElement(c + "</button>") : "icontext" === b ? SwymUtils.createElement('<div class="swym-grid-watchlist-btn-wrapper">' + c + '<span class="swym-grid-watchlist-text" onclick="event.preventDefault(); event.stopPropagation();">' + d + "</span></button></div>") : SwymUtils.createElement('<span class="swym-button-bar swym-add-to-watchlist-view-product swym-grid-watchlist-textbtn" data-swaction="addToWatchlist" onclick="event.preventDefault(); event.stopPropagation();" aria-label="' + w.WatchlistAddCTA + '">' + d + "</span>"),
                (a = e ? a.querySelector(e) : null) && a.insertAdjacentElement("afterend", b))
            }),
            f.initializeActionButtonsOnProductGrid(c))
        }
    }, 500);
    h.prototype.injectHeaderLaunchpointOnHeaderLazily = SwymUtils.debounce(function(a) {
        try {
            a = f.retailerSettings.Wishlist.headerConfig;
            var b = "wishlistheader.debug" === SwymUtils.getParameterByName("swaction") ? !0 : !1;
            if (a) {
                var c = f.getApp("Wishlist")
                  , d = f.getApp("ShoppingAssistant");
                if (c && c.enabled || d && d.enabled) {
                    var e = a.desktop
                      , g = a.mobile;
                    !e.Enabled && !b || SwymUtils.isElementAvailable("#swym-inject-header") || (0 < e.attachButtonSelector.length ? SwymUtils.isElementAvailable(e.attachButtonSelector) ? Na(e, !1) : SwymUtils.warn("Invalid desktop header element selector, adjacent element not found") : SwymUtils.warn("Desktop header enabled, but attachSelector is empty"));
                    !g.Enabled && !b || SwymUtils.isElementAvailable("#swym-inject-header-mobile") || (0 < g.attachButtonSelector.length ? SwymUtils.isElementAvailable(g.attachButtonSelector) ? Na(g, !0) : SwymUtils.warn("Invalid mobile header element selector, adjacent element not found") : SwymUtils.warn("Mobile header enabled, but attachSelector is empty"))
                }
            }
        } catch (h) {
            SwymUtils.error("Error - Wishlist header Injection failed, Re-evaluate the config", h)
        }
    }, 500);
    h.prototype.createWishlistButton = function(a, b, c) {
        var d = SwymViewProducts[a]
          , e = SwymUtils.createElement("<button class='swym-button swym-add-to-wishlist-view-product " + (c || "") + " swym-" + (t.ButtonType || "") + " swym-" + (t.ButtonIcon || "") + "' data-swaction='addToWishlist' data-product-id='' aria-label='" + w.WishlistAddCTA + "'></button>");
        return d ? (e.setAttribute("data-product-id", d.empi),
        d._cv = !0,
        d.vi = S(d),
        P(d),
        f.reportPageview(d),
        b.forEach(function(a) {
            var b = e.cloneNode(!0);
            a && document.querySelector(a).insertAdjacentElement("beforeend", b);
            z("addToWishList", f.EventTypes.addToWishList, b, d)
        }),
        !0) : !1
    }
    ;
    var Lb = {
        addToCart: ["addToCart", "add_to_cart"],
        soldOut: ["soldOut", "sold_out"]
    };
    window.theme && window.theme.strings && (h.prototype.getThemeString = function(a) {
        var b = "";
        try {
            var c = Lb[a];
            if (c)
                for (var d = window.theme.strings; 0 < c.length; c++) {
                    var e = d[c[0]];
                    if (e) {
                        b = e;
                        break
                    }
                }
        } catch (f) {}
        return b
    }
    );
    h.prototype.variantChanged = function(a, b) {
        ja(a, b)
    }
    ;
    h.prototype.mapShopifyProducts = function(a) {
        a.forEach(function(a) {
            window.SwymViewProducts[a.handle] = window.SwymViewProducts[a.id] = ka(a);
            window.SwymWatchProducts[a.handle] = window.SwymWatchProducts[a.id] = ha(a)
        })
    }
    ;
    h.prototype.initializeActionButtons = function(a, b) {
        this.ui.loadSecondaryStyles();
        var c = a ? document.querySelector(a) : null;
        if (c) {
            if (t && t.Enabled) {
                for (var d = c.querySelectorAll(b || "[data-swaction]:not([data-with-epi])"), e = 0, f = d.length; e < f; e++)
                    fa(d[e]);
                d = c.querySelectorAll(b || "[data-swaction][data-with-epi]");
                e = 0;
                for (f = d.length; e < f; e++)
                    Qa(d[e])
            }
            if (v && v.Enabled)
                for (d = c.querySelectorAll(b || "[data-swaction]"),
                e = 0,
                f = d.length; e < f; e++)
                    qa(d[e])
        }
    }
    ;
    h.prototype.initializeActionButtonsOnProductGrid = function(a) {
        this.ui.loadSecondaryStyles();
        t && t.Enabled && a && SwymUtils.forEachElement(a, ya);
        v && v.Enabled && a && SwymUtils.forEachElement(a, Db)
    }
    ;
    var Va = "backinstock"
      , Gb = ["cart", "swym-session-id", "swym-swymRegid", "swym-email"]
      , $a = 0;
    window.initSwymShopify = function(a) {
        if (a || !eb) {
            eb = !0;
            a = f.getSwymRegistrationId();
            f.getSwymHostUri();
            var b = window.SwymPageData || {
                et: f.EventTypes.unknownView
            };
            P(b);
            var c = b.ct;
            c && 200 < c.length && (b.ct = c.substr(0, 200).trim());
            window.SwymProductInfo && window.SwymProductInfo.variants && window.SwymProductInfo.currentVariant && (c = window.SwymProductInfo.variants.filter(function(a) {
                return a.id == window.SwymProductInfo.currentVariant
            }),
            0 < c.length && (b.available = c[0].available));
            f.api.trackPageview(b);
            f.evtLayer.addEventListener(f.JSEvents.regidRefreshed, function(a) {
                O()
            });
            f.evtLayer.addEventListener(f.JSEvents.variantChanged, function(a) {
                f.api.trackPageview({
                    et: 1,
                    epi: a.detail.d.variant.id,
                    empi: a.detail.d.product.id,
                    available: a.detail.d.variant.available,
                    pr: a.detail.d.product.price / 100
                })
            });
            sb();
            tb();
            rb();
            a ? (Pa ? f.initializeUi(function() {
                Oa(b)
            }) : Oa(b),
            SwymUtils.isBot() || O()) : (f.holdCallbacks(),
            f.evtLayer.addEventListener(h.JSEvents.registered, function e() {
                O(!0);
                za(!0);
                oa(b);
                f.evtLayer.removeEventListener(h.JSEvents.registered, e)
            }))
        }
    }
    ;
    window.history && (history.pushState = function(a) {
        return function() {
            var b = a.apply(this, arguments);
            window.dispatchEvent(new SwCustomEvent("swym:pushState"));
            window.dispatchEvent(new SwCustomEvent("swym:locationchange"));
            return b
        }
    }(history.pushState),
    history.replaceState = function(a) {
        return function() {
            var b = a.apply(this, arguments);
            window.dispatchEvent(new SwCustomEvent("swym:replaceState"));
            window.dispatchEvent(new SwCustomEvent("swym:locationchange"));
            return b
        }
    }(history.replaceState),
    window.addEventListener("popstate", function() {
        window.dispatchEvent(new SwCustomEvent("swym:locationchange"))
    }),
    window.SwymCallbacks = window.SwymCallbacks || [],
    SwymCallbacks.push(function() {
        window.addEventListener("swym:locationchange", function(a) {
            a = f.getApp("Watchlist") ? SwymWatchProducts : SwymProductVariants;
            var b = SwymUtils.getParameterByName("variant");
            b && a[b] && L != b && f.platform.checkVariantChange()
        })
    }));
    var Aa;
    window.triggerSwymVariantEvent = function(a) {
        try {
            var b = SwymWatchProducts[a] || ha(ra)[a];
            a != L && b && (L = a,
            f.triggerSwymEvent(f.JSEvents.variantChanged, {
                currentVariantId: L,
                product: ra,
                variant: b
            }))
        } catch (c) {}
    }
    ;
    swymModules.push({
        id: "shopify",
        events: {
            variantChanged: "sw:variantchanged"
        },
        init: function() {
            f = this;
            this.platform = {
                type: "Shopify",
                productDetailsCfg: {
                    hashFn: function(a) {
                        return a["raw-du"] || a.du
                    },
                    preloadHashFn: function(a, b) {
                        return b
                    },
                    internalFn: function(a, b, c) {
                        SwymUtils.ajaxGET(f.platform.getProductUrl(a.params["raw-du"] || a.params.du) + ".js", function(a) {
                            try {
                                var e = JSON.parse(a.responseText);
                                b(e)
                            } catch (f) {
                                SwymUtils.error("Error getProductDetails .js", f),
                                c(f, a)
                            }
                        })
                    }
                },
                isInDeviceCart: function(a) {
                    return !!this.getCartItemForVariantId(a)
                },
                getCartItemForVariantId: function(a) {
                    for (var b = SwymUtils.arrayFlat(window.swymCart.items), c, d = 0; d < b.length; d++)
                        b[d].id == a && (c = b[d]);
                    return c
                },
                refreshCustomerStatus: function(a) {
                    f.getSwymRegistrationId() && za(!0, a)
                },
                getProductUrl: function(a) {
                    var b = SwymUtils.updateToCurrentDomain(a.replace(/http:|https:/, location.protocol).split("?")[0]);
                    if (a = window.SwymOverrideSubFolder || window.Shopify.routes && window.Shopify.routes.root)
                        var c = SwymUtils.getURLAsLocation(b)
                          , b = b.split("/products/")[1]
                          , b = c.origin + a + "products/" + b;
                    return b
                },
                getBaseEpiMultiVariantProduct: function(a, b) {
                    b(SwymViewProducts[a].epi)
                },
                checkVariantChange: function() {
                    ua()
                },
                isAdminMode: function() {
                    try {
                        if (document.getElementById("admin_bar_iframe")) {
                            var a = function() {
                                SwymUtils.addClass(b, "swym-shopify-admin");
                                SwymUtils.addClass(document.body, "swym-shopify-admin")
                            }
                              , b = document.getElementById("swym-plugin");
                            b ? a() : f.evtLayer.addEventListener(f.JSEvents.renderRelayUI, function() {
                                b = document.getElementById("swym-plugin");
                                a()
                            });
                            return !0
                        }
                    } catch (c) {}
                    return !1
                },
                isInventorySetUpCorrectly: function(a) {
                    return a.inventory_management && ("deny" == a.inventory_policy || f.retailerSettings.Watchlist.ShowIfPolicyAllow && "continue" == a.inventory_policy || SwymUtils.isUndefined(a.inventory_policy))
                },
                isEpiOOS: function(a) {
                    var b = !1;
                    SwymPageData.et == f.EventTypes.productView ? b = f.platform.isVariantInProductOutOfStock(a, window.SwymProductInfo.product) : (a = window.SwymWatchProducts[a]) && (b = f.platform.isVariantOOS(a));
                    return b
                },
                transformCartItem: Eb,
                isVariantOOS: function(a) {
                    var b = !1;
                    SwymUtils.isUndefined(a.available) ? SwymUtils.isUndefined(a.inventory_quantity) || SwymUtils.isUndefined(a.inventory_policy) ? SwymUtils.warn("Swym snippet needs migration since available variable as well as inventory_quantity inventory_policy variables not set.") : "deny" == a.inventory_policy ? b = 1 > a.inventory_quantity : f.retailerSettings.Watchlist.ShowIfPolicyAllow && "continue" == a.inventory_policy && (b = 1 > a.inventory_quantity) : SwymUtils.isUndefined(a.inventory_policy) || "deny" == a.inventory_policy ? b = !a.available : f.retailerSettings.Watchlist.ShowIfPolicyAllow && "continue" == a.inventory_policy && (b = 1 > a.inventory_quantity);
                    return b
                },
                getOOSVariantsForProduct: function(a) {
                    a = [];
                    window.SwymProductInfo && window.SwymProductInfo.variants && window.SwymProductInfo.product && (a = window.SwymProductInfo.variants);
                    return a.filter(function(a) {
                        return !a.available
                    }).map(function(a) {
                        return a.id
                    })
                },
                isVariantInProductOutOfStock: function(a, b) {
                    var c = ha(b)[a];
                    return c ? f.platform.isInventorySetUpCorrectly(c) && f.platform.isVariantOOS(c) : !1
                },
                getInterfacePath: Ib,
                getDuFromVariantUri: function(a) {
                    return a.split("?")[0]
                },
                getCurrentCartId: function() {
                    try {
                        var a = window.swymCart && window.swymCart.token || decodeURIComponent(f.storage.getRaw("cart")) || null;
                        return "string" == typeof a ? a.split("?")[0] : null
                    } catch (b) {
                        return null
                    }
                },
                addToCart: function(a) {
                    var b = a.epi
                      , c = a.callback
                      , d = a.errorCallback;
                    a.du = a.product.du;
                    var e = a.product.qty || 1;
                    f.api.getProductDetails(a, function(a) {
                        try {
                            for (var h = 0; h < a.variants.length; h++) {
                                var l = a.variants[h];
                                if (l.id == b) {
                                    f.platform.isVariantOOS(l) ? d("Variant is in stock") : SwymUtils.ajaxOpt({
                                        url: location.protocol + "//" + location.host + "/cart/add.js",
                                        data: JSON.stringify({
                                            items: [{
                                                id: b,
                                                quantity: e
                                            }]
                                        }),
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json"
                                        },
                                        callback: function(a) {
                                            if (200 == a.status)
                                                f.triggerSwymEvent(f.JSEvents.UIAddedToCart, {
                                                    productData: l,
                                                    quantity: e
                                                }),
                                                setTimeout(function() {
                                                    window.CartJS && window.CartJS.getCart()
                                                }),
                                                c && c(a.responseText);
                                            else {
                                                var b = JSON.parse(a.responseText);
                                                d(b, a)
                                            }
                                        }
                                    });
                                    break
                                }
                            }
                        } catch (m) {
                            d && d(m),
                            SwymUtils.log("Error loading product for addToCart", m, {
                                epi: b
                            })
                        }
                    })
                },
                redirectToCartPage: function() {
                    window.location = f.retailerSettings.General.CartPath || location.protocol + "//" + location.host + "/cart"
                },
                redirectToContinueShopping: function() {
                    window.location = f.retailerSettings.General.ContinueShoppingPath || "/"
                },
                isProductInCart: function(a) {
                    return !!this.getCartItemForVariantId(a.epi) && a.et == f.EventTypes.addToCart
                },
                getVariantUrlFromDu: function(a, b) {
                    var c = this.getProductUrl(a);
                    if (!b)
                        return c;
                    -1 == c.indexOf("?") ? c += "?variant=" + b : -1 === c.indexOf("variant=") && (c += "&variant=" + b);
                    return c
                },
                getVariantString: function(a) {
                    var b = "";
                    a.vval1 && "Default Title" != a.vval1 && (b += a.vval1);
                    a.vval2 && "Default Title" != a.vval2 && (b += " / " + a.vval2);
                    a.vval3 && "Default Title" != a.vval3 && (b += " / " + a.vval3);
                    return b
                },
                isLoggedIn: function() {
                    return !!window.swymCustomerId
                },
                redirectToLoginPage: function() {
                    window.location = f.retailerSettings.General.LoginPath || "/account/login"
                },
                redirectToLogoutPage: function() {
                    window.location = f.retailerSettings.General.LogoutPath || "/account/logout"
                },
                addAllToCart: function(a, b, c) {
                    var d = {
                        items: []
                    };
                    a.forEach(function(a, b) {
                        d.items.push({
                            quantity: a.qty || 1,
                            id: a.epi
                        })
                    });
                    SwymUtils.ajaxOpt({
                        url: "/cart/add.js",
                        method: "POST",
                        data: JSON.stringify(d),
                        headers: {
                            "Content-Type": "application/json"
                        },
                        callback: function(a) {
                            try {
                                if (setTimeout(function() {
                                    window.CartJS && window.CartJS.getCart()
                                }),
                                200 == a.status) {
                                    var d = JSON.parse(a.responseText);
                                    f.triggerSwymEvent(f.JSEvents.UIAddedAllToCart, {
                                        productData: d
                                    });
                                    b(d, a)
                                } else
                                    d = JSON.parse(a.responseText),
                                    c(d, a)
                            } catch (h) {
                                c(h.msg, a, h)
                            }
                        }
                    })
                },
                transformRawProduct: function(a) {
                    a.dt || (a.dt = a.title);
                    a.pr || (a.pr = a.price / 100,
                    a.price = a.pr);
                    !a.op && a.compare_at_price && (a.op = a.compare_at_price / 100,
                    a.compare_at_price = a.compare_at_price);
                    a.variants.forEach(function(b) {
                        b.pr || (b.pr = b.price / 100,
                        b.price = b.pr);
                        !b.op && b.compare_at_price && (b.op = b.compare_at_price / 100,
                        b.compare_at_price = b.op);
                        b.featured_image && (b.featured_image = b.featured_image.src || b.featured_image);
                        b.swymAllowAddToCart = !this.isVariantOOS(b, a);
                        var c = this.getCartItemForVariantId(b.id);
                        b.swymIsAddedToCart = !!c;
                        if (b.cartLineItem = c)
                            b.swymCartItem = this.transformCartItem(c, window.swymCart)
                    }, this);
                    return a
                },
                removeFromCart: function(a, b) {
                    var c = {};
                    a.map(function(a) {
                        c[a.rawData.key] = 0
                    });
                    SwymUtils.ajaxOpt({
                        url: "/cart/update.js",
                        method: "POST",
                        cache: "no-cache",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json"
                        },
                        data: JSON.stringify({
                            updates: c
                        }),
                        callback: function(c) {
                            try {
                                if (200 == c.status) {
                                    f.triggerSwymEvent(f.JSEvents.UIRemovedFromCart, {
                                        productsData: a
                                    });
                                    var e = JSON.parse(c.responseText);
                                    b(e, c)
                                } else
                                    e = JSON.parse(c.responseText),
                                    fcb(e, c)
                            } catch (g) {
                                fcb(g.msg, c, g)
                            }
                        }
                    })
                },
                removeProductTileOnCartPage: function(a, b, c, d) {
                    try {
                        SwymUtils.removeClosestElem(a, c),
                        B.platform.updateCartSubTotalPrice(b.items_subtotal_price, d)
                    } catch (e) {
                        SwymUtils.error("Invalid removeProductTileOnCartPage call", e)
                    }
                },
                updateCartSubTotalPrice: function(a, b) {
                    var c = document.querySelector(b).innerText;
                    document.querySelector(b).innerText = c.replace(/[\d,]+(\.\d+)?/, parseFloat(parseFloat(a / 100).toFixed(2)).toLocaleString(null != Shopify.locale && null != Shopify.country ? Shopify.locale + "-" + Shopify.country : ""))
                },
                formatMoney: Wa,
                currentMoneyFormat: function() {
                    return f.retailerSettings.General.UseMoneyFormat && (window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : window.SwymOverrideMoneyFormat ? window.SwymOverrideMoneyFormat : f.retailerSettings.General.MoneyFormat)
                },
                getUserCartData: function() {
                    return fetch("/cart.js").then(function(a) {
                        return a.json()
                    }).then(function(a) {
                        var b = a.items.map(function(b) {
                            b.cartId = a.token;
                            return b
                        });
                        a.items = b;
                        return a
                    }).catch(function(a) {
                        return SwymUtils.error("GET CART ERROR", a)
                    })
                },
                isTagAvailable: function(a, b) {
                    var c = !1;
                    b && b.tags && b.tags.forEach(function(b) {
                        -1 < (a || []).indexOf(b) && (c = !0)
                    });
                    return c
                }
            };
            f.evtLayer.addEventListener(f.JSEvents.readRetailerConfig, function(a) {
                f.platform.refreshCustomerStatus()
            });
            f.evtLayer.addEventListener(f.JSEvents.UIAddedToCart, function(a) {
                ab()
            });
            f.evtLayer.addEventListener(f.JSEvents.UIAddedAllToCart, function(a) {
                ab()
            })
        }
    });
    h.prototype.createWorker = function(a, b, c) {
        if (0 < this.appsCache.length) {
            if (window.Worker) {
                this.webworkerSupported = !0;
                this.workers = this.workers || {};
                this.handlers = this.handlers || {};
                var d = a.subject;
                if (!this.workers[d]) {
                    var e = this;
                    this.workers[d] = new Worker("/apps/swym" + this.appsCache[0].app + "/scripts/swym-ww.js");
                    this.workers[d].onmessage = function(a) {
                        a = JSON.parse(a.data);
                        var b = a.subject
                          , c = a.result
                          , d = a.id;
                        c.error ? e.handlers[d].error(c, b) : e.handlers[d].receive(c, b);
                        a.keepalive || delete e.handlers[d]
                    }
                }
                var f = a.subject + Date.now();
                this.handlers[f] = {
                    receive: b,
                    error: c
                };
                a.source = "swym";
                a.id = f;
                this.workers[d].postMessage(a)
            } else
                this.webworkerSupported = !1,
                console.log("Sorry, worker not supported");
            return this.webworkerSupported
        }
        return !1
    }
    ;
    swymModules.push({
        id: "shopify-worker-helper",
        init: function() {
            var a = this;
            a.evtLayer.addEventListener(a.JSEvents.configLoaded, function() {
                if (!a.retailerSettings.General.DisablePrefetchWorkers) {
                    var b = function() {
                        clearTimeout(f);
                        return setTimeout(function() {
                            f = b()
                        }, 3E5)
                    }
                      , c = function(b) {
                        var c = a.platform.productDetails.mcache || {};
                        b = b.map(function(b) {
                            return a.platform.getProductUrl(b)
                        }).filter(function(a) {
                            return !(a in c)
                        }).filter(d);
                        SwymUtils.arrayPartition(b, 3).forEach(function(b) {
                            a.createWorker({
                                subject: "prefetch-jsons",
                                payload: b
                            }, function(b) {
                                if (b.r) {
                                    var c = {};
                                    c[b.l] = b.r;
                                    a.platform.productDetails.cacheLoadScb({}, c)
                                }
                            }, function(a) {
                                console.log("error", arguments)
                            })
                        })
                    }
                      , d = function(a) {
                        var b = !(a in e);
                        e[a] = !0;
                        return b
                    };
                    a.evtLayer.addEventListener(a.JSEvents.fetchNewsfeed, function(a) {
                        b()
                    });
                    a.evtLayer.addEventListener(a.JSEvents.fetchProducts, function(a) {
                        a = a.detail.d.map(function(a) {
                            return a.du
                        });
                        100 > a.length && (c(a),
                        b())
                    });
                    var e = {};
                    a.evtLayer.addEventListener(a.JSEvents.fetchProducts, function(b) {
                        b = b.detail.d.map(function(a) {
                            return a.iu
                        }).filter(d);
                        100 > b.length && SwymUtils.arrayPartition(b, 3).forEach(function(b) {
                            a.createWorker({
                                subject: "prefetch-imgs",
                                payload: b
                            }, function() {}, function() {
                                console.log("error", arguments)
                            })
                        })
                    });
                    var f
                }
            })
        }
    });
    var B = new h;
    window._swat = B;
    window._swat._swrt = window._swrt;
    window.SwymTracker = h
}();
